{
  "dataViewer": {
    "inferredBadge": "추론됨",
    "inferredBadgeTooltip": "온톨로지 추론(RDFS)으로 도출된 분류입니다",
    "restrictedBadge": "권한 제한",
    "restrictedBadgeTooltip": "보안 정책에 따라 이 필드를 볼 수 있는 권한이 없습니다",
    "empty": {
      "classRestricted": "보안 정책에 따라 이 클래스의 데이터를 볼 수 있는 권한이 없습니다"
    },
    "inferredCountChip": "+{{count}} 추론"
  },
  "instantBi": {
    "anchor": {
      "linkTooltip": "클릭하면 이 항목을 즉석 BI 차트로 봅니다",
      "narrativeEmpty": "서술 없음",
      "viewNarrative": "서술 보기",
      "viewAsChart": "차트로 보기",
      "badgeCertified": "인증됨",
      "badgeKept": "보관됨",
      "narrativeLoading": "서술 불러오는 중…",
      "narrativeError": "서술을 불러오지 못했습니다"
    },
    "combination": {
      "title": "관련 인사이트 모음",
      "subtitle": "이 질문과 관련된 인증 모듈을 함께 보여줍니다",
      "empty": "이 질문에 맞는 인증 모듈이 없습니다",
      "cellEmpty": "데이터 없음"
    },
    "badge": {
      "certified": "조직 인증 모듈",
      "keptUnverified": "AI 생성 — 검증 전"
    },
    "action": {
      "keep": "보관",
      "promote": "리포트로 승격"
    },
    "provenance": {
      "freshness": "신선도"
    }
  },
  "toolCallTrace": {
    "unknownTool": "도구 호출",
    "error": "오류",
    "errorDetail": "오류",
    "argsRedacted": "인자 마스킹됨",
    "objectSet": "오브젝트 집합",
    "sourceRefs": "소스 참조",
    "graphRefs": "그래프 참조",
    "policyDecision": "정책 결정",
    "resultSummary": "결과 요약"
  },
  "loopEvidence": {
    "title": "루프 증거",
    "generatedAt": "{{value}} 생성됨",
    "actions": {
      "viewAllMetrics": "전체 지표 보기"
    },
    "errors": {
      "continuationLoadFailed": "루프 연속 실행 원장을 불러오지 못했습니다",
      "dashboardLoadFailed": "루프 증거 대시보드를 불러오지 못했습니다"
    },
    "kpi": {
      "completedRuns": "AI 지원 실행: {{value}}",
      "graphWrites": "포착된 패턴: {{value}}",
      "capturedObjects": "업무 레코드: {{value}}",
      "linkedWidgets": "연결된 위젯: {{value}}",
      "staleSources": "오래된 소스: {{value}}",
      "staleAlerts": "오래된 알림: {{value}}",
      "viewAllTooltip": "전체 지표 보기"
    },
    "tabs": {
      "aria": "루프 증거 섹션",
      "persona": "업무 역할 사이클",
      "workflowRuns": "워크플로 실행",
      "reports": "리포트",
      "packFreshness": "데이터 신선도"
    },
    "metrics": {
      "drawerTitle": "전체 루프 증거 지표",
      "drawerDescription": "이 프로젝트의 모든 루프 증거 지표입니다.",
      "completedRuns": "완료된 실행",
      "loopSummaries": "루프 요약",
      "graphWrites": "포착된 패턴",
      "capturedObjects": "업무 레코드",
      "linkedWidgets": "연결된 위젯",
      "metricEvents": "지표 이벤트",
      "staleAlerts": "오래된 알림",
      "staleSources": "오래된 소스",
      "warningSources": "검토 필요 소스"
    },
    "columns": {
      "pack": "팩",
      "status": "상태",
      "reports": "리포트",
      "stale": "오래됨",
      "sources": "소스",
      "latestSync": "최근 동기화",
      "workflowEvidence": "워크플로 증거",
      "ontologyEvidence": "온톨로지 증거",
      "namedGraph": "명명된 그래프",
      "reportOutput": "리포트 출력"
    },
    "packFreshness": {
      "title": "데이터 신선도",
      "aria": "데이터 신선도",
      "empty": "데이터 신선도 기록이 없습니다."
    },
    "persona": {
      "title": "페르소나 시나리오 증거",
      "description": "팩 워크플로, 온톨로지 캡처, 명명된 그래프, 리포트 출력을 한곳에서 확인합니다.",
      "aria": "페르소나 시나리오 증거",
      "packEvidence": "팩 증거: {{name}} ({{packId}})",
      "reportSource": "리포트 소스 {{source}}",
      "freshness": "신선도 {{status}}",
      "packWorkflowEvidence": "팩 워크플로 증거",
      "runStatus": "실행 {{runId}} · 상태 {{status}}",
      "packReportLinked": "팩 리포트 연결됨",
      "reportSummary": "위젯 {{widgets}} · 리포트 {{reportId}}"
    },
    "freshness": {
      "projectTitle": "파이프라인 신선도 {{status}} (임계값 {{hours}}시간)",
      "projectSummary": "데이터 소스 {{total}}개 중 오래됨 {{stale}} / 경고 {{warning}}. 최근 동기화 {{latestSync}}.",
      "reasons": "사유: {{value}}",
      "noStaleReasons": "보고된 만료 사유 없음",
      "staleCount": "오래됨 {{count}}건"
    },
    "status": {
      "unknown": "알 수 없음",
      "linked": "연결됨"
    },
    "continuations": {
      "title": "2차 사이클 연속 실행",
      "aria": "2차 사이클 연속 실행 증거",
      "empty": "2차 사이클 연속 실행이 없습니다.",
      "columns": {
        "parent": "상위 리포트/오브젝트",
        "rule": "연속 실행 규칙",
        "childWorkflow": "하위 워크플로",
        "childGraphRefs": "하위 그래프 참조",
        "refreshedReportRefs": "갱신된 리포트 참조"
      },
      "injectionChain": "1차 {{first}} → {{step}} 에 {{count}}행 주입 → 2차 {{second}}"
    },
    "workflowRuns": {
      "title": "최근 워크플로 실행",
      "aria": "최근 워크플로 루프 증거",
      "empty": "루프 실행이 없습니다.",
      "metric": "지표",
      "openWorkflowRun": "워크플로 실행 열기",
      "openNamedGraph": "명명된 그래프 열기",
      "columns": {
        "workflow": "워크플로",
        "graph": "그래프",
        "ontology": "온톨로지",
        "lineage": "리니지",
        "report": "리포트"
      }
    },
    "reports": {
      "title": "리포트",
      "aria": "리포트 루프 증거",
      "empty": "루프에 연결된 리포트가 없습니다.",
      "pack": "팩: {{packId}}",
      "latestSync": "동기화: {{value}}",
      "openReportObject": "리포트 오브젝트 열기",
      "openReportGraph": "리포트 그래프 열기",
      "columns": {
        "report": "리포트",
        "freshness": "신선도",
        "widgets": "위젯",
        "workflowRuns": "워크플로 실행",
        "namedGraphs": "명명된 그래프",
        "objects": "오브젝트"
      }
    }
  },
  "readyMadePackUpgrade": {
    "title": "{{count}}개의 Ready Made Pack에 업그레이드가 있습니다.",
    "viewNow": "지금 보기",
    "dismiss": "나중에",
    "upgradeAction": "업그레이드",
    "versionLabel": "{{current}} → {{latest}}"
  },
  "getStarted": {
    "banner": {
      "title": "처음이라면 이렇게 시작하세요",
      "subtitle": "두 가지 진입점 중 하나를 선택하여 워크플로 + 온톨로지 + 리포트 루프를 시작합니다.",
      "readyMadePacksTitle": "Ready Made Packs로 시작",
      "readyMadePacksDesc": "검증된 템플릿(워크플로 + 온톨로지 + 리포트)을 한 번에 설치합니다.",
      "readyMadePacksCta": "시작하기",
      "designerTitle": "Designer로 직접 만들기",
      "designerDesc": "워크플로와 온톨로지를 처음부터 직접 설계합니다.",
      "designerCta": "직접 만들기",
      "dismiss": "다음에 보기"
    }
  },
  "common": {
    "open": "열기",
    "save": "저장",
    "cancel": "취소",
    "delete": "삭제",
    "edit": "수정",
    "add": "추가",
    "create": "생성",
    "search": "검색",
    "filter": "필터",
    "export": "내보내기",
    "import": "가져오기",
    "close": "닫기",
    "ok": "확인",
    "yes": "예",
    "no": "아니오",
    "loading": "로딩 중...",
    "comingSoon": "준비중입니다",
    "selectProject": "프로젝트를 먼저 선택해주세요",
    "error": "오류",
    "success": "성공",
    "warning": "경고",
    "info": "정보",
    "required": "필수",
    "optional": "선택",
    "refresh": "새로고침",
    "copy": "복사",
    "all": "전체",
    "actions": "작업"
  },
  "nav": {
    "home": "홈",
    "ontology": "온톨로지 관리",
    "schemaCanvas": "스키마 관리",
    "layerManagement": "레이어 관리",
    "classTypeManagement": "클래스 타입 관리",
    "relationshipManagement": "관계명 관리",
    "dataPropertyManagement": "데이터 속성 관리",
    "dataConnectionManagement": "데이터 커넥션 관리",
    "data": "데이터 관리",
    "dataCanvas": "데이터캔버스",
    "datasetManagement": "데이터셋 관리",
    "dataQuery": "데이터 조회",
    "shaclValidation": "SHACL 검증",
    "analysis": "데이터 분석"
  },
  "sidebar": {
    "connections": "커넥션",
    "connectionsSubtitle": "통합 커넥터 레지스트리 (39종)",
    "agentConsole": "에이전트 콘솔",
    "approvalInbox": "승인 대기함",
    "projectManagement": "프로젝트 관리",
    "projectList": "프로젝트 목록",
    "basicInfo": "기본정보",
    "accessControl": "접근 권한 관리",
    "startCatalog": "시작하기",
    "globalSettings": "글로벌 설정 관리",
    "globalAccessControl": "글로벌 접근 권한 관리",
    "globalRelationManagement": "글로벌 관계명 관리",
    "globalDataPropertyManagement": "글로벌 데이터 속성 관리",
    "schemaManagement": "스키마 관리",
    "schemaCanvas": "스키마캔버스",
    "layerManagement": "레이어 관리",
    "relationManagement": "관계 관리",
    "dataManagement": "데이터 관리",
    "dataHub": "데이터 허브",
    "dataCanvas": "데이터 캔버스",
    "dataSources": "데이터 소스",
    "dataViewer": "데이터 조회",
    "datasetManagement": "데이터셋 관리",
    "dataUpload": "데이터 업로드",
    "dataQuery": "데이터 조회",
    "conversionStats": "변환 통계",
    "sparqlQuery": "SPARQL 쿼리",
    "predefinedQuery": "미리 정의된 쿼리",
    "conditionalSearch": "조건부 검색",
    "customSparql": "사용자 정의 SPARQL",
    "autoInsight": "AI 인사이트",
    "insightDashboard": "인사이트 대시보드",
    "biDesigner": "BI 대시보드",
    "aiDesigner": "AI 디자이너",
    "llmAnalysis": "AI 분석 채팅",
    "dataExplorer": "데이터 탐색기",
    "advancedAnalytics": "고급 분석",
    "reportGenerator": "자동 리포트 생성",
    "dataAnalysis": "데이터 분석",
    "inferOpsAgent": "InferOps Agent",
    "biReportBuilder": "BI 리포트 빌더",
    "dashboard": "대시보드",
    "reportLibrary": "리포트 라이브러리",
    "reportBuilder": "리포트 빌더",
    "sparqlSources": "SPARQL 데이터 소스",
    "aiChat": "AI 채팅",
    "ragManagement": "RAG 관리",
    "aiBuild": "AI 빌드",
    "readyMadePacks": "레디메이드 팩",
    "useCases": "Use Cases",
    "onboarding": "시작 가이드",
    "closedLoopWalkthrough": "Closed-Loop 여정",
    "loopEvidence": "루프 증거",
    "policyAuthoring": "정책 정의",
    "unifiedDesigner": "Unified Designer",
    "unifiedDesignerSubtitle": "Workflow + Ontology 한 화면 편집",
    "aiBuildSubtitle": "AI가 골격을 자동 생성",
    "policyAuthoringSubtitle": "Decision Table 루프 룰",
    "dataSourcesSubtitle": "외부 데이터 카탈로그",
    "dbConnectorSubtitle": "DB 연결",
    "integrationConsole": "통합 콘솔",
    "integrationConsoleSubtitle": "외부 시스템 통합",
    "sparqlSourcesSubtitle": "SPARQL 엔드포인트",
    "ragManagementSubtitle": "RAG 지식 베이스",
    "objectsRelations": "객체와 관계",
    "streamingBackfill": "스트리밍 & 백필",
    "lineage": "리니지",
    "sections": {
      "reportBuilder": "리포트 구성",
      "reportViewer": "리포트 조회",
      "aiInsights": "AI 인사이트",
      "inferOpsAgent": "InferOps 에이전트",
      "designer": "디자이너",
      "designerBuild": "빌드",
      "designerConnect": "연결",
      "designerAutomate": "자동화 룰",
      "operate": "운영",
      "autoInsight": "Auto Insight",
      "dataOverview": "개요",
      "dataInstances": "인스턴스 작업",
      "dataFlow": "흐름 추적"
    },
    "agentDashboard": "에이전트 대시보드",
    "agentTasks": "에이전트 태스크",
    "settings": "설정",
    "llmSettings": "LLM 설정",
    "auditLog": "감사 로그",
    "exportOntologyItem": "온톨로지 내보내기",
    "simulation": "What-if 시뮬레이션",
    "anomalyDetection": "이상 탐지",
    "versionHistory": "버전 관리",
    "dbConnector": "외부 DB 커넥터",
    "workflows": "워크플로우",
    "dataLineage": "데이터 리니지",
    "streamingMonitor": "실시간 스트리밍"
  },
  "dashboard": {
    "title": "대시보드",
    "description": "저장된 리포트를 대시보드 형태로 조회합니다",
    "widgets": {
      "totalRevenue": "총 매출",
      "costReduction": "비용 절감",
      "efficiency": "효율성",
      "activeProjects": "활성 프로젝트"
    },
    "vsLastMonth": "전월 대비",
    "actions": {
      "filter": "필터",
      "refresh": "새로고침",
      "fullscreen": "전체화면"
    },
    "empty": {
      "title": "저장된 리포트가 없습니다",
      "description": "BI 리포트 빌더에서 리포트를 생성하고 저장하세요",
      "goToBuilder": "리포트 빌더로 이동"
    }
  },
  "reportLibrary": {
    "title": "리포트 라이브러리",
    "description": "저장된 리포트를 관리합니다",
    "copy": "(복사본)",
    "search": {
      "placeholder": "리포트 검색..."
    },
    "labels": {
      "updated": "수정",
      "noDescription": "설명 없음",
      "widgetCount": "{{count}}개 위젯"
    },
    "actions": {
      "view": "보기"
    },
    "menu": {
      "view": "보기",
      "edit": "편집",
      "duplicate": "복제",
      "share": "공유",
      "delete": "삭제"
    },
    "empty": {
      "noResults": "검색 결과가 없습니다",
      "noReports": "저장된 리포트가 없습니다",
      "noResultsDesc": "다른 검색어로 시도해보세요",
      "noReportsDesc": "리포트 빌더에서 새 리포트를 만들어주세요"
    },
    "errors": {
      "loadFailed": "리포트 목록을 불러오는데 실패했습니다",
      "noProject": "프로젝트가 선택되지 않았습니다. 프로젝트를 먼저 선택해주세요.",
      "duplicateFailed": "리포트 복제에 실패했습니다",
      "deleteFailed": "리포트 삭제에 실패했습니다"
    },
    "messages": {
      "duplicated": "리포트가 복제되었습니다",
      "deleted": "리포트가 삭제되었습니다"
    },
    "confirm": {
      "delete": "\"{{name}}\" 리포트를 삭제하시겠습니까?"
    },
    "queryDialog": {
      "title": "조회 조건 선택",
      "description": "리포트를 열기 전에 조회할 데이터 범위를 선택하세요.",
      "confirm": "리포트 열기",
      "rangeFrom": "시작",
      "rangeTo": "끝",
      "inPlaceholder": "값을 입력하고 Enter"
    },
    "tabs": {
      "all": "전체",
      "scheduled": "예약",
      "packs": "패키지",
      "generated": "워크플로 생성"
    },
    "generated": {
      "title": "워크플로 생성 리포트",
      "empty": "워크플로 실행으로 생성된 리포트가 없습니다",
      "col": {
        "title": "제목",
        "template": "템플릿",
        "format": "형식",
        "size": "크기",
        "createdAt": "생성 시각",
        "workflowRun": "워크플로 실행",
        "actions": "다운로드"
      },
      "actions": {
        "download": "리포트 다운로드"
      }
    },
    "allTab": {
      "packHint": "아직 생성된 리포트는 없습니다. 설치된 패키지 리포트 {{count}}개는 '패키지' 탭에서 확인할 수 있습니다."
    }
  },
  "reportBuilder": {
    "title": "리포트 빌더",
    "newReport": "새 리포트",
    "toolbar": {
      "new": "새로 만들기",
      "open": "열기",
      "save": "저장",
      "saving": "저장 중...",
      "undo": "실행 취소",
      "undoShortcut": "실행 취소 (Ctrl+Z)",
      "redo": "다시 실행",
      "redoShortcut": "다시 실행 (Ctrl+Y)",
      "modified": "수정됨",
      "templates": "템플릿",
      "queryBuilder": "쿼리 빌더"
    },
    "dialogs": {
      "saveTitle": "리포트 저장",
      "openTitle": "리포트 열기",
      "reportName": "리포트 이름",
      "reportNamePlaceholder": "예: 월간 비용 분석",
      "description": "설명 (선택)",
      "descriptionPlaceholder": "리포트에 대한 간단한 설명",
      "noSavedReports": "저장된 리포트가 없습니다.",
      "widgetCount": "{{count}}개 위젯",
      "cancel": "취소",
      "close": "닫기"
    },
    "notifications": {
      "reportOpened": "\"{{name}}\" 리포트를 열었습니다.",
      "reportCreated": "리포트가 생성되었습니다.",
      "reportSaved": "리포트가 저장되었습니다.",
      "saveFailed": "저장에 실패했습니다.",
      "loadFailed": "리포트를 불러오는데 실패했습니다.",
      "newReportStarted": "새 리포트를 시작합니다.",
      "unsavedChanges": "저장하지 않은 변경사항이 있습니다. 계속하시겠습니까?",
      "enterReportName": "리포트 이름을 입력해주세요.",
      "projectNotSelected": "프로젝트가 선택되지 않았습니다. 프로젝트를 먼저 선택해주세요.",
      "templateApplied": "템플릿이 적용되었습니다."
    },
    "configPanel": {
      "title": "위젯 설정"
    },
    "canvas": {
      "loading": "로딩 중..."
    },
    "chart": {
      "dataLoadFailed": "데이터를 불러오는데 실패했습니다",
      "noChartConfig": "차트 설정이 없습니다",
      "unsupportedChartType": "지원하지 않는 차트 타입: {{type}}",
      "total": "합계",
      "value": "값",
      "data": "데이터",
      "increase": "증가",
      "decrease": "감소",
      "legend": {
        "increase": "증가",
        "decrease": "감소",
        "total": "합계"
      }
    }
  },
  "widgetPalette": {
    "title": "위젯 추가",
    "categories": {
      "bar": "막대 차트",
      "lineArea": "선/영역 차트",
      "pie": "원형 차트",
      "special": "특수 차트",
      "data": "데이터 표시",
      "cost": "비용 분석",
      "analytics": "분석 위젯",
      "other": "기타"
    }
  },
  "costWidget": {
    "waterfall": {
      "title": "원가 워터폴"
    },
    "treemap": {
      "title": "원가 트리맵"
    },
    "breakdown": {
      "title": "원가 분해도",
      "category": "분류",
      "amount": "금액"
    },
    "drilldown": {
      "title": "원가 드릴다운",
      "total": "총 원가",
      "cost": "원가",
      "ratio": "비율"
    },
    "momComparison": {
      "title": "월별 원가 비교",
      "periodA": "기간 A",
      "periodB": "기간 B",
      "change": "변동",
      "byResourceType": "자원 유형별 비교",
      "topDrivers": "상위 변화 요인",
      "resource": "자원",
      "delta": "변동액",
      "contribution": "기여도",
      "trend": "기간 추이",
      "totalCost": "총 원가"
    }
  },
  "widgetConfig": {
    "selectWidget": "위젯을 선택해주세요",
    "widgetType": "위젯 타입",
    "dataSource": "데이터 소스",
    "objectQuerySource": "온톨로지 조회 (Object Query)",
    "objectQuerySourceHelp": "프로젝트 온톨로지의 클래스 인스턴스를 조회합니다.",
    "objectClass": "클래스 (비즈니스 레코드)",
    "objectClassHelp": "차트에 표시할 데이터의 클래스를 선택하세요. 선택하면 X/Y축 필드 목록이 채워집니다.",
    "objectClassLoadError": "클래스 목록 로드 실패: {{error}}",
    "loading": "로딩 중...",
    "aggregation": "집계 방식",
    "aggregationTypes": {
      "sum": "합계",
      "avg": "평균",
      "count": "개수",
      "min": "최소값",
      "max": "최대값"
    },
    "chartSettings": "차트 설정",
    "chartTitle": "차트 제목",
    "xAxisField": "X축 필드",
    "selectXAxisFields": "X축 필드 선택...",
    "multipleXAxisHint": "여러 필드 선택 시 결합되어 표시됨",
    "yAxisField": "Y축 필드",
    "noColumns": "컬럼 없음",
    "noNumericColumns": "숫자형 컬럼 없음",
    "selectDataSource": "데이터 소스를 선택하세요",
    "stackField": "스택 필드 (선택)",
    "none": "없음",
    "tableSettings": "테이블 설정",
    "tableTitle": "테이블 제목",
    "kpiSettings": "KPI 설정",
    "metricName": "지표 이름",
    "displayFormat": "표시 형식",
    "formatTypes": {
      "number": "숫자",
      "currency": "통화 (원)",
      "percent": "퍼센트"
    },
    "targetValue": "목표값 (선택)",
    "targetValueHelper": "설정 시 진행률 표시",
    "aiChatSettings": "AI 채팅 설정",
    "contextWidgets": "컨텍스트 위젯",
    "contextWidgetsHelper": "AI가 참조할 다른 위젯 선택",
    "suggestedQuestions": "추천 질문 (줄바꿈으로 구분)",
    "suggestedQuestionsHelper": "사용자가 빠르게 선택할 수 있는 질문",
    "textSettings": "텍스트 설정",
    "content": "내용",
    "format": "형식",
    "textFormats": {
      "plain": "일반 텍스트",
      "markdown": "마크다운",
      "html": "HTML"
    },
    "imageSettings": "이미지 설정",
    "imageUrl": "이미지 URL",
    "imageUrlHelper": "또는 위젯에서 직접 업로드",
    "altText": "대체 텍스트",
    "fit": "맞춤",
    "fitOptions": {
      "contain": "비율 유지 (contain)",
      "cover": "채우기 (cover)",
      "fill": "늘리기 (fill)"
    },
    "chartStyle": {
      "title": "차트 스타일",
      "titleFontSize": "제목 글꼴 크기",
      "showDataLabels": "데이터 라벨 표시",
      "showStackTotal": "총합계 표시",
      "labelFontSize": "라벨 글꼴 크기",
      "labelFormat": "라벨 형식",
      "labelFormats": {
        "value": "값",
        "percent": "퍼센트",
        "both": "값 + 퍼센트"
      },
      "axisFontSize": "축 글꼴 크기",
      "showGrid": "보조선 표시",
      "gridStyle": "보조선 스타일",
      "gridStyles": {
        "solid": "실선",
        "dashed": "점선",
        "dotted": "점점선"
      },
      "barSettings": "막대 차트 설정",
      "barCategoryGap": "카테고리 간격 (%)",
      "barGap": "막대 간격 (px)",
      "barRadius": "모서리 둥글기",
      "legendFontSize": "범례 글꼴 크기",
      "legendPosition": "범례 위치",
      "legendPositions": {
        "top": "상단",
        "bottom": "하단",
        "left": "좌측",
        "right": "우측"
      },
      "colorSettings": "색상 설정",
      "paletteGroup": "색상 테마 선택",
      "primaryColor": "주 색상",
      "colorPalette": "시리즈 색상 (개별 조정)",
      "gridColor": "보조선 색상",
      "resetColors": "기본값으로 초기화"
    },
    "comboAxis": {
      "title": "콤보 차트 시리즈 설정",
      "loadDataFirst": "데이터를 먼저 로드하면 시리즈 목록이 표시됩니다.",
      "seriesSettings": "시리즈별 축/차트유형/스타일 설정",
      "axis": "축",
      "primaryAxis": "주축 (왼쪽)",
      "secondaryAxis": "보조축 (오른쪽)",
      "chartType": "차트 유형",
      "chartTypeBar": "막대",
      "chartTypeLine": "선",
      "chartTypeArea": "영역",
      "lineStyle": "선 스타일",
      "lineSmooth": "부드러운 곡선",
      "lineLinear": "직선",
      "color": "색상",
      "axisLabels": "축 라벨 및 단위",
      "primaryAxisLabel": "주축 라벨",
      "primaryAxisPlaceholder": "예: 비용 (원)",
      "primaryAxisUnit": "주축 단위",
      "secondaryAxisLabel": "보조축 라벨",
      "secondaryAxisPlaceholder": "예: 수량 (개)",
      "secondaryAxisUnit": "보조축 단위",
      "unitPlaceholder": "예: 원"
    }
  },
  "globalFilter": {
    "title": "글로벌 조회/필터",
    "filterOnly": "필터",
    "noFiltersApplied": "적용된 필터가 없습니다",
    "field": "필드",
    "filterField": "필터 필드",
    "filterFieldHint": "뷰어에서 드롭다운으로 선택 가능",
    "condition": "조건",
    "operator": "연산자",
    "value": "값",
    "from": "시작",
    "to": "끝",
    "defaultValue": "기본값",
    "defaultValuePlaceholder": "리포트 진입 시 기본값",
    "commaSeparated": "쉼표로 구분된 값",
    "commaSeparatedOptional": "쉼표로 구분 (선택사항)",
    "optionalDefault": "기본값 (선택사항)",
    "optional": "선택",
    "queryValueHint": "진입 시 사용자가 변경 가능",
    "all": "전체",
    "loadingFilterValues": "필터 값 로딩 중...",
    "noValuesAvailable": "사용 가능한 값 없음",
    "queryTab": "조회",
    "filterTab": "필터",
    "queryDescription": "조회 조건: 리포트 진입 전 데이터 범위를 선택합니다. 사용자가 리포트 진입 시 값을 변경할 수 있습니다.",
    "filterDescription": "필터 조건: 필터로 사용할 필드를 지정합니다. 리포트 뷰어에서 드롭다운으로 값을 선택할 수 있습니다.",
    "noQueries": "설정된 조회 조건이 없습니다",
    "noFilters": "설정된 필터가 없습니다",
    "addQuery": "조회 조건 추가",
    "addFilter": "필터 추가",
    "apply": "적용",
    "clearQueries": "조회 조건 초기화",
    "clearFilters": "필터 초기화",
    "activeSummary": "적용된 조건:",
    "operators": {
      "eq": "같음",
      "ne": "같지 않음",
      "gt": "보다 큼",
      "lt": "보다 작음",
      "gte": "이상",
      "lte": "이하",
      "contains": "포함",
      "in": "다중 선택",
      "range": "범위"
    }
  },
  "dragDropCanvas": {
    "confirmDelete": "위젯을 삭제하시겠습니까?",
    "emptyState": {
      "title": "위젯을 추가해주세요",
      "description": "왼쪽 팔레트에서 위젯을 클릭하여 추가할 수 있습니다"
    }
  },
  "inferOpsAgent": {
    "title": "InferOps Agent",
    "description": "workflow, action, approval, retry 상태를 한 화면에서 관리하는 운영 콘솔",
    "alpha": "알파",
    "tasks": {
      "anomalyDetection": "이상 탐지",
      "patternAnalysis": "패턴 분석",
      "trendPrediction": "트렌드 예측",
      "correlationDiscovery": "상관관계 발견"
    },
    "kinds": {
      "workflow": "워크플로우",
      "action": "액션",
      "approval": "승인"
    },
    "status": {
      "running": "실행 중",
      "completed": "완료",
      "scheduled": "예약됨"
    },
    "stats": {
      "activeTasks": "활성 작업",
      "insightsFound": "발견된 인사이트",
      "analysisRuns": "분석 실행 횟수",
      "successRate": "성공률",
      "activeRuns": "활성 실행",
      "waitingApprovals": "대기 승인",
      "failedExecutions": "실패 실행",
      "completedRecently": "최근 완료"
    },
    "sections": {
      "tools": "도구 레지스트리",
      "approvals": "승인함",
      "activeRuns": "현재 실행 상태",
      "failures": "오류 / 재시도",
      "timeline": "실행 타임라인",
      "actionRequired": "조치 필요"
    },
    "empty": {
      "tools": "사용 가능한 tool이 없습니다.",
      "approvals": "대기 중인 approval이 없습니다.",
      "activeRuns": "현재 실행 중인 workflow/action이 없습니다.",
      "failures": "실패한 실행이 없습니다.",
      "timeline": "표시할 execution 이력이 없습니다."
    },
    "messages": {
      "decisionSaved": "결정이 저장되었습니다.",
      "retryQueued": "재시도가 등록되었습니다.",
      "workflowStarted": "워크플로우 실행이 시작되었습니다.",
      "actionExecuted": "액션 실행이 등록되었습니다."
    },
    "actions": {
      "executeTool": "실행",
      "startWorkflow": "워크플로우 시작",
      "executeAction": "액션 실행"
    },
    "labels": {
      "requiresApproval": "approval 필요",
      "contextualAction": "이 tool은 object context를 받아 실행됩니다.",
      "manualWorkflow": "이 workflow는 여기서 직접 실행할 수 있습니다.",
      "executionDenied": "현재 principal로 실행할 수 없습니다.",
      "workflowRunHint": "payload는 run context, source refs는 lineage/approval context로 저장됩니다."
    },
    "form": {
      "targetObjectType": "대상 객체 타입",
      "targetObjectId": "대상 객체 ID",
      "requestedStartAt": "요청 시작 시각",
      "payload": "Payload JSON",
      "sourceRefs": "소스 참조 JSON"
    },
    "taskList": "에이전트 작업 목록",
    "lastRun": "마지막 실행",
    "nextRun": "다음 실행",
    "insightsDiscovered": "인사이트 발견",
    "retry": "재시도"
  },
  "schemaCanvas": {
    "title": "스키마캔버스",
    "tabs": {
      "schemaDesign": "스키마 설계",
      "instanceViewer": "인스턴스 뷰어"
    },
    "addClass": "클래스 추가",
    "addRelationship": "관계 추가",
    "className": "클래스명",
    "classType": "클래스 타입",
    "selectClassType": "클래스 타입 선택",
    "description": "설명",
    "properties": "속성",
    "dataProperties": "데이터 속성",
    "relationships": "관계",
    "directProperties": "직접 정의된 속성",
    "inheritedProperties": "상속된 속성",
    "addProperty": "속성 추가",
    "propertyName": "속성명",
    "propertyType": "속성 타입",
    "saveSchema": "스키마 저장",
    "saveNeeded": "저장 필요",
    "saveComplete": "저장 완료!",
    "saving": "저장 중...",
    "save": "저장",
    "download": "다운로드",
    "upload": "업로드",
    "refresh": "새로고침",
    "deleteClass": "클래스 삭제",
    "deleteRelationship": "관계 삭제",
    "selectSourceClass": "시작 클래스 선택",
    "selectTargetClass": "대상 클래스 선택",
    "selectRelationType": "관계 타입 선택",
    "relationshipType": "관계 타입",
    "sourceClass": "시작 클래스",
    "targetClass": "대상 클래스",
    "undo": "실행 취소",
    "redo": "다시 실행",
    "alignLeft": "왼쪽 정렬",
    "alignRight": "오른쪽 정렬",
    "alignTop": "위쪽 정렬",
    "alignBottom": "아래쪽 정렬",
    "deleteSelected": "선택된 항목 삭제",
    "clearSelection": "선택 해제",
    "zoomIn": "확대",
    "zoomOut": "축소",
    "fitView": "전체 보기",
    "exportSchema": "스키마 내보내기",
    "importSchema": "스키마 가져오기"
  },
  "classTypes": {
    "title": "클래스 타입 관리",
    "name": "타입명",
    "color": "색상",
    "icon": "아이콘",
    "addType": "타입 추가",
    "editType": "타입 수정",
    "deleteType": "타입 삭제",
    "activity": "활동",
    "resource": "자원",
    "product": "제품",
    "cost": "비용",
    "confirmDelete": "이 클래스 타입을 삭제하시겠습니까?"
  },
  "relationships": {
    "title": "관계명 관리",
    "name": "관계명",
    "description": "설명",
    "usageCount": "사용 횟수",
    "addRelationship": "관계 추가",
    "editRelationship": "관계 수정",
    "deleteRelationship": "관계 삭제",
    "confirmDelete": "이 관계를 삭제하시겠습니까?",
    "produces": "생산한다",
    "uses": "사용한다",
    "requires": "필요로한다",
    "contains": "포함한다",
    "dependsOn": "의존한다",
    "partOf": "부분이다"
  },
  "dataProperties": {
    "title": "데이터 속성 관리",
    "name": "속성명",
    "dataType": "데이터 타입",
    "description": "설명",
    "scope": "범위",
    "global": "전역",
    "project": "프로젝트",
    "addProperty": "속성 추가",
    "editProperty": "속성 수정",
    "deleteProperty": "속성 삭제",
    "confirmDelete": "이 데이터 속성을 삭제하시겠습니까?",
    "string": "문자열",
    "number": "숫자",
    "boolean": "논리값",
    "date": "날짜",
    "dateTime": "날짜시간"
  },
  "dialogs": {
    "classTypeSelection": {
      "title": "클래스 타입 선택",
      "description": "새로 생성할 클래스의 이름과 타입을 지정해주세요. 선택한 타입에 따라 해당하는 기본 속성들이 자동으로 할당됩니다.",
      "classNameLabel": "클래스 이름",
      "classNamePlaceholder": "예: 제품, 부품, 공정 등",
      "classNameHelper": "클래스 이름을 입력하지 않으면 기본 이름이 생성됩니다",
      "classTypeLabel": "클래스 타입",
      "propertiesCount": "개 속성",
      "defaultPropertiesInfo": "개의 기본 속성이 자동 할당됩니다",
      "confirm": "선택 완료",
      "cancel": "취소",
      "loadError": "클래스 타입을 불러오는 중 오류가 발생했습니다."
    },
    "relationshipAdd": {
      "title": "관계 추가",
      "description": "\"{{nodeName}}\" 클래스와 다른 클래스 간의 관계를 추가합니다. 관계의 방향은 현재 클래스에서 선택한 클래스로 향합니다.",
      "noTargetsWarning": "관계를 추가할 다른 클래스가 없습니다. 먼저 다른 클래스를 생성해주세요.",
      "relationTypeLabel": "관계 타입",
      "targetClassLabel": "대상 클래스",
      "usageCount": "회 사용",
      "previewTitle": "관계 미리보기",
      "confirm": "관계 추가",
      "cancel": "취소"
    },
    "createProject": {
      "title": "새 프로젝트",
      "nameLabel": "프로젝트 이름",
      "descriptionLabel": "설명",
      "create": "생성",
      "cancel": "취소",
      "emptyProject": "빈 프로젝트",
      "fromSample": "샘플에서 시작",
      "sampleDescription": "샘플 프로젝트를 선택하여 새 프로젝트를 생성합니다. 스키마와 데이터가 함께 복제됩니다.",
      "noSamples": "사용 가능한 샘플 프로젝트가 없습니다.",
      "newProjectInfo": "새 프로젝트 정보",
      "createFromSample": "샘플에서 생성"
    },
    "projectInfo": {
      "title": "프로젝트 기본정보",
      "nameLabel": "프로젝트 이름",
      "descriptionLabel": "프로젝트 설명",
      "descriptionPlaceholder": "프로젝트에 대한 간단한 설명을 입력하세요.",
      "setAsDefault": "기본 프로젝트로 설정",
      "defaultHelper": "기본 프로젝트로 설정하면 홈페이지 접속 시 자동으로 선택됩니다.",
      "projectInfoTitle": "프로젝트 정보",
      "createdAt": "생성일",
      "updatedAt": "수정일",
      "owner": "소유자",
      "memberCount": "멤버 수",
      "memberCountUnit": "명",
      "nameRequired": "프로젝트 이름을 입력해주세요.",
      "save": "저장",
      "cancel": "취소"
    },
    "accessControl": {
      "title": "접근 권한 관리",
      "description": "프로젝트에 접근할 수 있는 사용자들의 권한을 관리합니다.",
      "roleDescriptionTitle": "권한 설명",
      "newMemberTitle": "새 멤버 추가",
      "emailLabel": "이메일 주소",
      "emailPlaceholder": "user@example.com",
      "roleLabel": "역할",
      "roleAdmin": "관리자",
      "roleEditor": "편집자",
      "roleViewer": "뷰어",
      "addButton": "추가",
      "memberListTitle": "프로젝트 멤버",
      "memberCountUnit": "명",
      "addedAt": "추가일",
      "addedBy": "추가자",
      "removeConfirm": " 사용자의 접근 권한을 제거하시겠습니까?",
      "noMembers": "등록된 멤버가 없습니다.",
      "noPermission": "멤버를 관리하려면 소유자 또는 관리자 권한이 필요합니다.",
      "close": "닫기"
    },
    "shareProject": {
      "title": "프로젝트 공유",
      "emailLabel": "이메일 주소",
      "roleLabel": "권한",
      "roleViewer": "읽기 전용",
      "roleEditor": "편집 가능",
      "roleAdmin": "관리자",
      "share": "공유",
      "cancel": "취소"
    },
    "dataPropertySelection": {
      "title": "데이터 속성 선택",
      "tabSelect": "기존 속성 선택",
      "tabAdd": "신규 속성 추가",
      "searchPlaceholder": "속성 검색...",
      "multipleInfo": "여러 속성을 선택할 수 있습니다",
      "noProperties": "등록된 데이터 속성이 없습니다",
      "noPropertiesHint": "신규 속성 추가 탭에서 새로운 속성을 만들어주세요",
      "propertyLabel": "속성 레이블",
      "propertyPlaceholder": "예: 단가, 수량, 크기",
      "propertyHelper": "데이터 속성의 이름",
      "descriptionLabel": "설명",
      "descriptionPlaceholder": "이 속성에 대한 설명 (선택사항)",
      "dataTypeLabel": "데이터 타입",
      "usageCount": "회 사용",
      "autoSelectInfo": "새로운 데이터 속성이 생성되면 자동으로 선택됩니다.",
      "selectButton": "선택",
      "selectWithCount": "선택 ({count})",
      "addAndSelectButton": "추가 및 선택",
      "cancel": "취소",
      "loadError": "속성 목록을 불러올 수 없습니다",
      "labelRequired": "속성 레이블을 입력해주세요",
      "addError": "속성 추가 실패",
      "unknownError": "알 수 없는 오류"
    },
    "objectPropertySelection": {
      "title": "객체 속성 선택",
      "tabSelect": "기존 속성 선택",
      "tabAdd": "신규 속성 추가",
      "searchPlaceholder": "속성 검색...",
      "noProperties": "등록된 객체 속성이 없습니다",
      "noPropertiesHint": "신규 속성 추가 탭에서 새로운 속성을 만들어주세요",
      "propertyLabel": "속성 레이블",
      "propertyPlaceholder": "예: 생산한다, 사용한다",
      "propertyHelper": "객체 간의 관계를 나타내는 이름",
      "descriptionLabel": "설명",
      "descriptionPlaceholder": "이 속성에 대한 설명 (선택사항)",
      "usageCount": "회 사용",
      "autoSelectInfo": "새로운 객체 속성이 생성되면 자동으로 선택됩니다.",
      "selectButton": "선택",
      "addAndSelectButton": "추가 및 선택",
      "cancel": "취소",
      "loadError": "속성 목록을 불러올 수 없습니다",
      "labelRequired": "속성 레이블을 입력해주세요",
      "addError": "속성 추가 실패",
      "unknownError": "알 수 없는 오류"
    },
    "dataSourceConfig": {
      "title": "데이터 소스 설정",
      "step0": "소스 타입",
      "step1": "CSV 업로드",
      "step2": "컬럼 매핑",
      "step3": "확인",
      "sourceTypeTitle": "데이터 소스 타입을 선택하세요",
      "csvUploadOption": "CSV 파일 업로드",
      "csvUploadDesc": "로컬 CSV 파일을 업로드하여 데이터를 수집합니다",
      "connectionOption": "외부 데이터 연결 (준비 중)",
      "connectionDesc": "데이터베이스, API 등 외부 소스와 연결합니다",
      "csvUploadTitle": "CSV 파일 업로드",
      "csvSelectPrompt": "CSV 파일을 선택하세요",
      "fileSelectButton": "파일 선택",
      "selectedFile": "선택된 파일",
      "csvOnlyError": "CSV 파일만 업로드 가능합니다",
      "previewTitle": "미리보기 (총 {total}행 중 처음 10행)",
      "columnMappingTitle": "컬럼 매핑 설정",
      "columnMappingDesc": "CSV 컬럼을 클래스 속성에 매핑하세요. 필수 속성은 반드시 매핑해야 합니다.",
      "required": "필수",
      "noMapping": "매핑 안함",
      "typeLabel": "타입",
      "mappingErrorTitle": "매핑 오류:",
      "confirmationTitle": "설정 확인",
      "classLabel": "클래스",
      "sourceTypeLabel": "소스 타입",
      "csvFileType": "CSV 파일",
      "fileNameLabel": "파일명",
      "totalRowsLabel": "총 행 수",
      "rowsUnit": "행",
      "mappedColumnsLabel": "매핑된 컬럼",
      "columnsUnit": "개",
      "columnMappingsTitle": "컬럼 매핑:",
      "propertyColumn": "속성",
      "csvColumnLabel": "CSV 컬럼",
      "cancel": "취소",
      "previous": "이전",
      "next": "다음",
      "uploadAndNext": "업로드 및 다음",
      "uploading": "업로드 중...",
      "save": "저장",
      "saving": "저장 중...",
      "uploadError": "CSV 업로드 실패",
      "saveError": "데이터 소스 저장 실패",
      "validationError": "검증 중 오류 발생",
      "validationFailed": "검증 실패",
      "connectionNotImplemented": "외부 연결 기능은 추후 구현 예정입니다"
    }
  },
  "dataCanvas": {
    "title": "데이터캔버스",
    "selectProjectGuide": "데이터 캔버스를 사용하려면 프로젝트를 선택해주세요.",
    "addInstance": "인스턴스 추가",
    "instanceName": "인스턴스명",
    "instanceClass": "클래스",
    "selectClass": "클래스 선택",
    "propertyValues": "속성 값",
    "saveInstance": "인스턴스 저장",
    "deleteInstance": "인스턴스 삭제",
    "collectionCanvas": "데이터 수집 캔버스",
    "refresh": "새로고침",
    "noClassTypes": "클래스 타입이 없습니다",
    "createClassFirst": "먼저 스키마 캔버스에서 클래스를 생성해주세요",
    "messages": {
      "detailsComingSoon": "상세 보기 기능은 다음 단계에서 구현됩니다",
      "setDataSourceFirst": "먼저 데이터 소스를 설정해주세요",
      "selectProjectFirst": "프로젝트를 선택해주세요",
      "collectionStarting": "데이터 수집을 시작합니다...",
      "collectionComplete": "수집 완료: {{processedRows}}개 행 처리, {{createdInstances}}개 인스턴스 생성",
      "collectionFailed": "데이터 수집 실패",
      "collectionFailedWithError": "수집 실패: {{error}}",
      "networkError": "네트워크 오류",
      "dataRefreshed": "데이터를 새로고침했습니다",
      "dataSourceConfigured": "데이터 소스가 성공적으로 설정되었습니다",
      "syncConfirmTitle": "동기화 실행 확인",
      "syncConfirmMessage": "데이터 소스를 동기화하시겠습니까? 기존 데이터가 최신 상태로 업데이트됩니다.",
      "syncConfirmExecute": "동기화 실행"
    },
    "classCard": {
      "dataSourceConfigured": "데이터 소스 설정됨",
      "dataStatus": "데이터 현황",
      "total": "총",
      "items": "건",
      "today": "오늘",
      "lastCollection": "최근 수집",
      "none": "없음",
      "justNow": "방금 전",
      "minutesAgo": "{minutes}분 전",
      "hoursAgo": "{hours}시간 전",
      "daysAgo": "{days}일 전",
      "tooltips": {
        "configureDataSource": "데이터 소스 설정",
        "viewDetails": "상세 보기",
        "manualCollection": "수동 수집",
        "configureFirst": "데이터 소스 먼저 설정"
      }
    }
  },
  "languageSelector": {
    "tooltip": "언어 선택 / Language / 言語"
  },
  "helpMenu": {
    "about": "정보",
    "close": "닫기",
    "infergraphInfo": "ℹ️ Infergraph 정보",
    "systemDescription": "AI가 설계하고, workflow가 실행하고, ontology가 기억하고, report가 설명하며, 그 결과가 다음 자동화로 다시 연결되는 업무 자동화 플랫폼.",
    "versionInfo": "버전 정보",
    "versionDetails": "• 버전: 1.0.0",
    "keyFeatures": "주요 기능",
    "featuresList": "• <b>AI Build</b> — 자연어 intent 한 줄로 workflow · ontology · report · pack 4-surface proposal 생성<br/>• <b>Designer</b> — Unified Designer (Workflow Canvas + Ontology Graph) + Decision Table policy authoring<br/>• <b>Operate</b> — Agent Console · Loop Evidence · 승인 inbox 로 실행과 거버넌스 통합<br/>• <b>Data</b> — workflow 실행 결과를 ABox 인스턴스 · lineage · streaming 으로 기억<br/>• <b>Auto Insight</b> — BI Report · AI Chat · Anomaly Detection 결과를 설명하며, 그 결과는 다음 자동화 입력으로 자동 연결됩니다.",
    "techStack": "기술 스택",
    "techStackDetails": "• Frontend: React + TypeScript + Material-UI + ReactFlow<br/>• Backend: FastAPI + Python<br/>• Knowledge: PostgreSQL + Apache Jena Fuseki (RDF/OWL · SPARQL)<br/>• AI: LLM 통합 (OpenAI · Claude · Gemini) · Scikit-Learn · SHAP"
  },
  "navigation": {
    "projectManagement": "프로젝트 관리",
    "schemaManagement": "스키마 관리",
    "dataManagement": "데이터 관리",
    "sparqlQuery": "SPARQL 쿼리",
    "autoInsight": "Auto Insight"
  },
  "validationPanel": {
    "title": "SHACL 데이터 검증",
    "description": "SHACL 규칙을 정의하고 온톨로지 데이터의 무결성을 검증합니다.",
    "tabs": {
      "rules": "SHACL 규칙",
      "results": "검증 결과",
      "templates": "규칙 템플릿"
    },
    "rulesCount": "SHACL 규칙 ({{count}}개)",
    "activeRules": "활성화된 규칙: {{count}}개",
    "runValidation": "검증 실행",
    "addRule": "규칙 추가",
    "targetClass": "대상 클래스",
    "allClasses": "전체",
    "noRules": "정의된 SHACL 규칙이 없습니다. \"규칙 추가\" 버튼을 클릭하거나 \"규칙 템플릿\" 탭에서 프리셋을 사용하세요.",
    "templates": {
      "costAllocationSum": {
        "name": "비용 배분 합계 검증",
        "description": "총비용과 배분비용 합계가 일치하는지 검증",
        "errorMessage": "총비용과 배분비용 합계가 일치하지 않습니다"
      },
      "timeCapacityCheck": {
        "name": "시간 용량 검증",
        "description": "사용시간이 운영시간을 초과하지 않는지 검증",
        "errorMessage": "사용시간이 운영시간을 초과했습니다"
      },
      "requiredProperty": {
        "name": "필수 속성 검증",
        "description": "지정된 속성이 반드시 존재하는지 검증",
        "errorMessage": "필수 속성이 누락되었습니다: {{propertyLabel}}"
      },
      "datatypeValidation": {
        "name": "데이터 타입 검증",
        "description": "속성 값이 올바른 데이터 타입인지 검증",
        "errorMessage": "잘못된 데이터 타입입니다. 예상: {{dataTypeLabel}}"
      }
    },
    "parameters": {
      "targetClass": "대상 클래스",
      "targetProperty": "대상 속성",
      "propertyLabel": "속성 라벨",
      "dataType": "데이터 타입",
      "dataTypeLabel": "타입 라벨"
    }
  },
  "dataset": {
    "title": "데이터셋 관리",
    "uploadDataset": "데이터셋 업로드",
    "fileName": "파일명",
    "fileSize": "파일 크기",
    "uploadDate": "업로드 날짜",
    "status": "상태",
    "processing": "처리 중",
    "completed": "완료",
    "failed": "실패",
    "download": "다운로드",
    "preview": "미리보기"
  },
  "dataPreprocessing": {
    "title": "데이터 전처리",
    "sections": {
      "datasetInfo": "데이터셋 정보",
      "analysisResults": "데이터 분석 결과",
      "preprocessingTasks": "전처리 작업",
      "versionSettings": "버전 설정",
      "processingResults": "처리 결과"
    },
    "labels": {
      "fileName": "파일명",
      "fileSize": "파일 크기",
      "rowCount": "{count}행",
      "columnCount": "{count}개 컬럼",
      "uploadedAt": "업로드 시각",
      "totalRows": "총 행 수",
      "totalColumns": "총 컬럼 수",
      "missingValues": "결측치",
      "duplicateRows": "중복 행",
      "dataTypes": "데이터 타입",
      "addTask": "작업 추가",
      "operation": "작업",
      "targetColumn": "대상 컬럼",
      "parameters": "파라미터",
      "versionName": "버전명",
      "versionDescription": "버전 설명"
    },
    "operations": {
      "handle_missing": "결측치 처리",
      "remove_duplicates": "중복 제거",
      "remove_outliers": "이상치 제거",
      "normalize": "정규화",
      "standardize": "표준화",
      "encode_categorical": "범주형 인코딩",
      "convert_types": "타입 변환",
      "filter_data": "데이터 필터링"
    },
    "strategies": {
      "mean": "평균값 대체",
      "median": "중앙값 대체",
      "mode": "최빈값 대체",
      "drop_rows": "행 삭제",
      "drop_column": "컬럼 삭제",
      "forward_fill": "이전 값으로 채우기",
      "backward_fill": "다음 값으로 채우기",
      "keep_first": "첫 번째 유지",
      "keep_last": "마지막 유지",
      "remove_all": "모두 제거",
      "iqr_method": "IQR 방법",
      "zscore_method": "Z-점수 방법",
      "minmax_normalize": "Min-Max 정규화",
      "label_encoding": "레이블 인코딩",
      "onehot_encoding": "원-핫 인코딩"
    },
    "paramLabels": {
      "strategy": "전략",
      "threshold": "임계값",
      "method": "방법",
      "targetType": "대상 타입",
      "condition": "조건"
    },
    "placeholders": {
      "versionName": "예: v1.0_cleaned",
      "versionDescription": "전처리 작업에 대한 설명 입력",
      "selectOperation": "작업 선택",
      "selectColumn": "컬럼 선택",
      "selectStrategy": "전략 선택",
      "enterThreshold": "임계값 입력",
      "enterCondition": "조건 입력"
    },
    "alerts": {
      "missingValuesInfo": "결측치가 발견되었습니다. 적절한 처리 방법을 선택하세요.",
      "duplicatesInfo": "중복 행이 발견되었습니다. 제거를 권장합니다.",
      "outliersInfo": "이상치가 발견되었습니다. 데이터 분석에 영향을 줄 수 있습니다.",
      "noTasksWarning": "전처리 작업이 없습니다. 작업을 추가하세요.",
      "processingSuccess": "전처리 완료! 새 버전이 생성되었습니다.",
      "processingWarning": "일부 작업에서 경고가 발생했습니다."
    },
    "buttons": {
      "analyze": "분석",
      "addTask": "작업 추가",
      "removeTask": "작업 제거",
      "preview": "미리보기",
      "process": "전처리 실행",
      "download": "다운로드",
      "cancel": "취소",
      "apply": "적용"
    },
    "errors": {
      "analysisError": "데이터 분석 실패",
      "taskError": "작업 추가 실패",
      "processingError": "전처리 실행 실패",
      "downloadError": "다운로드 실패",
      "invalidParameters": "유효하지 않은 파라미터"
    }
  },
  "dataConnector": {
    "title": "데이터 커넥션 관리",
    "description": "외부 데이터 소스 연결 정보를 관리합니다",
    "newConnection": "새 연결",
    "refresh": "새로고침",
    "connectedSources": "연결된 데이터 소스",
    "connectionCount": "{{count}}개",
    "noConnections": "연결된 데이터 소스가 없습니다",
    "noConnectionsHint": "[새 연결] 버튼을 클릭하여 첫 연결을 생성하세요",
    "createFirstConnection": "첫 연결 생성하기",
    "lastTested": "테스트: {{date}}",
    "testConnection": "테스트"
  },
  "relationPropertyEditor": {
    "title": "엣지 속성 관리: {{relationLabel}}",
    "connectExisting": "기존 데이터 속성을 이 관계에 연결",
    "selectProperty": "데이터 속성 선택",
    "searchPlaceholder": "검색...",
    "selectedPropertyInfo": "선택된 속성 정보:",
    "label": "라벨",
    "type": "타입",
    "unit": "단위",
    "range": "범위",
    "required": "필수",
    "requiredInRelation": "이 관계에서 필수 여부",
    "requiredHint": "동일한 속성이라도 관계마다 필수/선택을 다르게 설정 가능",
    "connectProperty": "속성 연결",
    "cancel": "취소",
    "save": "저장",
    "connectedProperties": "연결된 엣지 속성",
    "propertyCount": "{{count}}개",
    "noAvailableProperties": "사용 가능한 데이터 속성이 없습니다. 먼저 \"데이터 속성 관리\"에서 데이터 속성을 생성하세요.",
    "tableHeaders": {
      "label": "라벨",
      "type": "타입",
      "unit": "단위",
      "range": "범위",
      "required": "필수",
      "actions": "작업"
    },
    "alerts": {
      "selectProperty": "데이터 속성을 선택해주세요.",
      "alreadyConnected": "이미 연결된 속성입니다.",
      "confirmRemove": "이 엣지 속성 연결을 해제하시겠습니까?"
    }
  },
  "classTypeManagement": {
    "title": "클래스 타입 관리",
    "addNewType": "새 클래스 타입 추가",
    "editType": "클래스 타입 수정",
    "deleteType": "클래스 타입 삭제",
    "manageProperties": "{{typeName}} 타입 속성 관리",
    "tableHeaders": {
      "typeName": "타입 이름",
      "description": "설명",
      "color": "색상",
      "actions": "작업"
    },
    "noTypes": "등록된 클래스 타입이 없습니다.",
    "noDescription": "설명 없음",
    "form": {
      "typeName": "타입 이름",
      "typeNameHelper": "사용자에게 표시될 타입 이름",
      "typeNameHelperNew": "타입 이름 (ID는 자동 생성됩니다)",
      "description": "설명",
      "descriptionHelper": "이 클래스 타입에 대한 설명",
      "color": "색상"
    },
    "buttons": {
      "cancel": "취소",
      "add": "추가",
      "edit": "수정",
      "delete": "삭제",
      "save": "변경사항 저장",
      "saving": "저장 중...",
      "close": "닫기",
      "resetChanges": "변경 취소",
      "manageProperties": "속성 관리"
    },
    "deleteDialog": {
      "title": "클래스 타입 삭제",
      "message": "\"{{typeName}}\" 클래스 타입을 정말 삭제하시겠습니까?",
      "warning": "이 작업은 되돌릴 수 없습니다."
    },
    "propertyDialog": {
      "title": "데이터 속성 선택",
      "hint": "체크박스를 클릭하여 이 클래스 타입에 할당할 데이터 속성을 선택하세요. 변경사항은 저장 버튼을 클릭해야 적용됩니다.",
      "tableHeaders": {
        "select": "선택",
        "propertyId": "속성 ID",
        "label": "라벨",
        "description": "설명"
      },
      "noProperties": "사용 가능한 데이터 속성이 없습니다.",
      "pendingChanges": "{{count}}개의 변경사항이 대기 중입니다.",
      "assignedProperties": "지정된 속성 {{count}}개",
      "pendingAdd": "추가 {{count}}개",
      "pendingDelete": "해제 {{count}}개",
      "pendingSaveNeeded": "저장하지 않은 변경: {{changes}}"
    },
    "messages": {
      "loadError": "클래스 타입을 불러오는 중 오류가 발생했습니다.",
      "saveSuccess": "클래스 타입이 성공적으로 저장되었습니다.",
      "updateSuccess": "클래스 타입이 성공적으로 수정되었습니다.",
      "createSuccess": "클래스 타입이 성공적으로 생성되었습니다.",
      "saveError": "클래스 타입 저장 중 오류가 발생했습니다.",
      "deleteSuccess": "클래스 타입이 성공적으로 삭제되었습니다.",
      "deleteError": "클래스 타입 삭제 중 오류가 발생했습니다.",
      "loadPropertiesError": "데이터 속성을 불러오는 중 오류가 발생했습니다.",
      "loadTypePropertiesError": "클래스 타입 속성을 불러오는 중 오류가 발생했습니다.",
      "applyPropertiesSuccess": "속성 변경사항이 성공적으로 적용되었습니다.",
      "applyPropertiesError": "속성 변경사항 적용 중 오류가 발생했습니다."
    },
    "impactTitle": "'{{name}}' 영향 범위"
  },
  "dataPropertyManagement": {
    "title": "데이터 속성 관리",
    "addNew": "새 속성 추가",
    "description": "온톨로지 클래스에서 사용할 수 있는 데이터 속성을 관리합니다.",
    "globalHint": "글로벌 속성은 모든 프로젝트에서 사용할 수 있으며 수정/삭제할 수 없습니다.",
    "dataTypes": {
      "string": "문자열",
      "number": "숫자",
      "integer": "정수",
      "boolean": "불린",
      "date": "날짜",
      "datetime": "날짜시간",
      "text": "텍스트",
      "email": "이메일"
    },
    "tableHeaders": {
      "label": "라벨",
      "description": "설명",
      "type": "타입",
      "unit": "단위",
      "actions": "작업"
    },
    "noProperties": "데이터 속성이 없습니다.",
    "global": "글로벌",
    "noDescription": "설명 없음",
    "cannotEditGlobal": "글로벌 속성은 수정할 수 없습니다",
    "cannotDeleteGlobal": "글로벌 속성은 삭제할 수 없습니다",
    "edit": "수정",
    "delete": "삭제",
    "messages": {
      "loadError": "데이터 속성을 불러오는 중 오류가 발생했습니다.",
      "requiredFields": "속성 ID와 라벨은 필수입니다.",
      "invalidPropertyId": "속성 ID는 \"dp_\"로 시작해야 합니다.",
      "updateSuccess": "데이터 속성이 성공적으로 수정되었습니다.",
      "createSuccess": "데이터 속성이 성공적으로 생성되었습니다.",
      "saveError": "데이터 속성 저장 중 오류가 발생했습니다.",
      "deleteSuccess": "데이터 속성이 성공적으로 삭제되었습니다.",
      "deleteError": "데이터 속성 삭제 중 오류가 발생했습니다."
    },
    "deleteDialog": {
      "message": "'{{label}}' 속성을 삭제할까요?"
    }
  },
  "relationManagement": {
    "title": "관계 관리",
    "description": "온톨로지 클래스 간 연결에 사용할 관계(Object Property)를 정의하고 관리합니다.",
    "addNew": "새 관계 추가",
    "edit": "관계 편집",
    "add": "새 관계 추가",
    "global": "글로벌",
    "usageCount": "사용 {{count}}회",
    "propertyCount": "속성 {{count}}개",
    "editRelationProperties": "관계 속성 스키마 편집",
    "editRelationName": "관계명 편집",
    "deleteRelationName": "관계명 삭제",
    "dialogTitleEdit": "관계 편집",
    "dialogTitleAdd": "새 관계 추가",
    "labelField": "관계명",
    "labelPlaceholder": "예: 생산한다, 사용한다, 포함한다",
    "descriptionField": "설명",
    "descriptionPlaceholder": "예: {A}가 {B}를 생산함",
    "isGlobal": "전체 프로젝트에서 사용 가능한 글로벌 관계",
    "cancel": "취소",
    "update": "수정",
    "deleteInUseWarning": "이 관계는 현재 {{count}}개의 연결에서 사용 중입니다.\n\n관계를 삭제하려면:\n1. 스키마캔버스에서 해당 관계를 사용하는 모든 연결을 먼저 삭제해주세요.\n2. 저장하시면 관계가 자동으로 목록에서 제거됩니다.",
    "confirmDelete": "\"{{label}}\" 관계를 삭제하시겠습니까?",
    "messages": {
      "labelRequired": "관계명을 입력해주세요.",
      "relationUpdated": "관계가 수정되었습니다.",
      "relationAdded": "새 관계가 추가되었습니다.",
      "relationDeleted": "관계가 삭제되었습니다.",
      "saveError": "관계 저장에 실패했습니다.",
      "deleteError": "관계 삭제에 실패했습니다.",
      "propertiesUpdated": "'{{label}}' 관계의 속성이 업데이트되었습니다 ({{deletedCount}}개 삭제, {{remainingCount}}개 유지)",
      "propertiesSaved": "'{{label}}' 관계의 속성이 저장되었습니다",
      "propertyDeleteError": "속성 삭제 실패: {{error}}",
      "propertySaveError": "속성 저장 실패: {{error}}",
      "propertyLinkError": "속성 연결에 실패했습니다: {{error}}"
    },
    "propertyEditor": {
      "connectedProperties": "연결된 속성 {{count}}개",
      "typeValue": "유형: {{value}}",
      "unitSuffix": " (단위 {{unit}})"
    }
  },
  "exportManager": {
    "title": "데이터 내보내기",
    "unavailable": "사용 불가",
    "addWatermark": "워터마크 추가",
    "watermarkText": "워터마크 텍스트",
    "includeChart": "차트 포함",
    "autoColumnWidth": "자동 열 너비 조정",
    "applyStyling": "스타일링 적용",
    "separator": "구분자",
    "includeMetadata": "메타데이터 포함",
    "highResolution": "고해상도",
    "width": "너비",
    "height": "높이",
    "fileName": "파일명 (선택사항)",
    "fileNameHelper": "비워두면 기본 파일명이 사용됩니다",
    "chips": {
      "chartIncluded": "차트 포함",
      "watermarkIncluded": "워터마크 포함",
      "highRes": "고해상도",
      "styling": "스타일링"
    }
  },
  "microservices": {
    "title": "마이크로서비스 관리",
    "serviceRegistry": "서비스 레지스트리",
    "apiGateway": "API 게이트웨이",
    "monitoring": "모니터링",
    "migration": "마이그레이션",
    "registerService": "서비스 등록",
    "addRoute": "라우트 추가",
    "loadDefaultRoutes": "기본 라우트 로드",
    "refresh": "새로고침",
    "totalServices": "총 서비스",
    "serviceTypes": "서비스 타입",
    "statusDistribution": "상태 분포",
    "serviceId": "서비스 ID",
    "serviceName": "서비스명",
    "version": "버전",
    "endpoint": "엔드포인트",
    "status": "상태",
    "lastHeartbeat": "마지막 하트비트",
    "actions": "작업",
    "totalRequests": "총 요청",
    "activeRoutes": "활성 라우트",
    "avgResponseTime": "평균 응답시간",
    "rateLimitedClients": "제한된 클라이언트",
    "pathPattern": "경로 패턴",
    "targetPath": "대상 경로",
    "methods": "메서드",
    "strategy": "전략",
    "timeout": "타임아웃",
    "authentication": "인증",
    "rateLimit": "레이트 리미트",
    "required": "필요",
    "notRequired": "불필요",
    "systemMonitoring": "시스템 모니터링",
    "performanceMetrics": "성능 메트릭",
    "securityStatus": "보안 상태",
    "migrationReadiness": "마이그레이션 준비도 분석",
    "startAnalysis": "분석 시작",
    "decompositionCandidates": "분해 후보 서비스",
    "recommendations": "권장사항",
    "readinessScore": "준비도 점수",
    "recommendedApproach": "권장 접근 방식",
    "estimatedTimeline": "예상 일정",
    "close": "닫기",
    "cancel": "취소",
    "register": "등록",
    "host": "호스트",
    "port": "포트",
    "healthCheckUrl": "헬스 체크 URL",
    "loadBalancingStrategy": "로드 밸런싱 전략",
    "roundRobin": "라운드 로빈",
    "random": "랜덤",
    "leastConnections": "최소 연결",
    "timeoutSeconds": "타임아웃(초)",
    "rateLimitPerMinute": "레이트 리미트(분당 요청수)",
    "complexity": "복잡도",
    "endpoints": "엔드포인트",
    "dependencies": "의존성",
    "migrationReadinessDescription": "현재 모놀리식 구조를 마이크로서비스로 전환하기 위한 준비 상태를 분석합니다.",
    "migrationAnalysisResult": "마이그레이션 분석 결과",
    "messages": {
      "dataLoadError": "데이터 로딩 중 오류가 발생했습니다.",
      "serviceRegistered": "서비스가 성공적으로 등록되었습니다.",
      "serviceRegisterFailed": "서비스 등록에 실패했습니다.",
      "serviceRegisterError": "서비스 등록 중 오류가 발생했습니다.",
      "routeRegistered": "라우트가 성공적으로 등록되었습니다.",
      "routeRegisterFailed": "라우트 등록에 실패했습니다.",
      "routeRegisterError": "라우트 등록 중 오류가 발생했습니다.",
      "serviceUnregistered": "서비스가 성공적으로 해제되었습니다.",
      "serviceUnregisterFailed": "서비스 해제에 실패했습니다.",
      "serviceUnregisterError": "서비스 해제 중 오류가 발생했습니다.",
      "migrationAnalysisFailed": "마이그레이션 분석에 실패했습니다.",
      "defaultRoutesLoaded": "기본 라우트가 로드되었습니다.",
      "defaultRoutesLoadFailed": "기본 라우트 로드에 실패했습니다.",
      "defaultRoutesLoadError": "기본 라우트 로드 중 오류가 발생했습니다."
    }
  },
  "interactiveAnalytics": {
    "title": "인터랙티브 분석",
    "chartType": "차트 타입",
    "timeRange": "시간 범위",
    "aggregation": "집계 방식",
    "granularity": "세부 단위",
    "addFilter": "필터 추가",
    "comparison": "비교 분석 설정",
    "export": "내보내기",
    "lineChart": "선 그래프",
    "areaChart": "영역 그래프",
    "barChart": "막대 그래프",
    "scatterPlot": "산점도",
    "pieChart": "원형 그래프",
    "last24Hours": "지난 24시간",
    "last7Days": "지난 7일",
    "last30Days": "지난 30일",
    "last90Days": "지난 90일",
    "custom": "사용자 정의",
    "sum": "합계",
    "average": "평균",
    "count": "개수",
    "minimum": "최소값",
    "maximum": "최대값",
    "hourly": "시간별",
    "daily": "일별",
    "weekly": "주별",
    "monthly": "월별",
    "total": "총합",
    "avg": "평균",
    "max": "최대값",
    "min": "최소값",
    "trend": "추세",
    "field": "필드",
    "operator": "연산자",
    "value": "값",
    "label": "라벨 (선택사항)",
    "add": "추가",
    "cancel": "취소",
    "close": "닫기",
    "equals": "같음",
    "contains": "포함",
    "greaterThan": "초과",
    "lessThan": "미만",
    "between": "범위",
    "in": "포함됨",
    "enableComparison": "비교 분석 활성화",
    "baseline": "기준선",
    "targetLine": "목표선",
    "unsupportedChartType": "지원하지 않는 차트 타입입니다."
  },
  "mlModel": {
    "title": "ML 모델 관리자",
    "newModel": "새 모델",
    "modelList": "모델 목록",
    "trainingJobs": "훈련 작업",
    "deploymentStatus": "배포 현황",
    "modelName": "모델 이름",
    "modelType": "모델 타입",
    "algorithm": "알고리즘",
    "accuracy": "정확도",
    "f1Score": "F1 점수",
    "featureCount": "특성 수",
    "precision": "정밀도",
    "recall": "재현율",
    "performanceMetrics": "성능 지표",
    "featureImportance": "특성 중요도",
    "basicInfo": "기본 정보",
    "trainingDataSize": "훈련 데이터 크기",
    "samples": "샘플",
    "usedFeatures": "사용된 특성",
    "details": "상세 정보",
    "train": "훈련",
    "deploy": "배포",
    "delete": "삭제",
    "jobId": "작업 ID",
    "model": "모델",
    "progress": "진행률",
    "startTime": "시작 시간",
    "duration": "소요 시간",
    "responseTime": "응답 시간",
    "memoryUsage": "메모리 사용량",
    "cpuUsage": "CPU 사용률",
    "deploymentTime": "배포 일시",
    "modelDetails": "모델 상세 정보",
    "createNewModel": "새 모델 생성",
    "downloadModel": "모델 다운로드",
    "create": "생성",
    "cancel": "취소",
    "close": "닫기",
    "modelTypes": {
      "prediction": "예측",
      "anomaly": "이상 탐지",
      "clustering": "클러스터링",
      "classification": "분류",
      "regression": "회귀",
      "forecasting": "예측"
    },
    "algorithms": {
      "randomForest": "Random Forest",
      "svm": "Support Vector Machine",
      "neuralNetwork": "Neural Network",
      "gradientBoosting": "Gradient Boosting",
      "linearRegression": "Linear Regression",
      "logisticRegression": "Logistic Regression"
    },
    "messages": {
      "modelLoadFailed": "모델 로드 실패: {{error}}",
      "modelLoadError": "모델 로드 중 오류가 발생했습니다.",
      "modelCreated": "모델이 성공적으로 생성되었습니다.",
      "modelCreateFailed": "모델 생성 실패: {{error}}",
      "modelCreateError": "모델 생성 중 오류가 발생했습니다.",
      "modelTrained": "모델 훈련이 시작되었습니다.",
      "modelTrainFailed": "모델 훈련 실패: {{error}}",
      "modelTrainError": "모델 훈련 중 오류가 발생했습니다.",
      "modelDeployed": "모델이 성공적으로 배포되었습니다.",
      "modelDeployFailed": "모델 배포 실패: {{error}}",
      "modelDeployError": "모델 배포 중 오류가 발생했습니다.",
      "confirmDelete": "정말로 이 모델을 삭제하시겠습니까?",
      "modelDeleted": "모델이 성공적으로 삭제되었습니다.",
      "modelDeleteFailed": "모델 삭제 실패: {{error}}",
      "modelDeleteError": "모델 삭제 중 오류가 발생했습니다."
    }
  },
  "shareManager": {
    "title": "공유 관리",
    "tabs": {
      "link": "링크 공유",
      "users": "사용자 초대",
      "embed": "임베드",
      "settings": "설정"
    },
    "linkShare": {
      "generateLink": "공유 링크 생성",
      "copyLink": "링크 복사",
      "linkCopied": "링크가 복사되었습니다",
      "shareUrl": "공유 URL",
      "accessCount": "접근 횟수",
      "lastAccessed": "마지막 접근",
      "expiresAt": "만료 일시"
    },
    "userInvite": {
      "inviteUser": "사용자 초대",
      "email": "이메일",
      "role": "역할",
      "viewer": "뷰어",
      "editor": "편집자",
      "collaborator": "협업자",
      "message": "초대 메시지",
      "sendInvite": "초대 보내기",
      "invitationSent": "초대가 전송되었습니다"
    },
    "embed": {
      "embedCode": "임베드 코드",
      "width": "너비",
      "height": "높이",
      "copyCode": "코드 복사",
      "codeCopied": "코드가 복사되었습니다"
    },
    "settings": {
      "public": "공개",
      "allowComments": "댓글 허용",
      "allowDownload": "다운로드 허용",
      "allowEdit": "편집 허용",
      "accessLevel": "접근 레벨",
      "view": "보기",
      "comment": "댓글",
      "edit": "편집",
      "requireAuth": "인증 필요",
      "passwordProtected": "비밀번호 보호",
      "password": "비밀번호",
      "expiresAt": "만료 일시",
      "allowedDomains": "허용 도메인"
    },
    "actions": {
      "save": "저장",
      "cancel": "취소",
      "delete": "삭제",
      "revoke": "취소",
      "close": "닫기"
    }
  },
  "complianceManager": {
    "title": "컴플라이언스 관리",
    "tabs": {
      "overview": "개요",
      "frameworks": "프레임워크",
      "requirements": "요구사항",
      "assessments": "평가",
      "reports": "보고서"
    },
    "overview": {
      "complianceScore": "준수 점수",
      "totalRequirements": "총 요구사항",
      "compliant": "준수",
      "nonCompliant": "미준수",
      "inProgress": "진행중",
      "notApplicable": "해당없음"
    },
    "frameworks": {
      "selectFramework": "프레임워크 선택",
      "addFramework": "프레임워크 추가",
      "frameworkName": "프레임워크 이름",
      "description": "설명",
      "version": "버전",
      "effectiveDate": "시행일"
    },
    "requirements": {
      "requirementId": "요구사항 ID",
      "title": "제목",
      "category": "카테고리",
      "status": "상태",
      "priority": "우선순위",
      "assignedTo": "담당자",
      "dueDate": "마감일",
      "evidence": "증거",
      "notes": "비고"
    },
    "assessment": {
      "runAssessment": "평가 실행",
      "assessmentInProgress": "평가 진행중",
      "assessmentComplete": "평가 완료",
      "progress": "진행률",
      "startDate": "시작일",
      "completedDate": "완료일",
      "assessor": "평가자",
      "results": "결과"
    },
    "reports": {
      "generateReport": "보고서 생성",
      "reportType": "보고서 유형",
      "dateRange": "기간",
      "includeEvidence": "증거 포함",
      "exportFormat": "내보내기 형식",
      "download": "다운로드",
      "share": "공유"
    },
    "actions": {
      "save": "저장",
      "cancel": "취소",
      "delete": "삭제",
      "edit": "편집",
      "view": "보기",
      "refresh": "새로고침"
    }
  },
  "userManagement": {
    "title": "사용자 관리",
    "tabs": {
      "users": "사용자",
      "roles": "역할",
      "permissions": "권한",
      "activity": "활동"
    },
    "users": {
      "addUser": "사용자 추가",
      "username": "사용자명",
      "email": "이메일",
      "firstName": "이름",
      "lastName": "성",
      "status": "상태",
      "active": "활성",
      "inactive": "비활성",
      "suspended": "정지",
      "roles": "역할",
      "lastLogin": "마지막 로그인",
      "createdAt": "생성일",
      "mfaEnabled": "MFA 활성화",
      "department": "부서",
      "location": "위치",
      "manager": "매니저"
    },
    "roles": {
      "addRole": "역할 추가",
      "roleName": "역할 이름",
      "description": "설명",
      "permissions": "권한",
      "userCount": "사용자 수",
      "admin": "관리자",
      "editor": "편집자",
      "viewer": "뷰어"
    },
    "permissions": {
      "resource": "리소스",
      "action": "작업",
      "read": "읽기",
      "write": "쓰기",
      "delete": "삭제",
      "admin": "관리",
      "grantPermission": "권한 부여",
      "revokePermission": "권한 취소"
    },
    "activity": {
      "activityLog": "활동 로그",
      "user": "사용자",
      "action": "작업",
      "resource": "리소스",
      "timestamp": "시간",
      "ipAddress": "IP 주소",
      "success": "성공",
      "failed": "실패"
    },
    "actions": {
      "save": "저장",
      "cancel": "취소",
      "delete": "삭제",
      "edit": "편집",
      "lock": "잠금",
      "unlock": "잠금해제",
      "resetPassword": "비밀번호 재설정",
      "sendInvite": "초대 보내기"
    },
    "messages": {
      "userCreated": "사용자가 생성되었습니다",
      "userUpdated": "사용자가 업데이트되었습니다",
      "userDeleted": "사용자가 삭제되었습니다",
      "roleCreated": "역할이 생성되었습니다",
      "roleUpdated": "역할이 업데이트되었습니다",
      "roleDeleted": "역할이 삭제되었습니다",
      "confirmDelete": "정말로 삭제하시겠습니까?"
    }
  },
  "visualSettings": {
    "title": "비주얼 설정",
    "theme": "테마",
    "colors": "색상",
    "axes": "축",
    "legend": "범례",
    "animation": "애니메이션",
    "responsive": "반응형",
    "themePresets": {
      "default": "기본",
      "dark": "다크",
      "minimal": "미니멀",
      "corporate": "코퍼레이트"
    },
    "colorSettings": {
      "backgroundColor": "배경 색상",
      "textColor": "텍스트 색상",
      "gridColor": "격자 색상",
      "palette": "팔레트",
      "categorical": "범주형",
      "sequential": "순차형",
      "diverging": "발산형"
    },
    "axisSettings": {
      "showXAxis": "X축 표시",
      "showYAxis": "Y축 표시",
      "xAxisLabel": "X축 라벨",
      "yAxisLabel": "Y축 라벨",
      "showGrid": "격자선 표시",
      "gridStyle": "격자선 스타일",
      "fontSize": "폰트 크기",
      "fontFamily": "폰트 패밀리"
    },
    "legendSettings": {
      "showLegend": "범례 표시",
      "position": "위치",
      "top": "상단",
      "bottom": "하단",
      "left": "좌측",
      "right": "우측",
      "alignment": "정렬",
      "orientation": "방향",
      "horizontal": "가로",
      "vertical": "세로"
    },
    "animationSettings": {
      "enable": "애니메이션 활성화",
      "type": "애니메이션 타입",
      "duration": "지속시간",
      "delay": "지연 시간",
      "easing": "이징"
    },
    "actions": {
      "apply": "적용",
      "reset": "초기화",
      "save": "저장",
      "cancel": "취소"
    }
  },
  "chartBuilder": {
    "title": "차트 빌더",
    "steps": {
      "dataSource": "데이터 소스",
      "chartType": "차트 타입",
      "dataFields": "데이터 필드",
      "visualSettings": "비주얼 설정",
      "interactions": "인터랙션",
      "preview": "미리보기"
    },
    "dataSource": {
      "selectSource": "소스 선택",
      "api": "API",
      "file": "파일",
      "database": "데이터베이스",
      "url": "URL",
      "method": "메소드",
      "headers": "헤더 (JSON)",
      "body": "바디 (JSON)",
      "preview": "데이터 미리보기",
      "settings": "설정",
      "help": "도움말"
    },
    "chartType": {
      "selectType": "차트 타입 선택",
      "search": "차트 검색...",
      "recommended": "추천",
      "all": "전체"
    },
    "dataFields": {
      "addField": "필드 추가",
      "dataKey": "데이터 키",
      "displayName": "표시 이름",
      "dataType": "데이터 타입",
      "role": "필드 역할",
      "format": "형식 (선택사항)",
      "formatPlaceholder": "예: yyyy-MM-dd, #,##0.00"
    },
    "interactions": {
      "type": "인터랙션 유형",
      "tooltip": "툴팁",
      "zoom": "줌",
      "pan": "팬",
      "click": "클릭",
      "hover": "호버"
    },
    "preview": {
      "chartName": "차트 이름",
      "settings": "설정",
      "viewCode": "코드 보기",
      "export": "내보내기",
      "save": "저장"
    }
  },
  "dashboardBuilder": {
    "title": "대시보드 빌더",
    "widgetTypes": {
      "bar": "막대 차트",
      "line": "라인 차트",
      "pie": "파이 차트",
      "table": "테이블",
      "metric": "메트릭",
      "text": "텍스트"
    },
    "toolbar": {
      "addWidget": "위젯 추가",
      "save": "저장",
      "execute": "실행",
      "widgetsCount": "{{count}}개 위젯"
    },
    "widgetDialog": {
      "title": "위젯 설정",
      "widgetTitle": "위젯 제목",
      "dataSource": "데이터 소스",
      "sparqlQuery": "SPARQL 쿼리",
      "queryPlaceholder": "SELECT ?s ?p ?o WHERE { ?s ?p ?o } LIMIT 10",
      "cancel": "취소",
      "save": "저장"
    },
    "dataSources": {
      "ontology": "온톨로지",
      "csv": "CSV",
      "api": "API"
    }
  },
  "collaboration": {
    "title": "협업 관리",
    "users": {
      "activeUsers": "활성 사용자",
      "online": "온라인",
      "offline": "오프라인",
      "lastActivity": "마지막 활동"
    },
    "operations": {
      "insert": "삽입",
      "delete": "삭제",
      "update": "수정",
      "move": "이동"
    },
    "conflicts": {
      "title": "충돌 해결",
      "merge": "병합",
      "override": "덮어쓰기",
      "manual": "수동 해결",
      "resolveConflict": "충돌 해결"
    },
    "status": {
      "connected": "연결됨",
      "disconnected": "연결 끊김",
      "reconnecting": "재연결 중",
      "syncing": "동기화 중"
    }
  },
  "aiChat": {
    "title": "AI 채팅",
    "description": "자연어로 데이터를 조회하고 AI와 대화하세요",
    "selectProject": "프로젝트를 먼저 선택해주세요",
    "sparqlGenerated": "SPARQL 쿼리가 생성되었습니다",
    "ragResultsFound": "{{count}}개의 관련 문서를 찾았습니다",
    "noRagResults": "관련 문서를 찾지 못했습니다",
    "error": "오류가 발생했습니다",
    "generatedSparql": "생성된 SPARQL 쿼리",
    "queryResults": "쿼리 결과 ({{count}}건)",
    "showingFirst": "처음 {{shown}}개 표시 (전체 {{total}}건)",
    "ragSearchResults": "RAG 검색 결과",
    "relevanceScore": "관련도",
    "emptyState": "질문을 입력하세요",
    "ragHint": "예: '장비 관련 정보 찾기'",
    "chatHint": "예: '비용 분석 방법에 대해 설명해줘'",
    "modes": {
      "chat": "일반 채팅",
      "rag": "RAG 검색"
    },
    "modeDescriptions": {
      "chat": "일반 AI 채팅",
      "rag": "벡터 검색으로 관련 문서 찾기"
    },
    "handoff": {
      "title": "governed handoff 제안",
      "hint": "채팅은 직접 쓰기를 하지 않고, governed action/workflow 실행을 제안합니다.",
      "action": "액션",
      "workflow": "워크플로우",
      "execute": "실행",
      "executing": "실행 중...",
      "requiresApproval": "approval 필요",
      "contextLabel": "후속 컨텍스트",
      "activeContext": "현재 채팅 컨텍스트"
    },
    "placeholders": {
      "chat": "질문을 입력하세요...",
      "rag": "검색할 내용을 입력하세요..."
    }
  },
  "costPrediction": {
    "title": "비용 예측",
    "tabs": {
      "overview": "개요",
      "predictions": "예측",
      "trends": "트렌드",
      "insights": "인사이트"
    },
    "metrics": {
      "totalCost": "총 비용",
      "predictedCost": "예측 비용",
      "variance": "변동",
      "confidence": "신뢰도",
      "accuracy": "정확도"
    },
    "timeRanges": {
      "week": "주간",
      "month": "월간",
      "quarter": "분기",
      "year": "연간"
    },
    "actions": {
      "runPrediction": "예측 실행",
      "export": "내보내기",
      "refresh": "새로고침"
    }
  },
  "featureImportance": {
    "title": "특성 중요도 분석",
    "chart": {
      "importance": "중요도",
      "feature": "특성",
      "value": "값"
    },
    "insights": {
      "topFeatures": "상위 특성",
      "correlations": "상관관계",
      "recommendations": "권장사항"
    }
  },
  "insightGenerator": {
    "title": "인사이트 생성기",
    "generate": "인사이트 생성",
    "generating": "생성 중...",
    "categories": {
      "cost": "비용",
      "quality": "품질",
      "performance": "성능",
      "risks": "리스크"
    },
    "priority": {
      "high": "높음",
      "medium": "중간",
      "low": "낮음"
    },
    "actions": {
      "viewDetails": "상세 보기",
      "implement": "적용",
      "dismiss": "무시"
    }
  },
  "modelPerformance": {
    "title": "모델 성능",
    "metrics": {
      "accuracy": "정확도",
      "precision": "정밀도",
      "recall": "재현율",
      "f1Score": "F1 점수",
      "auc": "AUC",
      "rmse": "RMSE",
      "mae": "MAE"
    },
    "charts": {
      "confusionMatrix": "혼동 행렬",
      "rocCurve": "ROC 곡선",
      "learningCurve": "학습 곡선",
      "featureImportance": "특성 중요도"
    },
    "comparison": {
      "title": "모델 비교",
      "baseline": "기준선",
      "current": "현재",
      "best": "최고"
    }
  },
  "realTimeVisualization": {
    "title": "실시간 시각화",
    "controls": {
      "start": "시작",
      "pause": "일시정지",
      "stop": "정지",
      "refresh": "새로고침",
      "settings": "설정",
      "fullscreen": "전체화면",
      "download": "다운로드"
    },
    "stream": {
      "isStreaming": "스트리밍 중",
      "updateInterval": "업데이트 주기",
      "maxDataPoints": "최대 데이터 포인트",
      "autoScale": "자동 스케일",
      "showAlerts": "알림 표시"
    },
    "alerts": {
      "highValue": "높은 값 경고",
      "lowValue": "낮은 값 경고",
      "threshold": "임계값",
      "upperThreshold": "상한",
      "lowerThreshold": "하한"
    },
    "chart": {
      "value": "값",
      "timestamp": "시간",
      "lastUpdate": "마지막 업데이트",
      "dataPoints": "데이터 포인트"
    },
    "messages": {
      "updateFailed": "데이터 업데이트 실패",
      "noData": "데이터 없음",
      "connecting": "연결 중..."
    }
  },
  "databaseOptimization": {
    "title": "데이터베이스 최적화",
    "tabs": {
      "queries": "쿼리 최적화",
      "indexes": "인덱스 관리",
      "cache": "캐시 설정",
      "performance": "성능 모니터링"
    },
    "queries": {
      "slowQueries": "느린 쿼리",
      "executionTime": "실행 시간",
      "rowsAffected": "영향받은 행",
      "optimize": "최적화",
      "explain": "실행 계획"
    },
    "indexes": {
      "createIndex": "인덱스 생성",
      "dropIndex": "인덱스 삭제",
      "rebuild": "재구축",
      "analyze": "분석",
      "indexName": "인덱스 이름",
      "columns": "컬럼",
      "unique": "고유",
      "usage": "사용률"
    },
    "cache": {
      "hitRate": "캐시 히트율",
      "size": "크기",
      "ttl": "유효 시간",
      "clear": "캐시 초기화",
      "policy": "정책"
    },
    "performance": {
      "qps": "초당 쿼리",
      "connections": "연결 수",
      "memory": "메모리 사용량",
      "cpu": "CPU 사용량",
      "diskIO": "디스크 I/O"
    }
  },
  "autoML": {
    "title": "AutoML 워크벤치",
    "tabs": {
      "dataset": "데이터셋",
      "features": "특성 엔지니어링",
      "models": "모델 선택",
      "training": "학습",
      "evaluation": "평가"
    },
    "dataset": {
      "upload": "데이터셋 업로드",
      "target": "타겟 변수",
      "features": "특성",
      "split": "데이터 분할",
      "trainSize": "학습 데이터 비율",
      "testSize": "테스트 데이터 비율",
      "preview": "미리보기"
    },
    "features": {
      "autoFeature": "자동 특성 생성",
      "featureSelection": "특성 선택",
      "scaling": "스케일링",
      "encoding": "인코딩",
      "polynomial": "다항식 특성",
      "interaction": "상호작용 특성"
    },
    "models": {
      "autoSelect": "자동 모델 선택",
      "algorithms": "알고리즘",
      "ensemble": "앙상블",
      "hyperparameters": "하이퍼파라미터",
      "crossValidation": "교차 검증",
      "folds": "폴드 수"
    },
    "training": {
      "start": "학습 시작",
      "stop": "학습 중지",
      "progress": "진행률",
      "currentModel": "현재 모델",
      "bestScore": "최고 점수",
      "elapsed": "경과 시간",
      "remaining": "남은 시간"
    },
    "evaluation": {
      "bestModel": "최고 모델",
      "metrics": "성능 지표",
      "confusionMatrix": "혼동 행렬",
      "featureImportance": "특성 중요도",
      "predictions": "예측",
      "export": "모델 내보내기",
      "deploy": "배포"
    }
  },
  "ontologyGraph": {
    "title": "온톨로지 네트워크 그래프",
    "layout": {
      "force": "Force 레이아웃",
      "hierarchical": "계층형",
      "circular": "원형",
      "grid": "격자"
    },
    "display": {
      "showLabels": "라벨 표시",
      "showEdges": "간선 표시",
      "nodeSize": "노드 크기",
      "edgeWidth": "간선 너비",
      "physics": "물리 효과"
    },
    "filters": {
      "nodeTypes": "노드 타입",
      "edgeTypes": "간선 타입",
      "search": "검색",
      "neighbors": "이웃 노드"
    },
    "actions": {
      "zoomIn": "확대",
      "zoomOut": "축소",
      "fit": "맞추기",
      "reset": "초기화",
      "export": "내보내기"
    }
  },
  "query": {
    "title": "데이터 조회",
    "sparqlQuery": "SPARQL 쿼리",
    "runQuery": "쿼리 실행",
    "queryResults": "쿼리 결과",
    "noResults": "결과 없음",
    "queryHistory": "쿼리 이력",
    "saveQuery": "쿼리 저장"
  },
  "validation": {
    "title": "SHACL 검증",
    "runValidation": "검증 실행",
    "validationResults": "검증 결과",
    "passed": "통과",
    "failed": "실패",
    "warnings": "경고",
    "errors": "오류",
    "details": "상세 정보",
    "navigateNotReady": "준비 중인 기능입니다"
  },
  "messages": {
    "saveSuccess": "저장되었습니다",
    "saveError": "저장 실패",
    "deleteSuccess": "삭제되었습니다",
    "deleteError": "삭제 실패",
    "loadError": "불러오기 실패",
    "connectionSuccess": "연결 성공",
    "connectionError": "연결 실패",
    "validationSuccess": "검증 통과",
    "validationError": "검증 실패",
    "confirmAction": "이 작업을 진행하시겠습니까?",
    "unsavedChanges": "저장되지 않은 변경사항이 있습니다"
  },
  "auth": {
    "loginRequired": "로그인이 필요합니다",
    "loginDescription": "이 기능을 사용하려면 Google 계정으로 로그인해주세요.",
    "loginWithGoogle": "Google로 로그인",
    "login": "로그인",
    "logout": "로그아웃",
    "guard": {
      "globalAdminOnly": "이 페이지는 글로벌 관리자만 이용할 수 있습니다."
    }
  },
  "landing": {
    "hero": {
      "eyebrow": "AI Operations Platform with Ontology",
      "title": "운영 데이터, 워크플로우, 인사이트를 온톨로지로 연결합니다.",
      "subtitle": "AI가 운영 워크플로우를 설계하고 실행합니다. 결과는 온톨로지 지식 그래프로 축적되고 리포트로 설명되며, 다음 자동화의 입력으로 다시 연결됩니다. 코드 없이.",
      "ctaPrimary": "무료로 시작하기",
      "ctaSecondary": "데모 둘러보기",
      "trustline": "신용카드 없이 5분 안에 시작 · 기존 DB / SaaS / API 그대로 사용"
    },
    "socialProof": {
      "title": "적용 산업과 운영 시나리오",
      "subtitle": "AI Operations Platform with Ontology는 운영 데이터가 흩어져 있고 의사결정 근거를 남겨야 하는 산업에서 먼저 효과가 납니다.",
      "standardsNote": "RDF / OWL, SPARQL 1.1, REST / OpenAPI, MCP, RPA 기반으로 기존 운영 시스템 위에 연결됩니다.",
      "industryScenarios": {
        "mfg": {
          "label": "제조",
          "issue": "공정, 설비, 자재, 원가 데이터가 부서별로 흩어짐",
          "application": "온톨로지로 생산 흐름과 원가 근거를 연결"
        },
        "distribution": {
          "label": "유통 / 물류",
          "issue": "주문, 재고, 운송 이벤트가 실시간 의사결정과 분리됨",
          "application": "워크플로우 결과를 지식 그래프로 축적해 SLA와 예외 대응 추적"
        },
        "finance": {
          "label": "금융",
          "issue": "규정, 승인, 리스크 근거가 시스템별 로그로만 남음",
          "application": "정책, 증적, 리포트를 같은 운영 문맥으로 설명"
        },
        "health": {
          "label": "헬스케어",
          "issue": "운영 품질과 컴플라이언스 증적을 반복적으로 수집해야 함",
          "application": "프로세스 실행과 감사 근거를 자동으로 연결"
        },
        "energy": {
          "label": "에너지",
          "issue": "자산 상태, 현장 작업, 이상 징후가 별도 체계로 운영됨",
          "application": "설비 이벤트와 조치 workflow를 온톨로지 기반으로 추적"
        }
      }
    },
    "vision4axes": {
      "title": "AI 운영 플랫폼을 구성하는 4 가지 축",
      "loopHint": "AI가 설계하고 workflow가 실행하면 ontology가 기억하고 report가 설명하며, 그 결과가 policy 기반으로 다음 자동화에 연결됩니다.",
      "axisAgentic": {
        "title": "에이전틱 AI",
        "desc": "자연어 의도에서 workflow / ontology / report 를 설계하고, self-repair · clarification 까지"
      },
      "axisInfra": {
        "title": "외부 IT 인프라 결합",
        "desc": "DB · SaaS · REST · 파일 · MCP · RPA connector federation. 운영 데이터는 그대로."
      },
      "axisOntology": {
        "title": "온톨로지 메모리",
        "desc": "workflow 실행 결과가 RDF graph · lineage · audit 으로 정본화"
      },
      "axisLoop": {
        "title": "운영 피드백",
        "desc": "report · insight 결과가 policy 기반으로 다음 workflow의 trigger · parameter 입력에 자동으로 연결됩니다."
      }
    },
    "features": {
      "title": "왜 Infergraph 인가?",
      "subtitle": "AI 실행력과 온톨로지 기억이 결합될 때 운영 자동화는 일회성 작업이 아니라 축적되는 자산이 됩니다.",
      "f1": {
        "title": "분 단위로 가동, 주 단위가 아닙니다",
        "desc": "재무 · 구매 · 생산 · 유통 ready-made pack 1 클릭 설치. 컨설팅 6개월 없이 첫 사이클이 그 주 안에 돕니다."
      },
      "f2": {
        "title": "데이터를 이동하지 않습니다",
        "desc": "DB · SaaS · REST · 파일 · MCP · RPA 위 federation 동작. 보안 검토 새로 받을 필요 없이, 기존 IT 인프라 위에서 그대로."
      },
      "f3": {
        "title": "온톨로지가 운영 지식의 정본이 됩니다",
        "desc": "워크플로우 결과와 의사결정 근거가 ontology graph에 정본화됩니다. 신규 입사자도 lineage로 맥락을 추적할 수 있습니다."
      },
      "f4": {
        "title": "지식 그래프가 다음 판단을 준비합니다",
        "desc": "사이클 결과는 ontology graph와 report에 남고, 다음 workflow의 trigger · parameter · policy 입력으로 자동 환류됩니다."
      }
    },
    "onboarding": {
      "title": "5단계로 비전 루프를 체험합니다",
      "subtitle": "ready-made pack 설치 → workflow → ontology 캡처 → report 까지 — 비개발자 첫 사용자 경험을 위한 가이드."
    },
    "cta": {
      "title": "AI Operations Platform with Ontology를 시작하세요",
      "subtitle": "자연어로 운영 자동화를 만들고, 실행 결과를 온톨로지 지식 그래프로 축적하세요.",
      "primary": "시작하기",
      "contact": "문의하기"
    },
    "howItWorks": {
      "overline": "작동 방식",
      "title": "AI와 온톨로지로 운영 cycle 이 완성됩니다",
      "subtitle": "Design → Execute → Capture as Ontology → Explain → Automate Again. AI 운영이 지식 그래프 위에서 순환합니다.",
      "foundationsHeading": "기반 — 모든 단계를 받쳐주는 백본",
      "stepLabel": "단계 {{n}}"
    }
  },
  "closedLoopWalkthrough": {
    "eyebrow": "Closed-loop 여정",
    "title": "Closed-Loop 5-step 여정",
    "intro": "AI가 설계하고, workflow가 실행하고, ontology가 기억하고, report가 설명하며, 그 결과가 다시 자동화로 돌아가는 흐름을 한 화면에서 확인합니다.",
    "steps": {
      "aiDesign": {
        "title": "AI 설계",
        "description": "Decision Table 또는 AI Build로 정책과 워크플로우를 자동 설계합니다.",
        "cta": "정책 작성 열기"
      },
      "workflowExecute": {
        "title": "Workflow 실행",
        "description": "Published workflow가 트리거와 dispatcher를 통해 운영 작업을 실행합니다.",
        "cta": "Workflow 열기"
      },
      "ontologyCapture": {
        "title": "Ontology 기억",
        "description": "실행 결과를 RDF graph와 lineage로 캡처해 다음 분석의 정본으로 남깁니다.",
        "cta": "Object Explorer 열기"
      },
      "reportExplain": {
        "title": "Report 설명",
        "description": "Published report와 dashboard가 결과를 설명하고 의사결정 근거를 보여줍니다.",
        "cta": "Report Library 열기"
      },
      "loopFeedback": {
        "title": "루프 피드백",
        "description": "Loop Evidence가 단일 사이클 결과와 근거를 모으고, 다음 cycle의 입력으로 자동 연결합니다.",
        "cta": "Loop Evidence 열기"
      }
    },
    "audit": {
      "col": {
        "actor": "액터",
        "cycle": "사이클",
        "definitions": "정의",
        "parent": "부모",
        "reason": "상태"
      }
    },
    "continuation": {
      "error": "연속 실행 시작 실패",
      "impactHint": "{{domain}}의 마지막 사이클에서 {{count}}개 이상의 패턴을 분석합니다",
      "impactHintNoDomain": "마지막 사이클에서 {{count}}개 이상의 패턴을 분석합니다",
      "launch": "연속 실행 시작",
      "snackbarSuccess": "{{persona}}에 대한 연속 실행을 시작했습니다",
      "success": "연속 실행 요청됨: {{status}}"
    },
    "cycle": {
      "label": "사이클 {{index}}",
      "short": "C{{index}}"
    },
    "drawer": {
      "title": "Closed Loop 트리거 상세"
    },
    "empty": {
      "help": "워크플로를 실행하면 결과가 캡처되어 여기에 표시됩니다.",
      "title": "Closed Loop 사이클이 없습니다."
    },
    "errors": {
      "loadFailed": "Closed Loop 리플레이 매니페스트를 불러오지 못했습니다",
      "missingProject": "프로젝트 컨텍스트 없음 — 연속 실행을 시작할 수 없습니다"
    },
    "goToPolicyAuthoring": "Policy Authoring으로 이동",
    "kpi": {
      "auditEvents": "트리거 이벤트: {{value}}",
      "cycles": "사이클: {{value}}",
      "personas": "페르소나: {{value}}",
      "reportVersions": "리포트 버전: {{value}}",
      "triples": "캡처된 패턴: {{value}}"
    },
    "noMatchingRule": "이 프로젝트에 활성화된 루프 규칙이 없습니다. Policy Authoring에서 Decision Table을 생성하고 활성화하세요.",
    "provenance": {
      "artifactDir": "아티팩트 디렉터리",
      "loopEvidence": "Loop Evidence Dashboard",
      "objectExplorer": "Object Explorer",
      "policyAuthoring": "Policy Authoring",
      "reportLibrary": "Report Library",
      "workflows": "Workflows"
    },
    "section": {
      "auditTrail": "Closed Loop 트리거 감사",
      "continuation": "연속 실행 시작",
      "cycleProgression": "사이클 진행",
      "provenance": "아티팩트 출처",
      "reportRefresh": "리포트 갱신"
    },
    "seedError": "샘플 데이터 시드에 실패했습니다.",
    "seedSample": "샘플 데이터 불러오기",
    "seedingSample": "샘플 데이터 불러오는 중…",
    "subtitle": "각 페르소나에 대해 엔드투엔드 Closed Loop 실행을 진행합니다",
    "tabs": {
      "aria": "Closed Loop 페르소나"
    }
  },
  "closedLoopCycle": {
    "ariaLabel": "AI 운영 플랫폼의 온톨로지 기반 순환 구조",
    "axisAgentic": "에이전틱 AI",
    "axisInfra": "외부 IT 결합",
    "axisOntology": "온톨로지 메모리",
    "axisLoop": "운영 피드백"
  },
  "governance": {
    "hub": {
      "title": "거버넌스 허브",
      "subtitle": "Credential · 승인 · loop evidence — 3 가지 governance surface 를 한 곳에서. 각 카드는 본격 화면으로 이동합니다.",
      "footnote": "metric 자동 연결은 G6-FU 에서 추가. Loop evidence cycle 추적은 VC-B2/B3 trigger bus 위에서 동작.",
      "vault": {
        "title": "자격 증명 보관소",
        "desc": "외부 IT 인프라(Snowflake / BigQuery / Postgres / REST / MCP) credential 을 한 곳에서 등록 · 회전 · 권한 부여.",
        "cta": "Credential 관리"
      },
      "inbox": {
        "title": "승인 대기함",
        "desc": "Workflow / ontology / report publish 대기 승인 요청. 승인 / 거절 / 위임 처리.",
        "cta": "승인함 열기"
      },
      "loop": {
        "title": "루프 증거 대시보드",
        "desc": "AI 자동화가 약속대로 돌고 있다는 증거. workflow → ontology → report → 다음 사이클까지 끊기지 않았는지, 어디서 지연이 발생했는지 한 화면에서 감사합니다.",
        "cta": "루프 증거 보기"
      }
    }
  },
  "home": {
    "title": "온톨로지 기반 데이터 분석 시스템",
    "subtitle": "의미론적 모델링과 AI 기반 분석을 통해",
    "subtitle2": "데이터 관계의 추적성을 향상시키는 지능형 시스템입니다.",
    "footer1": "시맨틱 웹 기술 + AI 기반 원가 분석",
    "footer2": "RDF/OWL, SPARQL, FastAPI, React, Claude AI 기반",
    "projectTitle": "프로젝트 관리",
    "projectDesc": "프로젝트를 생성하고 관리하며, 접근 권한을 설정합니다.",
    "projectButton": "프로젝트 관리",
    "schemaTitle": "스키마 관리",
    "schemaDesc": "제조업 공정의 온톨로지 클래스와 속성을 시각적으로 설계하고 관리합니다.",
    "schemaButton": "스키마 관리",
    "dataTitle": "데이터 관리",
    "dataDesc": "CSV 데이터를 RDF 온톨로지로 변환하고 지식 그래프를 구축합니다.",
    "dataButton": "데이터 관리",
    "insightTitle": "Auto Insight",
    "insightDesc": "AI 기반 자동 인사이트 생성, BI 대시보드, LLM 분석, 자동 리포트 생성 기능을 제공합니다.",
    "insightButton": "Auto Insight"
  },
  "loginModal": {
    "title": "Infergraph 로그인",
    "description": "Infergraph는 Google 계정으로만 로그인 가능합니다.",
    "loginWithGoogle": "Google로 로그인",
    "loggingIn": "로그인 중...",
    "loginSuccess": "로그인 성공!",
    "credentialsDivider": "또는 계정으로 로그인",
    "usernameLabel": "이메일 또는 사용자명",
    "passwordLabel": "비밀번호",
    "credentialsButton": "로그인",
    "errors": {
      "emailAndPasswordRequired": "이메일과 비밀번호를 입력해주세요",
      "allFieldsRequired": "모든 필드를 입력해주세요",
      "passwordMismatch": "비밀번호가 일치하지 않습니다",
      "passwordTooShort": "비밀번호는 6자 이상이어야 합니다",
      "emailRequired": "이메일을 입력해주세요",
      "userNotFound": "등록되지 않은 이메일입니다",
      "wrongPassword": "잘못된 비밀번호입니다",
      "emailInUse": "이미 사용 중인 이메일입니다",
      "weakPassword": "비밀번호는 6자 이상이어야 합니다",
      "invalidEmail": "유효하지 않은 이메일 형식입니다",
      "popupClosed": "로그인 창이 닫혔습니다",
      "popupBlocked": "팝업이 차단되었습니다. 팝업을 허용해주세요",
      "loginError": "로그인 중 오류가 발생했습니다",
      "credentialsFailed": "이메일/비밀번호를 확인해주세요."
    }
  },
  "propertyConstraints": {
    "sections": {
      "basicInfo": "기본 정보",
      "requiredProperty": "필수 속성 설정",
      "valueRange": "값 범위 제약",
      "textConstraints": "텍스트 제약"
    },
    "labels": {
      "propertyLabel": "속성 레이블",
      "dataType": "데이터 타입",
      "requiredInput": "필수 입력",
      "minValue": "최소값",
      "maxValue": "최대값",
      "unit": "단위",
      "minLength": "최소 길이",
      "maxLength": "최대 길이",
      "regexPattern": "정규식 패턴"
    },
    "dataTypes": {
      "string": "문자열",
      "text": "텍스트",
      "integer": "정수",
      "decimal": "소수",
      "number": "숫자",
      "boolean": "논리값",
      "date": "날짜",
      "datetime": "날짜시간",
      "time": "시간",
      "yearMonth": "년월",
      "year": "년",
      "url": "URL",
      "email": "이메일"
    },
    "alerts": {
      "requiredPropertyInfo": "이 속성을 필수로 설정하면 모든 인스턴스는 반드시 이 속성 값을 가져야 합니다.",
      "dateFormat": "날짜 형식: YYYY-MM-DD (예: 2024-01-15)",
      "datetimeFormat": "날짜시간 형식: YYYY-MM-DDTHH:mm:ss (예: 2024-01-15T14:30:00)",
      "timeFormat": "시간 형식: HH:mm:ss (예: 14:30:00)",
      "yearMonthFormat": "년월 형식: YYYY-MM (예: 2024-01)",
      "yearFormat": "년 형식: YYYY (예: 2024)",
      "urlFormat": "URL 형식: http:// 또는 https:// 로 시작",
      "emailFormat": "이메일 형식: user@example.com"
    },
    "errors": {
      "invalidRegex": "유효하지 않은 정규식입니다",
      "minGreaterThanMax": "최소값은 최대값보다 작아야 합니다",
      "minLengthGreaterThanMaxLength": "최소 길이는 최대 길이보다 작아야 합니다"
    },
    "helpers": {
      "regexExample": "예: ^[A-Z]{2}-\\d{4}$",
      "unitPlaceholder": "예: kg, cm, 원"
    },
    "buttons": {
      "cancel": "취소",
      "save": "저장"
    }
  },
  "detailedPermission": {
    "title": "{email} - {role}",
    "subtitle": "상세 권한 설정",
    "modes": {
      "useRoleDefaults": "역할 기본 권한 사용",
      "customPermissions": "사용자 정의 권한"
    },
    "alerts": {
      "usingDefaults": "현재 {role} 역할의 기본 권한을 사용하고 있습니다",
      "customSettings": "사용자 정의 권한이 설정되어 있습니다"
    },
    "tabs": {
      "ontology": "온톨로지",
      "data": "데이터",
      "sparql": "SPARQL",
      "analytics": "분석"
    },
    "sections": {
      "ontologyPermissions": "온톨로지 권한",
      "dataPermissions": "데이터 권한",
      "sparqlPermissions": "SPARQL 권한",
      "analyticsPermissions": "분석 권한"
    },
    "labels": {
      "custom": "사용자 정의",
      "defaultAllow": "기본 허용",
      "defaultDeny": "기본 거부"
    },
    "buttons": {
      "customSettings": "사용자 정의 설정",
      "useDefaults": "기본값 사용",
      "cancel": "취소",
      "save": "저장"
    }
  },
  "ontologyMapping": {
    "title": "{datasetName} - 온톨로지 매핑",
    "tabs": {
      "schemaAnalysis": "스키마 분석",
      "mappingSettings": "매핑 설정",
      "generatedOntology": "생성된 온톨로지",
      "sparqlQueries": "SPARQL 쿼리"
    },
    "sections": {
      "datasetInfo": "데이터셋 정보",
      "columnAnalysis": "컬럼 분석 결과",
      "columnDetails": "컬럼 상세",
      "mappingConfig": "매핑 설정",
      "classGeneration": "생성될 클래스",
      "propertyGeneration": "생성될 속성",
      "ontologyPreview": "온톨로지 미리보기",
      "tripleCount": "생성될 트리플 수",
      "sampleQueries": "샘플 쿼리",
      "customQuery": "사용자 정의 쿼리",
      "queryResults": "쿼리 결과"
    },
    "labels": {
      "fileName": "파일명",
      "rowCount": "{count}행",
      "columnCount": "{count}개 컬럼",
      "analyzedAt": "분석 시각",
      "columnName": "컬럼명",
      "dataType": "데이터 타입",
      "nullCount": "결측치",
      "uniqueCount": "고유값",
      "sampleValues": "샘플 값",
      "mappingType": "매핑 타입",
      "semanticType": "의미 타입",
      "domainConcept": "도메인 개념",
      "targetProperty": "대상 속성",
      "className": "클래스명",
      "classDescription": "클래스 설명",
      "propertyName": "속성명",
      "propertyDescription": "속성 설명",
      "propertyType": "속성 타입",
      "totalTriples": "총 트리플 수",
      "classTriples": "클래스 트리플",
      "propertyTriples": "속성 트리플",
      "queryName": "쿼리명",
      "queryDescription": "쿼리 설명",
      "executeQuery": "쿼리 실행",
      "noResults": "결과 없음"
    },
    "mappingTypes": {
      "property": "속성으로 매핑",
      "class": "클래스로 매핑",
      "ignore": "무시"
    },
    "semanticTypes": {
      "identifier": "식별자",
      "label": "레이블",
      "description": "설명",
      "temporal": "시간",
      "monetary": "금액",
      "quantity": "수량",
      "classification": "분류",
      "general": "일반"
    },
    "domainConcepts": {
      "product": "제품",
      "process": "공정",
      "resource": "자원",
      "parameter": "파라미터",
      "metric": "지표",
      "batch": "배치",
      "attribute": "속성"
    },
    "placeholders": {
      "selectMapping": "매핑 타입 선택",
      "selectSemantic": "의미 타입 선택",
      "selectDomain": "도메인 개념 선택",
      "selectProperty": "속성 선택"
    },
    "buttons": {
      "analyze": "분석",
      "applyMapping": "매핑 적용",
      "generateOntology": "온톨로지 생성",
      "downloadRDF": "RDF 다운로드",
      "cancel": "취소",
      "next": "다음",
      "previous": "이전"
    },
    "errors": {
      "analysisError": "스키마 분석 실패",
      "mappingError": "매핑 적용 실패",
      "generationError": "온톨로지 생성 실패",
      "queryError": "쿼리 실행 실패"
    },
    "messages": {
      "analyzeSuccess": "스키마 분석 완료",
      "mappingSuccess": "매핑 설정 완료",
      "generationSuccess": "온톨로지 생성 완료",
      "querySuccess": "쿼리 실행 완료"
    }
  },
  "versionManagement": {
    "title": "버전 관리",
    "sections": {
      "versionList": "버전 목록",
      "versionDetails": "버전 상세",
      "versionComparison": "버전 비교"
    },
    "labels": {
      "versionName": "버전명",
      "description": "설명",
      "createdAt": "생성일",
      "createdBy": "생성자",
      "rowCount": "{count}행",
      "columnCount": "{count}개 컬럼",
      "baseVersion": "기준 버전",
      "compareVersion": "비교 버전",
      "changes": "변경사항",
      "rowsAdded": "추가된 행",
      "rowsRemoved": "제거된 행",
      "columnsAdded": "추가된 컬럼",
      "columnsRemoved": "제거된 컬럼",
      "valueChanges": "값 변경"
    },
    "placeholders": {
      "versionName": "예: v1.0",
      "description": "버전 설명 입력",
      "searchVersions": "버전 검색...",
      "selectBase": "기준 버전 선택",
      "selectCompare": "비교 버전 선택"
    },
    "buttons": {
      "createVersion": "버전 생성",
      "viewDetails": "상세 보기",
      "compare": "비교",
      "rollback": "롤백",
      "download": "다운로드",
      "delete": "삭제",
      "cancel": "취소",
      "confirm": "확인"
    },
    "dialogs": {
      "createVersion": "새 버전 생성",
      "viewDetails": "버전 상세",
      "deleteVersion": "버전 삭제",
      "rollbackVersion": "버전 롤백"
    },
    "alerts": {
      "currentVersion": "현재 버전",
      "noVersions": "생성된 버전이 없습니다",
      "selectTwoVersions": "비교할 버전 2개를 선택하세요",
      "noChanges": "변경사항이 없습니다",
      "rollbackWarning": "이전 버전으로 롤백하면 현재 데이터가 손실될 수 있습니다."
    },
    "confirmations": {
      "deleteVersion": "버전 '{versionName}'을(를) 삭제하시겠습니까?",
      "rollbackVersion": "버전 '{versionName}'(으)로 롤백하시겠습니까?",
      "deleteSuccess": "버전이 삭제되었습니다",
      "rollbackSuccess": "버전 롤백이 완료되었습니다"
    },
    "errors": {
      "createError": "버전 생성 실패",
      "loadError": "버전 목록 로드 실패",
      "deleteError": "버전 삭제 실패",
      "rollbackError": "버전 롤백 실패",
      "compareError": "버전 비교 실패"
    }
  },
  "analysis": {
    "title": "데이터 분석",
    "description": "온톨로지 데이터 분석 및 인사이트",
    "ontologyQuery": "온톨로지 쿼리",
    "aiAnalysis": "AI 자동 분석",
    "dashboard": "대시보드",
    "dataQuery": "데이터 쿼리",
    "relationshipExplorer": "관계 탐색기",
    "pathAnalysis": "경로 분석",
    "patternDetection": "패턴 탐지",
    "impactAnalysis": "영향 분석",
    "insightGeneration": "인사이트 생성",
    "dashboardTitle": "온톨로지 대시보드",
    "dashboardDescription": "프로젝트 온톨로지 구조 개요",
    "dataQueryTitle": "데이터 쿼리",
    "dataQueryDescription": "온톨로지 데이터 필터링 및 검색",
    "relationshipExplorerTitle": "관계 탐색기",
    "relationshipExplorerDescription": "클래스 간 관계 탐색 및 분석",
    "pathAnalysisTitle": "경로 분석",
    "pathAnalysisDescription": "두 클래스 간 연결 경로 탐색",
    "patternDetectionTitle": "패턴 탐지",
    "patternDetectionDescription": "온톨로지 데이터의 패턴 자동 분석",
    "impactAnalysisTitle": "영향 분석",
    "impactAnalysisDescription": "클래스 변경의 영향 범위 분석",
    "insightGenerationTitle": "인사이트 생성",
    "insightGenerationDescription": "AI 기반 온톨로지 인사이트 자동 생성",
    "classes": "클래스",
    "relations": "관계",
    "instances": "인스턴스",
    "relationInstances": "관계 인스턴스",
    "relationshipInstances": "관계 인스턴스",
    "classList": "클래스 목록",
    "totalClasses": "전체 클래스",
    "totalRelations": "전체 관계",
    "totalInstances": "전체 인스턴스",
    "definedConnections": "정의된 연결",
    "relationTypes": "관계 유형",
    "connectionsList": "연결 목록",
    "noConnections": "연결이 없습니다",
    "noRelations": "관계가 없습니다",
    "categoryOntologyQuery": "온톨로지 쿼리",
    "categoryAIAnalysis": "AI 자동 분석",
    "connectionsFound": "개 연결 발견",
    "classesByType": "클래스 타입별 분포",
    "relationUsage": "관계 사용 통계",
    "loading": "로딩 중...",
    "loadError": "데이터 로드 실패",
    "analysisError": "분석 실패",
    "queryError": "쿼리 실행 실패",
    "pathSearchError": "경로 검색 실패",
    "filters": "필터",
    "selectClass": "클래스 선택",
    "selectRelation": "관계 선택",
    "searchText": "텍스트 검색",
    "runQuery": "쿼리 실행",
    "queryResults": "쿼리 결과",
    "records": "건",
    "exportCsv": "CSV 내보내기",
    "noResults": "결과 없음",
    "filterByClass": "클래스로 필터",
    "connections": "연결",
    "sourceClass": "시작 클래스",
    "targetClass": "대상 클래스",
    "findPath": "경로 찾기",
    "searchPaths": "경로 검색",
    "foundPaths": "발견된 경로",
    "noPathsFound": "경로를 찾을 수 없습니다",
    "selectBothClasses": "시작과 대상 클래스를 모두 선택하세요",
    "selectClassFirst": "분석할 클래스를 먼저 선택하세요",
    "selectClassToAnalyze": "분석할 클래스 선택",
    "analyzeImpact": "영향 분석",
    "directImpacts": "직접 영향",
    "indirectImpacts": "간접 영향",
    "affectedInstances": "영향받는 인스턴스",
    "overallRisk": "전체 위험도",
    "noDirectImpacts": "직접 영향을 받는 클래스가 없습니다",
    "noIndirectImpacts": "간접 영향을 받는 클래스가 없습니다",
    "outgoingRelation": "나가는 관계",
    "incomingRelation": "들어오는 관계",
    "hops": "홉",
    "risk": {
      "low": "낮음",
      "medium": "중간",
      "high": "높음"
    },
    "reanalyze": "재분석",
    "analyzingPatterns": "패턴 분석 중...",
    "lastAnalyzed": "마지막 분석",
    "patternsDetected": "탐지된 패턴",
    "highPriority": "높은 우선순위",
    "mediumPriority": "중간 우선순위",
    "lowPriority": "낮은 우선순위",
    "noPatternsFound": "탐지된 패턴 없음",
    "noPatternsDesc": "현재 데이터에서 특별한 패턴이 발견되지 않았습니다",
    "severity": {
      "low": "낮음",
      "medium": "중간",
      "high": "높음"
    },
    "confidence": "신뢰도",
    "relatedEntities": "관련 항목",
    "patterns": {
      "highFrequencyRelations": "고빈도 관계",
      "highFrequencyDesc": "{{count}}개 관계가 평균보다 1.5배 이상 사용됨: {{relations}}",
      "unusedRelations": "미사용 관계",
      "unusedRelationsDesc": "{{count}}개 관계가 정의되었지만 사용되지 않음",
      "classImbalance": "클래스 불균형",
      "classImbalanceDesc": "클래스 타입 간 불균형이 감지됨",
      "isolatedClasses": "고립된 클래스",
      "isolatedClassesDesc": "{{count}}개 클래스가 다른 클래스와 연결되지 않음",
      "sparseData": "희소 데이터",
      "sparseDataDesc": "전체 인스턴스 수({{instances}})가 예상치({{expected}})보다 적음"
    },
    "regenerate": "재생성",
    "generatingInsights": "인사이트 생성 중...",
    "lastGenerated": "마지막 생성",
    "noInsights": "인사이트 없음",
    "noInsightsDesc": "현재 온톨로지 구조에서 특별한 인사이트가 발견되지 않았습니다",
    "insights": "인사이트",
    "recommendation": "권장사항",
    "relatedItems": "관련 항목",
    "category": {
      "optimization": "최적화",
      "quality": "품질",
      "completeness": "완전성",
      "suggestion": "제안"
    },
    "priority": {
      "low": "낮음",
      "medium": "중간",
      "high": "높음"
    },
    "orphanClasses": "고립된 클래스",
    "orphanClassesDesc": "{{count}}개 클래스가 어떤 관계와도 연결되지 않음",
    "orphanClassesRec": "이 클래스들에 관계를 추가하거나 불필요한 경우 삭제를 고려하세요",
    "emptyRelations": "빈 관계",
    "emptyRelationsDesc": "{{count}}개 관계 타입에 실제 인스턴스가 없음",
    "emptyRelationsRec": "관계 인스턴스를 추가하거나 관계 정의를 검토하세요",
    "undefinedTypes": "미정의 타입",
    "undefinedTypesDesc": "{{count}}개 클래스에 클래스 타입이 지정되지 않음",
    "undefinedTypesRec": "모든 클래스에 적절한 타입을 지정하세요",
    "incompleteRelations": "불완전한 관계",
    "incompleteRelationsDesc": "{{count}}개 관계에 시작 또는 대상 클래스가 누락됨",
    "incompleteRelationsRec": "관계 정의를 완성하세요",
    "hubClasses": "허브 클래스",
    "hubClassesDesc": "일부 클래스가 매우 많은 연결을 가지고 있습니다",
    "hubClassesRec": "허브 클래스의 역할을 검토하고 필요시 분리를 고려하세요",
    "underutilizedRelations": "활용도 낮은 관계",
    "underutilizedRelationsDesc": "일부 관계가 평균보다 훨씬 적게 사용됨",
    "underutilizedRelationsRec": "관계의 필요성을 검토하거나 더 많은 인스턴스 추가를 고려하세요",
    "moreRelations": "관계 부족",
    "moreRelationsDesc": "{{classes}}개 클래스 대비 {{relations}}개의 관계만 정의됨",
    "moreRelationsRec": "클래스 간 더 많은 관계를 정의하여 온톨로지를 풍부하게 만드세요"
  },
  "reportCreator": {
    "title": "새 리포트 만들기",
    "steps": {
      "type": "유형 선택",
      "dataSource": "데이터 소스",
      "layout": "레이아웃",
      "preview": "미리보기"
    },
    "back": "이전",
    "next": "다음",
    "create": "리포트 생성",
    "typeSelect": {
      "basicInfo": "기본 정보",
      "reportName": "리포트 이름",
      "reportNamePlaceholder": "예: 월간 비용 분석 리포트",
      "description": "설명",
      "descriptionPlaceholder": "리포트에 대한 간단한 설명을 입력하세요",
      "category": "리포트 유형",
      "categoryHint": "분석하려는 데이터 유형에 맞는 카테고리를 선택하세요"
    },
    "categories": {
      "cost": "비용 분석",
      "costDesc": "제조 비용, 원가 구조 분석",
      "process": "공정 효율",
      "processDesc": "공정 흐름, 효율성 분석",
      "resource": "자원 활용",
      "resourceDesc": "자원 배분, 활용도 분석",
      "trend": "트렌드 분석",
      "trendDesc": "시계열 데이터, 추세 분석",
      "custom": "커스텀",
      "customDesc": "사용자 정의 분석"
    },
    "dataSource": {
      "title": "데이터 소스 선택",
      "hint": "분석에 사용할 데이터 소스를 선택하세요 (복수 선택 가능)",
      "selected": "{{count}}개 선택됨",
      "noDataSources": "사용 가능한 데이터 소스가 없습니다"
    },
    "layout": {
      "title": "레이아웃 선택",
      "hint": "리포트의 기본 레이아웃을 선택하세요",
      "default": "기본",
      "defaultDesc": "표준 대시보드 레이아웃",
      "compact": "컴팩트",
      "compactDesc": "좁은 화면에 최적화",
      "wide": "와이드",
      "wideDesc": "넓은 화면에 최적화",
      "dashboard": "대시보드",
      "dashboardDesc": "다양한 위젯 배치"
    },
    "preview": {
      "title": "설정 확인",
      "hint": "아래 내용을 확인하고 리포트를 생성하세요.",
      "reportName": "리포트 이름",
      "description": "설명",
      "category": "리포트 유형",
      "dataSources": "데이터 소스",
      "layout": "레이아웃",
      "info": "리포트 생성 후 위젯을 추가하고 레이아웃을 자유롭게 수정할 수 있습니다."
    }
  },
  "widgets": {
    "kpi": {
      "errors": {
        "loadFailed": "KPI 데이터를 불러오는데 실패했습니다",
        "noConfig": "KPI 설정이 없습니다",
        "noData": "데이터가 없습니다"
      },
      "comparison": {
        "previousPeriod": "전기 대비",
        "target": "목표 대비"
      }
    },
    "aiChat": {
      "placeholder": "데이터에 대해 질문하세요",
      "inputPlaceholder": "질문을 입력하세요...",
      "thinking": "생각 중...",
      "loadingDataSources": "데이터 소스 로딩 중...",
      "dataSourcesLoaded": "{{count}}개 데이터 소스 연결됨",
      "setupApiKey": "API 키 설정",
      "llmNotConfiguredAlert": "AI 채팅을 사용하려면 LLM API 키를 설정해주세요.",
      "apiKeyRequired": "API 키를 입력해주세요",
      "builtinNoApiKey": "빌트인 엔진은 API 키 없이 바로 사용할 수 있습니다. 저장을 누르면 사용 가능 여부를 확인합니다.",
      "errors": {
        "responseError": "응답을 받는데 실패했습니다. 다시 시도해주세요."
      }
    },
    "image": {
      "clickToUpload": "클릭하여 이미지 업로드",
      "urlPlaceholder": "이미지 URL 입력",
      "orAddByUrl": "또는 URL로 추가",
      "change": "변경",
      "errors": {
        "fileTooLarge": "파일 크기는 5MB 이하여야 합니다",
        "invalidFileType": "이미지 파일만 업로드 가능합니다"
      }
    }
  },
  "ragManagement": {
    "title": "RAG 인덱스 관리",
    "description": "RAG(Retrieval-Augmented Generation) 인덱스를 관리합니다",
    "selectProject": "프로젝트를 먼저 선택해주세요",
    "indexStatus": "인덱스 상태",
    "indexExists": "인덱스 존재 여부",
    "documentCount": "문서 수",
    "collectionName": "컬렉션 이름",
    "lastIndexed": "마지막 인덱싱",
    "noIndex": "인덱스가 없습니다",
    "forceReindex": "강제 재인덱싱",
    "createIndex": "인덱스 생성",
    "updateIndex": "인덱스 갱신",
    "deleteIndex": "인덱스 삭제",
    "indexSuccess": "{{count}}개의 문서가 {{time}}초 만에 인덱싱되었습니다",
    "deleteSuccess": "인덱스가 삭제되었습니다",
    "testSearch": "테스트 검색",
    "testSearchPlaceholder": "검색어를 입력하세요...",
    "runSearch": "검색 실행",
    "indexRequired": "검색하려면 먼저 인덱스를 생성하세요",
    "searchResults": "검색 결과",
    "resultCount": "{{count}}개 결과",
    "noResults": "결과 없음",
    "metadata": "메타데이터",
    "deleteConfirmTitle": "인덱스 삭제 확인",
    "deleteConfirmMessage": "정말 RAG 인덱스를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
    "errors": {
      "loadFailed": "인덱스 정보를 불러오는데 실패했습니다",
      "indexFailed": "인덱싱에 실패했습니다",
      "deleteFailed": "인덱스 삭제에 실패했습니다",
      "searchFailed": "검색에 실패했습니다"
    }
  },
  "chartPalette": {
    "default": "기본",
    "colorful": "다채로움",
    "pastel": "파스텔",
    "monoBlue": "블루 계열",
    "monoGreen": "그린 계열",
    "monoOrange": "오렌지 계열",
    "business": "비즈니스",
    "earth": "어스 톤",
    "ocean": "오션",
    "sunset": "선셋",
    "retro": "레트로",
    "neon": "네온"
  },
  "breadcrumb": {
    "settings": "설정"
  },
  "toast": {
    "defaultSuccess": "작업이 완료되었습니다",
    "defaultError": "오류가 발생했습니다"
  },
  "addDataSource": {
    "steps": {
      "upload": "파일 업로드",
      "mapping": "컬럼 매핑",
      "validate": "ID 검증",
      "confirm": "확인 및 실행"
    },
    "confirmSummary": "저장 위치 확인",
    "targetLayer": "대상 레이어",
    "dataType": "데이터 유형",
    "instance": "인스턴스",
    "relationship": "관계",
    "fileName": "파일"
  },
  "layerManagement": {
    "matrix": {
      "title": "속성 × 차원 종속성 매트릭스",
      "description": "각 데이터 속성이 어떤 차원(레이어 스키마)에 종속되는지 설정합니다.",
      "property": "데이터 속성",
      "loadError": "데이터를 불러오는데 실패했습니다.",
      "updateError": "종속성 업데이트에 실패했습니다.",
      "noProperties": "데이터 속성이 없습니다.",
      "noSchemas": "레이어 스키마가 없습니다."
    }
  },
  "costAnalysis": {
    "year": "년",
    "month": "월",
    "dimensionSelect": "분석 차원",
    "compareDimension": "비교 차원",
    "fetchSummary": "원가 조회",
    "calculate": "적산 계산",
    "compare": "비교",
    "tooltips": {
      "selectProjectFirst": "프로젝트를 먼저 선택하세요",
      "selectDimensionFirst": "분석 차원을 먼저 선택하세요",
      "selectCompareDimension": "비교할 차원을 선택하세요"
    }
  },
  "auditLog": {
    "title": "감사 로그",
    "empty": "감사 로그가 없습니다",
    "loadError": "감사 로그를 불러오지 못했습니다",
    "searchPlaceholder": "이름, ID, 설명으로 검색...",
    "filterAction": "액션",
    "filterEntityType": "엔티티 타입",
    "dateFrom": "시작일",
    "dateTo": "종료일",
    "all": "전체",
    "rowsPerPage": "페이지당 행 수",
    "noData": "데이터 없음",
    "before": "변경 전",
    "after": "변경 후",
    "changeDetail": "변경 상세",
    "columns": {
      "time": "시간",
      "user": "사용자",
      "action": "액션",
      "entityType": "엔티티 타입",
      "target": "대상",
      "description": "설명"
    }
  },
  "exportOntology": {
    "title": "온톨로지 내보내기",
    "project": "프로젝트",
    "scope": "내보내기 범위",
    "schema": "스키마",
    "instances": "인스턴스",
    "tboxDesc": "클래스, 속성, 관계 정의",
    "aboxDesc": "인스턴스 데이터 (Named Graph 포함)",
    "format": "내보내기 형식",
    "triples": "트리플",
    "previewError": "미리보기를 불러올 수 없습니다",
    "downloadError": "다운로드에 실패했습니다",
    "downloadSuccess": "다운로드 완료"
  },
  "simulation": {
    "title": "What-if 시뮬레이션",
    "description": "파라미터를 변경하여 원가 변동을 예측합니다",
    "createScenario": "시나리오 생성",
    "scenarioName": "시나리오 이름",
    "scenarioDescription": "설명 (선택)",
    "dimensionKey": "차원 키",
    "dimensionValue": "차원 값",
    "baseline": "기준 차원",
    "overridesCount": "오버라이드 수",
    "run": "실행",
    "runSimulation": "시뮬레이션 실행",
    "edit": "편집",
    "delete": "삭제",
    "duplicate": "복제",
    "viewResult": "결과 보기",
    "result": "결과",
    "empty": "시나리오가 없습니다",
    "emptyDescription": "What-if 시나리오를 생성하여 원가 변동을 예측해보세요",
    "createFirst": "첫 시나리오 생성",
    "confirmDelete": "이 시나리오를 삭제하시겠습니까?",
    "loadError": "시나리오 목록을 불러올 수 없습니다",
    "createError": "시나리오 생성에 실패했습니다",
    "saveError": "시나리오 저장에 실패했습니다",
    "loadParametersError": "오버라이드 가능한 파라미터를 불러올 수 없습니다",
    "deleteError": "삭제에 실패했습니다",
    "duplicateError": "복제에 실패했습니다",
    "runError": "시뮬레이션 실행에 실패했습니다",
    "noResult": "결과가 없습니다. 시뮬레이션을 실행해주세요.",
    "noParameters": "오버라이드 가능한 파라미터가 없습니다",
    "parameterOverrides": "파라미터 오버라이드",
    "paramClass": "클래스",
    "paramName": "이름",
    "paramProperty": "속성",
    "currentValue": "현재 값",
    "newValue": "변경 값",
    "changePct": "변화율",
    "unitCost": "단가",
    "usageAmount": "사용량",
    "baselineCost": "기준 원가",
    "scenarioCost": "시나리오 원가",
    "costDelta": "원가 변동",
    "impactSummary": "영향도 요약",
    "affectedActivities": "영향 받는 Activity",
    "affectedActivityGroups": "영향 받는 Activity Group",
    "affectedProducts": "영향 받는 Product",
    "activityComparison": "Activity별 비교",
    "activityGroupComparison": "Activity Group별 비교",
    "productComparison": "Product별 비교"
  },
  "anomaly": {
    "title": "이상 탐지",
    "description": "ML 알고리즘을 사용하여 비용 데이터의 이상치를 자동 탐지합니다",
    "noProject": "프로젝트를 선택해주세요",
    "runDetection": "이상 탐지 실행",
    "detectionComplete": "{{total}}건의 이상치 탐지 완료 (신규 {{new_count}}건)",
    "loadError": "이상 탐지 데이터를 불러올 수 없습니다",
    "detectError": "이상 탐지 실행에 실패했습니다",
    "updateError": "상태 업데이트에 실패했습니다",
    "clearError": "초기화에 실패했습니다",
    "confirmClear": "모든 이상 탐지 기록을 삭제하시겠습니까?",
    "totalAnomalies": "전체 이상치",
    "openCount": "미확인",
    "criticalCount": "심각",
    "resolvedCount": "해결됨",
    "filterStatus": "상태",
    "filterSeverity": "심각도",
    "statusOpen": "미확인",
    "statusAcknowledged": "확인됨",
    "statusResolved": "해결됨",
    "statusSuppressed": "억제됨",
    "clearAll": "전체 삭제",
    "empty": "탐지된 이상치가 없습니다",
    "emptyDescription": "이상 탐지를 실행하여 비용 데이터를 분석해보세요",
    "colSeverity": "심각도",
    "colEntity": "엔티티",
    "colClass": "클래스",
    "colProperty": "속성",
    "colValue": "현재 값",
    "colExpected": "예상 값",
    "colDeviation": "편차(%)",
    "colMethod": "탐지 방법",
    "colStatus": "상태",
    "resolve": "해결 처리",
    "suppress": "억제 처리",
    "configTitle": "이상 탐지 설정",
    "configEnabled": "자동 탐지 활성화",
    "configContamination": "오염 비율",
    "configContaminationHelp": "예상 이상치 비율 (0.01 ~ 0.5)",
    "configZScore": "Z-Score 임계값",
    "configIqr": "IQR 배수"
  },
  "version": {
    "title": "버전 관리",
    "description": "온톨로지 스키마 버전 스냅샷을 추적하고 관리합니다",
    "noProject": "프로젝트를 먼저 선택해주세요",
    "createSnapshot": "스냅샷 생성",
    "createSuccess": "버전 스냅샷이 생성되었습니다",
    "createError": "버전 스냅샷 생성에 실패했습니다",
    "loadError": "버전 기록 로드에 실패했습니다",
    "compareVersions": "버전 비교",
    "fromVersion": "이전 버전",
    "toVersion": "비교 버전",
    "compare": "비교",
    "compareError": "버전 비교에 실패했습니다",
    "diffResult": "비교 결과",
    "diffClasses": "클래스",
    "diffProperties": "데이터 속성",
    "diffRelations": "관계",
    "diffLayers": "레이어 스키마",
    "diffKeyFields": "키 필드",
    "diffClassTypes": "클래스 타입",
    "rollback": "롤백",
    "rollbackConfirmTitle": "롤백 확인",
    "rollbackWarning": "롤백하면 현재 온톨로지 스키마가 선택한 버전으로 덮어씌워집니다. 이 작업은 취소할 수 없습니다. 새로운 버전 기록이 생성됩니다.",
    "rollbackTo": "v{{version}} ({{label}})으로 롤백하시겠습니까?",
    "rollbackSuccess": "선택한 버전으로 롤백되었습니다",
    "rollbackError": "롤백에 실패했습니다",
    "empty": "버전 기록 없음",
    "emptyDescription": "스냅샷을 생성하여 온톨로지 변경 이력 추적을 시작하세요",
    "createFirst": "첫 스냅샷 생성",
    "labelField": "레이블",
    "descriptionField": "설명"
  },
  "dbConnector": {
    "title": "외부 DB 커넥터",
    "description": "외부 데이터베이스(ERP/MES)에 연결하여 데이터를 온톨로지에 동기화합니다.",
    "noProject": "프로젝트를 먼저 선택해주세요.",
    "reset": "초기화",
    "back": "이전",
    "next": "다음",
    "steps": {
      "connect": "연결 설정",
      "explore": "스키마 탐색",
      "map": "매핑 설정",
      "sync": "동기화 실행"
    },
    "connection": {
      "newTitle": "새 DB 연결",
      "existingTitle": "기존 연결",
      "connected": "연결 완료",
      "dbType": "DB 타입",
      "name": "연결 이름",
      "host": "호스트",
      "port": "포트",
      "database": "데이터베이스",
      "schema": "스키마",
      "schemaHelp": "비워두면 기본 스키마 사용 (PostgreSQL: public, MSSQL: dbo)",
      "user": "사용자",
      "password": "비밀번호",
      "connectBtn": "연결 테스트 및 생성",
      "testing": "연결 테스트 중...",
      "failed": "연결 실패",
      "requiredFields": "호스트, 데이터베이스, 사용자는 필수 입력입니다."
    },
    "schema": {
      "title": "스키마 탐색",
      "loading": "스키마 로딩 중...",
      "tables": "테이블",
      "views": "뷰",
      "selectAll": "전체 선택/해제",
      "tableName": "테이블명",
      "columns": "컬럼",
      "rows": "행 수",
      "keys": "키",
      "preview": "미리보기",
      "previewTitle": "데이터 미리보기",
      "selectedCount": "{{count}}개 테이블 선택됨",
      "colName": "컬럼명",
      "colType": "타입",
      "colNullable": "Nullable 여부",
      "colDefault": "기본값",
      "colFlags": "플래그"
    },
    "mapping": {
      "title": "매핑 설정",
      "description": "각 테이블을 온톨로지 클래스에 매핑하고, 컬럼을 속성에 연결합니다.",
      "autoSuggest": "자동 매핑 제안",
      "targetClass": "대상 클래스",
      "noClass": "(매핑 안함)",
      "idColumn": "ID 컬럼",
      "dbColumn": "DB 컬럼",
      "dbType": "DB 타입",
      "ontologyProperty": "온톨로지 속성",
      "skip": "건너뛰기"
    },
    "sync": {
      "title": "동기화 실행",
      "summary": "{{tables}}/{{total}} 테이블이 매핑되어 동기화 준비 완료",
      "unmappedWarning": "{{count}}개 테이블이 매핑되지 않아 건너뜁니다.",
      "table": "테이블",
      "targetClass": "대상 클래스",
      "idColumn": "ID 컬럼",
      "status": "상태",
      "syncedRows": "동기화 행",
      "startSync": "동기화 시작",
      "running": "동기화 중...",
      "completed": "완료: 성공 {{success}}, 실패 {{error}}, 총 {{rows}}행 동기화",
      "statusPending": "대기",
      "statusRunning": "실행 중",
      "statusSuccess": "성공",
      "statusError": "실패"
    }
  },
  "workflow": {
    "tabs": {
      "designer": "워크플로우 디자이너",
      "approvals": "승인 대시보드"
    },
    "designer": {
      "title": "워크플로우 정의",
      "newWorkflow": "새 워크플로우",
      "editWorkflow": "워크플로우 편집",
      "empty": "정의된 워크플로우가 없습니다. 새 워크플로우를 만들어 보세요.",
      "name": "워크플로우 이름",
      "description": "설명",
      "triggerEvent": "트리거 이벤트",
      "webhookSecret": "웹훅 시크릿",
      "webhookSecretHint": "외부 호출자가 X-Workflow-Trigger-Secret 헤더로 보내야 하는 공유 시크릿입니다.",
      "webhookSecretKeepHint": "현재 설정된 시크릿을 유지하려면 비워 두세요.",
      "webhookEndpoint": "웹훅 엔드포인트",
      "webhookEndpointHint": "이 상대 경로로 JSON payload와 X-Workflow-Trigger-Secret 헤더를 보내면 됩니다.",
      "webhookEndpointAfterSave": "웹훅 엔드포인트는 저장 후 생성됩니다.",
      "failurePolicyTitle": "실패 정책",
      "failurePolicyHint": "자동 실행되는 schedule/webhook 워크플로우는 반복 실패 시 자동 억제되고, 필요하면 governed escalation 흐름을 만들 수 있습니다.",
      "failurePolicyAutoTriggerHint": "실패 정책은 자동 트리거가 켜져 있을 때 적용됩니다.",
      "failurePolicyEnabled": "실패 정책 활성화",
      "failurePolicyAutoSuppress": "반복 실패 시 자동 억제",
      "failurePolicyEscalateOnSuppress": "억제 시 에스컬레이션 생성",
      "failurePolicyMaxConsecutiveFailures": "최대 연속 실패 수",
      "autoTrigger": "자동 트리거",
      "steps": "스텝 구성",
      "stepName": "스텝 이름",
      "stepType": "스텝 타입",
      "assigneeRole": "담당 역할",
      "assigneeEmail": "담당자 이메일",
      "addStep": "스텝 추가"
    },
    "stepType": {
      "approval": "승인",
      "validation": "검증",
      "notification": "알림",
      "action": "액션",
      "wait": "대기",
      "branch": "분기"
    },
    "trigger": {
      "manual": "수동 시작",
      "schedule": "예약 실행",
      "chat": "채팅",
      "webhook": "웹훅",
      "workflow_trigger_suppressed": "워크플로우 트리거 억제",
      "data_upload": "데이터 업로드",
      "cost_calculation": "원가 계산",
      "connector_sync_completed": "커넥터 동기화 완료",
      "schema_change": "스키마 변경"
    },
    "status": {
      "queued": "대기열",
      "running": "실행 중",
      "waiting_for_approval": "승인 대기",
      "waiting_for_time": "시간 대기",
      "completed": "완료",
      "failed": "실패",
      "pending": "대기",
      "in_progress": "진행 중",
      "approved": "승인됨",
      "rejected": "거부됨",
      "cancelled": "취소됨",
      "timed_out": "시간 초과",
      "succeeded": "성공",
      "paused": "일시 중지 (승인 대기)"
    },
    "stepStatus": {
      "queued": "대기열",
      "running": "실행 중",
      "waiting_for_approval": "승인 대기",
      "waiting_for_time": "시간 대기",
      "pending": "대기",
      "in_progress": "진행 중",
      "completed": "완료",
      "failed": "실패",
      "rejected": "거부",
      "cancelled": "취소",
      "skipped": "건너뜀"
    },
    "active": "활성",
    "inactive": "비활성",
    "instances": "건",
    "start": "시작",
    "step": "스텝",
    "defaultStepName": "승인",
    "confirmDelete": "이 워크플로우를 삭제하시겠습니까?",
    "approval": {
      "title": "승인 대시보드",
      "pendingTab": "대기 중인 승인",
      "instancesTab": "워크플로우 인스턴스",
      "noPending": "대기 중인 승인 요청이 없습니다.",
      "noInstances": "워크플로우 인스턴스가 없습니다.",
      "workflow": "워크플로우",
      "step": "스텝",
      "summary": "요약",
      "objectContext": "대상 / 액션",
      "actionContext": "액션",
      "graphKind": "그래프 종류",
      "allActionTypes": "전체 액션",
      "allGraphKinds": "전체 Graph Kind",
      "searchPlaceholder": "워크플로우, 대상, 액션으로 검색...",
      "requestedAt": "요청 시간",
      "actions": "액션",
      "approve": "승인",
      "revise": "수정 요청",
      "reject": "거부",
      "approveTitle": "승인 확인",
      "reviseTitle": "수정 요청 확인",
      "rejectTitle": "거부 확인",
      "comment": "코멘트",
      "commentPlaceholder": "승인/거부 사유를 입력하세요 (선택)",
      "viewInstance": "인스턴스 보기",
      "viewDetail": "상세 보기",
      "openObjectView": "Object Explorer에서 보기",
      "cancel": "취소",
      "resume": "재개",
      "confirmCancel": "이 워크플로우를 취소하시겠습니까?",
      "instanceDetail": "워크플로우 인스턴스 상세",
      "instanceId": "인스턴스 ID",
      "status": "상태",
      "initiatedBy": "시작자",
      "startedAt": "시작 시간",
      "stepsProgress": "스텝 진행 상황",
      "result": "결과"
    },
    "dryRun": {
      "_reserved": "(예약됨)"
    },
    "proposedWriteDiff": {
      "_reserved": "(예약됨)"
    },
    "riskExplanation": {
      "_reserved": "(예약됨)"
    },
    "sourcePreview": {
      "_reserved": "(예약됨)"
    },
    "nodePalette": {
      "_reserved": "(예약됨)"
    },
    "validation": {
      "_reserved": "(예약됨)"
    },
    "stepIo": {
      "_reserved": "(예약됨)"
    },
    "stepRun": {
      "_reserved": "(예약됨)"
    },
    "approvalDecision": {
      "_reserved": "(예약됨)",
      "aiReviewDraft": "AI 검토 초안",
      "approve": "승인",
      "comment": "코멘트",
      "decision": "결정",
      "downstreamObjectRefs": "다운스트림 오브젝트 참조",
      "errors": {
        "submitFailed": "승인 처리에 실패했습니다."
      },
      "initiatedBy": "{{user}} 시작",
      "proposedGraphWrites": "제안된 그래프 쓰기",
      "reject": "거부",
      "retry": "재시도",
      "revise": "수정",
      "riskExplanation": "위험 설명",
      "sourceObjectPreview": "소스 오브젝트 미리보기"
    },
    "credentialSlot": {
      "_reserved": "(예약됨)"
    },
    "graphWrite": {
      "_reserved": "(예약됨)",
      "empty": "이 스텝에 대한 그래프 쓰기가 없습니다.",
      "ontologyEvidence": "온톨로지 증거",
      "policyActions": "정책 액션: {{actions}}",
      "recovery": "그래프 쓰기 복구: {{failureClass}}",
      "retryAvailable": "재시도/재실행 가능",
      "retryNotRecommended": "재시도 권장 안 함",
      "reviewRequired": "검토 필요",
      "rollbackNotSupported": "롤백 지원 안 함"
    },
    "nodeConfig": {
      "_reserved": "(예약됨)"
    },
    "ontologyCapture": {
      "_reserved": "(예약됨)"
    },
    "executionTimeline": {
      "_reserved": "(예약됨)",
      "approvalEvents": "승인 이벤트",
      "attempts": "시도 {{attempt}}/{{total}}",
      "byApprover": "{{approver}} 처리",
      "category": "카테고리: {{category}}",
      "finalArtifacts": "최종 산출물",
      "lastRetry": "마지막 재시도 @ {{time}}",
      "recovery": {
        "failureCause": "실패 원인: {{cause}}",
        "graphWriteDetails": "롤백: 이 화면에서는 지원되지 않습니다. 보상: {{compensation}}. 정책 액션: {{actions}}.",
        "graphWriteFailed": "그래프 쓰기 실패",
        "graphWriteSummary": "그래프 쓰기가 실패했습니다. 멱등성 증거와 그래프 참조를 검토한 후에만 재시도/재실행을 사용하세요.",
        "noFailureCause": "실패 원인이 기록되지 않았습니다. 입력/출력 패널과 graph write 결과를 확인하세요.",
        "none": "없음",
        "notAvailable": "사용할 수 없음",
        "openRetryReplay": "재시도/재실행 열기",
        "retryDisabled": "재시도 콜백(onRetryStep)이 연결되어 있지 않아 이 화면에서 재실행할 수 없습니다. Workflow Replay 화면에서 다시 시도하세요.",
        "retryStep": "이 단계 재시도/재실행",
        "stepFailed": "이 단계가 실패했습니다"
      },
      "retryPolicy": "재시도 {{maxRetries}}× / 백오프 {{backoffSeconds}}s{{timeout}}",
      "retryRuns": "재시도 실행: {{count}}",
      "timeoutSuffix": " / 타임아웃 {{timeoutSeconds}}s"
    },
    "replay": {
      "_reserved": "(예약됨)"
    },
    "run": {
      "stopTooltip": "이 워크플로 실행을 중지합니다",
      "confirmStop": "이 워크플로 실행을 중지할까요? 중지한 실행은 다시 이어서 실행할 수 없습니다.",
      "stopped": "워크플로 실행을 중지했습니다."
    }
  },
  "lineage": {
    "title": "데이터 리니지",
    "nodes": "노드",
    "edges": "연결",
    "noData": "리니지 데이터가 없습니다.",
    "noDataHint": "데이터를 업로드하거나 원가를 계산하면 리니지가 자동으로 기록됩니다.",
    "detail": "노드 상세",
    "status": "상태",
    "createdBy": "생성자",
    "createdAt": "생성일시",
    "metadata": "메타데이터",
    "upstream": "업스트림 (데이터 소스)",
    "downstream": "다운스트림 (소비처)",
    "nodeType": {
      "csvFile": "CSV 파일",
      "rdfGraph": "RDF 그래프",
      "namedGraph": "Named Graph",
      "classInstances": "클래스 인스턴스",
      "costCalculation": "원가계산",
      "dashboardWidget": "대시보드 위젯",
      "export": "내보내기"
    },
    "edgeType": {
      "upload": "업로드",
      "transform": "변환",
      "store": "저장",
      "consume": "소비",
      "calculate": "계산",
      "visualize": "시각화",
      "export": "내보내기"
    },
    "viewInReport": "리포트에서 보기"
  },
  "lineageDialog": {
    "title": "데이터 출처",
    "noData": "이 위젯의 리니지 데이터가 아직 없습니다.",
    "error": "리니지 데이터를 불러올 수 없습니다.",
    "currentWidget": "현재 위젯",
    "openExplorer": "리니지 탐색기에서 보기"
  },
  "topNav": {
    "menu": {
      "project": "프로젝트",
      "designer": "디자이너",
      "operate": "운영",
      "ontology": "온톨로지 관리",
      "data": "데이터",
      "autoInsight": "Auto Insight"
    },
    "masterOnly": "마스터",
    "selectLayer": "레이어 선택",
    "noLayers": "레이어 없음",
    "packAuthoring": "Ready Made Pack 작성 (관리자 전용)"
  },
  "comments": {
    "title": "코멘트",
    "noThreads": "아직 코멘트가 없습니다",
    "startThread": "새 코멘트 시작",
    "newThread": "새 스레드",
    "writeComment": "코멘트를 입력하세요...",
    "addComment": "코멘트 추가...",
    "editComment": "코멘트 수정",
    "edited": "수정됨",
    "open": "열림",
    "resolved": "해결됨",
    "resolve": "해결로 표시",
    "reopen": "다시 열기",
    "resolvedBy": "해결자:",
    "online": "명 접속 중",
    "activeUsers": "현재 접속 중인 사용자"
  },
  "queryBuilder": {
    "title": "비주얼 쿼리 빌더",
    "selectClass": "클래스 선택",
    "class": "클래스",
    "selectProperties": "속성 선택",
    "noProperties": "속성이 없습니다",
    "filters": "필터",
    "property": "속성",
    "value": "값",
    "addFilter": "필터 추가",
    "aggregation": "집계",
    "groupBy": "그룹 기준",
    "aggregations": "집계 함수",
    "addAggregation": "집계 추가",
    "orderLimit": "정렬 및 제한",
    "orderBy": "정렬 기준",
    "generatedSparql": "생성된 SPARQL",
    "noQuery": "쿼리를 구성해주세요",
    "testQuery": "쿼리 테스트",
    "applyToWidget": "위젯에 적용",
    "results": "결과",
    "rows": "건",
    "generated": "쿼리 생성 완료"
  },
  "templates": {
    "title": "대시보드 템플릿",
    "description": "사전 정의된 템플릿으로 빠르게 대시보드를 구성하세요",
    "widgets": "위젯",
    "includedWidgets": "포함된 위젯",
    "useTemplate": "이 템플릿 사용",
    "category": {
      "cost": "비용 분석",
      "process": "공정 분석",
      "resource": "자원 활용",
      "trend": "트렌드",
      "custom": "커스텀"
    },
    "costOverview": {
      "name": "비용 현황 대시보드",
      "description": "전체 비용 구조와 분류를 한눈에 파악할 수 있는 대시보드",
      "totalCost": "총 비용",
      "avgStepCost": "공정단계별 평균 비용",
      "resourceCount": "자원 수",
      "processCount": "공정 수",
      "costBreakdown": "비용 분해 (워터폴)",
      "costByType": "유형별 비용 비율",
      "costByStep": "공정단계별 비용"
    },
    "processAnalysis": {
      "name": "Activity 분석 대시보드",
      "description": "Activity와 Activity Group별 비용과 효율성을 분석하는 대시보드",
      "stepCount": "전체 Activity 수",
      "avgCostPerStep": "Activity당 평균 비용",
      "totalProcesses": "전체 Activity Group 수",
      "costByProcess": "Activity Group별 비용 비교",
      "costTreemap": "비용 트리맵",
      "stepDetail": "Activity 상세"
    },
    "resourceUtil": {
      "name": "자원 활용 대시보드",
      "description": "Resource 클래스별 비용과 활용도 분석",
      "equipmentCount": "Resource 수",
      "materialCount": "Resource 클래스 수",
      "laborCount": "사용 Activity 수",
      "totalResourceCost": "총 자원 비용",
      "costByResourceType": "자원 유형별 비용",
      "topEquipmentCost": "Resource별 비용 상위",
      "resourceDetail": "자원 상세 목록"
    },
    "trendAnalysis": {
      "name": "트렌드 분석 대시보드",
      "description": "비용 변화 추이와 월별 트렌드를 분석하는 대시보드",
      "costTrend": "비용 추이",
      "latestCost": "최신 비용",
      "costChange": "비용 변동률",
      "costVsVolume": "비용 대 생산량",
      "cumulativeCost": "누적 비용"
    }
  },
  "streaming": {
    "title": "실시간 스트리밍 모니터",
    "live": "실시간",
    "start": "소비자 시작",
    "stop": "소비자 중지",
    "published": "발행됨",
    "processed": "처리됨",
    "throughput": "처리량",
    "avgLatency": "평균 지연",
    "errors": "에러",
    "errorRate": "에러율",
    "uptime": "가동 시간",
    "recentEvents": "최근 이벤트",
    "recentErrors": "최근 에러",
    "eventType": "이벤트 유형",
    "user": "사용자",
    "time": "시간",
    "payload": "페이로드",
    "errorMessage": "에러 메시지",
    "actions": "작업",
    "retry": "재시도",
    "waitingForEvents": "이벤트 대기 중...",
    "enableLive": "실시간 모드를 활성화하세요",
    "noErrors": "에러가 없습니다",
    "noDLQ": "Dead Letter Queue가 비어있습니다"
  },
  "aiBuild": {
    "packGrounding": {
      "badgeWithScore": "이 제안은 {{packName}} 팩에 근거합니다 (매칭도 {{score}}%).",
      "badge": "이 제안은 {{packName}} 팩에 근거합니다.",
      "regenerate": "팩 없이 다시 생성",
      "disabled": "이 제안은 팩 없이 intent 만으로 생성되었습니다."
    },
    "agent": {
      "toggle": "에이전트 루프",
      "thinking": "Agent가 생각 중입니다...",
      "toolCall": "도구 호출",
      "clarification": "확인 질문",
      "cancel": "Agent 취소",
      "completed": "완료됨"
    },
    "recovery": {
      "missing_project": {
        "title": "프로젝트 필요",
        "detail": "AI Build는 플래너 오케스트레이션 실행이나 연동 제안 저장 전에 활성 프로젝트가 필요합니다.",
        "action": "프로젝트 선택 또는 생성"
      },
      "missing_grounding": {
        "title": "프로젝트 그라운딩 필요",
        "detail": "설치된, 활성화된, 플래너 사용 가능한 프로젝트 컨텍스트를 찾을 수 없습니다. 팩을 설치하거나 커넥터/자격 증명을 활성화한 후 플래너를 실행하세요.",
        "action": "프로젝트 설정 열기"
      },
      "missing_pack": {
        "title": "Ready Made Pack 필요",
        "detail": "워크플로우, 스키마, 리포트 제안을 채택하기 전에 promoted pack을 선택하거나 AI Build에 추천을 요청하세요.",
        "action": "Ready Made Pack 열기"
      },
      "missing_connector": {
        "title": "커넥터 필요",
        "detail": "요청한 소스에 사용 가능한 커넥터 기능이 없습니다. 지원되는 커넥터를 추가하거나 샘플/CSV 데이터로 전환하세요.",
        "action": "커넥터 열기"
      },
      "missing_credential": {
        "title": "자격 증명 누락",
        "detail": "커넥터는 존재하지만 필수 자격 증명 슬롯이 바인딩되지 않았습니다. AI Build에 원시 비밀을 붙여넣지 말고 승인된 자격 증명을 바인딩하세요.",
        "action": "자격 증명 설정 열기"
      },
      "permission_denied": {
        "title": "권한 필요",
        "detail": "현재 역할로는 이 플래너 작업을 실행하거나 참조된 도구에 접근할 수 없습니다. 접근 권한을 요청하거나 승인된 프로젝트/도구를 선택하세요.",
        "action": "권한 검토"
      },
      "provider_unavailable": {
        "title": "AI 프로바이더 사용 불가",
        "detail": "프로바이더가 사용 가능한 플래너 출력을 반환하지 않았습니다. AI Build는 폴백 초안을 만들지 않습니다. 프로바이더 설정을 확인하거나 정상 상태일 때 다시 시도하세요.",
        "action": "프로바이더 설정 열기"
      },
      "provider_unconfigured": {
        "title": "AI 프로바이더 미구성",
        "detail": "프로바이더, 모델, 필수 자격 증명이 구성될 때까지 AI Build는 플래너 프로바이더를 호출할 수 없습니다. 폴백 초안 콘텐츠는 생성되지 않았습니다.",
        "action": "프로바이더 설정 열기"
      },
      "missing_data": {
        "title": "데이터 소스 필요",
        "detail": "샘플 데이터를 첨부하거나 CSV 컨텍스트를 업로드하거나 연결된 데이터베이스/API/웨어하우스/레이크하우스 소스를 선택하세요.",
        "action": "데이터 소스 선택"
      },
      "missing_intent": {
        "title": "비즈니스 의도 필요",
        "detail": "AI Build가 지원해야 할 의사결정, 지표, 예외 또는 운영 질문을 설명하세요.",
        "action": "의도 설명"
      },
      "missing_output": {
        "title": "출력 대상 필요",
        "detail": "AI Build가 팩, 스키마, 워크플로우, 리포트 또는 커넥터 요구사항을 준비할지 알 수 있도록 최소 하나의 대상을 선택하세요.",
        "action": "출력 선택"
      },
      "title": "필요 조건"
    },
    "adoption": {
      "workflowBanner": {
        "title": "AI Build에서 생성됨",
        "body": "AI Build 제안 \"{{label}}\"으로 임시 초안이 생성되었습니다. 단계를 검토한 뒤 저장을 눌러 영구 저장하세요.",
        "projectMismatchTitle": "AI Build 핸드오프가 다른 프로젝트용입니다",
        "projectMismatch": "AI Build 제안 \"{{label}}\"은 다른 프로젝트에서 생성되어 여기서는 적용되지 않았습니다. 원래 프로젝트로 전환하여 적용하세요.",
        "dismiss": "닫기"
      },
      "dialog": {
        "title": "플랜 채택 확인",
        "description": "이 플랜을 채택하면 선택한 제안들이 대상 에디터에 미저장 초안으로 적재됩니다. 도착 후 각 초안을 검토하고 저장할 수 있습니다.",
        "group": {
          "workflow": "Workflow Canvas",
          "ontology": "Ontology Graph",
          "report": "Report Builder",
          "route": "경로: {{route}}"
        },
        "skipNotAccepted": "건너뜀 — 아직 수락되지 않음",
        "skipSummary": "수락되지 않은 제안 {{count}}건은 건너뜁니다.",
        "emptyAdoptable": "연결된 제안 중 에디터 초안으로 채택할 수 있는 항목이 없습니다.",
        "noneAccepted": "아직 Accept 된 제안이 없어 채택할 수 없습니다. 리뷰 카드 또는 “라이프사이클” 에서 각 제안의 “Accept” 를 먼저 누르세요.",
        "confirm": "{{count}}건 채택",
        "error": "채택에 실패했습니다. 다시 시도하거나 제안 증거를 확인하세요."
      },
      "snackbar": {
        "draftLoaded": "AI Build 초안 로드됨 — 검토 후 저장: \"{{label}}\"",
        "draftLoaded_plural": "AI Build 초안 로드됨 ({{count}}건) — 검토 후 저장"
      }
    },
    "title": "AI 빌드",
    "description": "비즈니스 의도를 한 번 입력하면 워크플로 / 온톨로지 / 리포트 초안이 함께 생성됩니다.",
    "intake": {
      "title": "무엇을 만들고 싶으신가요?",
      "businessIntent": "비즈니스 의도",
      "businessIntentPlaceholder": "예: 물류비가 오르는 이유를 찾고 주간 예외 리포트를 생성한다.",
      "industry": "산업",
      "department": "부서 또는 직무",
      "desiredOutputs": "원하는 결과물",
      "industryHelp": "플래너가 산업 맥락으로 proposal 정확도를 높입니다.",
      "departmentHelp": "플래너가 부서 맥락으로 proposal 정확도를 높입니다.",
      "dataSourceHelp": "플래너가 connector 요건 추정에 사용합니다 — 여기서 데이터를 업로드하지는 않습니다.",
      "sampleUploadHint": "샘플 데이터셋이 필요하면 Project > Ready Made Packs 에서 설치하세요."
    },
    "summary": {
      "businessFallback": "비즈니스",
      "generalFallback": "일반",
      "intent": "{{industry}} 컨텍스트의 {{department}} 의도: {{intent}}",
      "needsIntent": "AI Build 가 readiness 를 평가하려면 비즈니스 의도가 먼저 필요합니다.",
      "withOutputs": "{{summary}} 기대 출력: {{outputs}}."
    },
    "outputs": {
      "input": {
        "readyMadePack": "Ready-made pack",
        "ontologyCapture": "온톨로지 캡처",
        "workflow": "워크플로",
        "report": "리포트",
        "connectorRequirements": "커넥터 요건"
      },
      "summary": {
        "ready_made_pack": "Ready-made pack 추천",
        "ontology_capture": "스키마 · 캡처 제안",
        "workflow": "워크플로 초안",
        "report": "리포트 초안",
        "connector_requirements": "커넥터 · 자격증명 요구"
      }
    },
    "dataSources": {
      "none": "아직 없음",
      "sample": "샘플 데이터",
      "csv": "CSV 또는 스프레드시트",
      "database": "데이터베이스",
      "api": "API",
      "warehouse": "데이터 웨어하우스"
    },
    "nextAction": {
      "title": "다음 단계 안내"
    },
    "actions": {
      "analyseIntent": "AI 빌드 분석",
      "buildWorkflow": "선택한 출력으로 AI 빌드 실행",
      "startNew": "새 빌드 시작",
      "viewDetails": "빌드 상세 보기"
    },
    "kpi": {
      "readiness": "입력 상태: {{value}}",
      "proposalsCount": "제안: {{count}}",
      "fallbackDraft": "대안 초안: {{value}}",
      "manifestVersion": "manifest: {{value}}",
      "manifestHash": "hash: {{value}}",
      "plannerInvoked": "플래너 실행: {{value}}",
      "tooltips": {
        "readiness": "의도 / 프로젝트 / 출력 / 그라운딩 4가지가 모두 충족되면 ready_for_planner 입니다.",
        "plannerInvoked": "백엔드 플래너 orchestrate API 호출 여부.",
        "fallbackDraft": "플래너가 실패하면 백엔드가 대안 초안을 자동 생성합니다.",
        "proposalsCount": "플래너가 만든 surface 별 초안 (workflow / ontology / report) 의 개수."
      }
    },
    "planner": {
      "stages": "플래너 단계",
      "runningTitle": "플래너 실행 중",
      "runningDescription": "AI Build 가 프로젝트 범위 플래너 호출을 시작했습니다. 이 화면을 닫지 마세요 — 최종 결과는 단계별 성공/실패로 표시되고 폴백 초안은 만들지 않습니다.",
      "stageCompleted": "플래너 단계 완료",
      "errorTitle": "플래너 오류"
    },
    "drawer": {
      "title": "빌드 상세",
      "subtitle": "이 빌드의 핸드오프, 라이프사이클, 증거, 프로젝트 컨텍스트 매니페스트.",
      "tabs": {
        "handoff": "상세 정보",
        "lifecycle": "라이프사이클",
        "evidence": "증거",
        "manifest": "컨텍스트 매니페스트"
      }
    },
    "linkedProposal": {
      "title": "연계 제안",
      "subtitle": "이 단계의 산출물을 검토하세요. 에디터로 채택은 P5-022 에서 처리됩니다."
    },
    "handoffs": {
      "title": "핸드오프 대상"
    },
    "status": {
      "ready_for_planner": "플래너 실행 준비됨",
      "needs_intent": "의도 필요",
      "needs_project": "프로젝트 필요",
      "needs_outputs": "출력 선택 필요",
      "needs_data": "데이터 소스 필요",
      "succeeded": "성공",
      "failed": "실패",
      "running": "실행 중",
      "queued": "대기 중",
      "skipped after workflow": "워크플로우 실패로 스킵",
      "skipped after workflow, ontology capture": "워크플로우/온톨로지 실패로 스킵",
      "succeeded after workflow": "워크플로우 완료 후 성공",
      "succeeded after workflow, ontology capture": "워크플로우/온톨로지 완료 후 성공",
      "failed after workflow": "워크플로우 완료 후 실패",
      "pending": "대기",
      "unknown": "알 수 없음"
    },
    "proposal": {
      "refs": {
        "used": "사용된 참조 ({{count}})",
        "available": "사용 가능 참조 ({{count}})",
        "manifestHash": "Manifest 해시: {{hash}}"
      },
      "readyTitle": "AI 초안 준비됨",
      "partialTitle": "일부 stage 실패 — 초안만 부분 채택 가능",
      "failedTitle": "AI 빌드 실패 — 아래 에러를 확인하세요",
      "failedHint": "스테이지 별 에러를 확인하거나 재시도하세요.",
      "needsRepair": "복구 필요",
      "adopt": "초안 채택",
      "refine": "초안 다듬기",
      "viewDetails": "전체 상세 보기",
      "stepsTitle": "실행할 제안 ({{count}})",
      "accepted": "채택됨",
      "acceptedCount": "{{accepted}}/{{total}} 채택됨",
      "acceptHint": "먼저 각 제안의 “Accept” 를 눌러야 “초안 채택” 으로 대상 에디터에 전달됩니다.",
      "payloadRefs": "Payload 참조",
      "evidence": {
        "title": "제안 증거",
        "groups": {
          "citedCatalogRefs": "참조된 카탈로그",
          "sourceRefs": "소스 참조",
          "upstreamProposalRefs": "상위 제안 참조",
          "projectInstalledRefs": "프로젝트 설치 참조",
          "citedConnectorIds": "참조된 커넥터",
          "citedOntologyClassIds": "참조된 온톨로지 클래스",
          "citedPolicyIds": "참조된 정책",
          "citedWorkflowNodeIds": "참조된 워크플로우 노드",
          "citedReportWidgetIds": "참조된 리포트 위젯",
          "citedProjectWorkflowDefinitionIds": "참조된 설치 워크플로우",
          "citedProjectBiReportIds": "참조된 설치 리포트"
        }
      }
    },
    "labels": {
      "projectContextValue": "프로젝트 컨텍스트: {{projectId}}",
      "projectContextRequired": "프로젝트 컨텍스트 필요",
      "refsCount": "참조 {{count}}"
    },
    "nextActions": {
      "describeIntent": "AI Build 가 지원할 비즈니스 의사결정, 지표, 예외를 설명하세요.",
      "selectProject": "플래너 오케스트레이션 실행 전에 프로젝트를 선택하거나 생성하세요.",
      "attachData": "샘플 데이터, CSV, 데이터베이스, API, 또는 웨어하우스 컨텍스트를 첨부하세요.",
      "chooseOutput": "핸드오프 대상이 명확해지도록 최소 한 가지 출력을 선택하세요.",
      "runPlanner": "워크플로우 / 온톨로지 / 리포트 초안을 받으려면 플래너 오케스트레이션을 실행하세요."
    },
    "projectContextChip": "프로젝트 컨텍스트: {{projectId}}"
  },
  "settings": {
    "navigation": "설정 탐색",
    "llm": {
      "menu": "LLM"
    },
    "auditLogs": {
      "menu": "감사 로그"
    },
    "aiDataUse": {
      "menu": "AI 데이터 사용",
      "title": "AI 데이터 사용",
      "route": "AI 요청은 배포 설정에 따라 Infergraph backend를 거쳐 OpenAI API, Anthropic API 또는 local proxy로 전달됩니다.",
      "sent": "전송 데이터에는 선택한 사용자 입력, 프로젝트 컨텍스트, 생성 옵션, 프롬프트, 처리에 필요한 기술 메타데이터가 포함될 수 있습니다.",
      "notSent": "원시 자격 증명은 의도적으로 AI 제공자에게 전송하지 않으며, credential reference와 secret 형태 필드는 backend 제어로 redaction됩니다.",
      "requiredConsent": "선택한 콘텐츠의 AI 처리를 허용",
      "trainingOptIn": "선택적 모델 개선 공유는 별도 승인 전까지 꺼져 있습니다",
      "requestDeletion": "AI 사용 데이터 삭제 요청",
      "consent": {
        "title": "AI 데이터 사용 동의",
        "body": "선택한 콘텐츠와 생성 옵션이 Infergraph backend를 거쳐 설정된 AI 제공자로 전송될 수 있습니다. 권한 없이 민감한 개인정보, 기밀정보 또는 자격 증명을 입력하지 마세요.",
        "settings": "Settings에서 자세히",
        "accept": "동의하고 계속"
      },
      "demo": {
        "openTrustCenter": "데모 신뢰 센터 열기",
        "noProject": "AI 데이터 사용 정책과 감사 증거를 확인하려면 데모 신뢰 센터를 여세요.",
        "chips": {
          "sharedPolicy": "공유 데모 정책",
          "trainingOptInOff": "학습 옵트인 꺼짐"
        },
        "sections": {
          "dataSent": "AI로 전송되는 데이터",
          "dataNotSent": "전송되지 않는 데이터",
          "policyControls": "정책 제어"
        },
        "labels": {
          "trainingUseStance": "학습 사용 입장",
          "retentionWindow": "보존 기간",
          "approvalGates": "승인 게이트",
          "auditTrail": "감사 추적"
        },
        "actions": {
          "billingProof": "빌링 증거",
          "credentialVaultProof": "자격 증명 보관소 증거",
          "governanceProof": "거버넌스 증거"
        }
      }
    },
    "credentialVault": {
      "title": "자격 증명 보관소",
      "description": "프로젝트별 외부 인프라 자격 증명을 관리합니다.",
      "subtitle": "프로젝트별 외부 인프라 자격 증명을 관리합니다.",
      "menu": "자격 증명 보관소",
      "list": {
        "empty": "등록된 자격 증명이 없습니다."
      },
      "empty": "등록된 자격 증명이 없습니다.",
      "emptySelect": "자격 증명을 선택하세요.",
      "action": {
        "create": "등록",
        "test": "테스트",
        "rotate": "교체",
        "delete": "삭제"
      },
      "actions": {
        "register": "등록",
        "test": "테스트",
        "rotate": "교체",
        "delete": "삭제"
      },
      "field": {
        "name": "이름",
        "host": "호스트",
        "port": "포트"
      },
      "fields": {
        "label": "라벨",
        "kind": "커넥터 유형",
        "secret": "시크릿",
        "allowedProjects": "허용 프로젝트 ID",
        "allowedProjectsHelp": "쉼표로 구분",
        "newSecret": "새 시크릿"
      },
      "tabs": {
        "credentials": "자격 증명",
        "permissions": "권한"
      },
      "labels": {
        "version": "v"
      },
      "permissions": {
        "title": "허용 프로젝트"
      },
      "usage": {
        "title": "사용처",
        "empty": "활성 바인딩이 없습니다."
      },
      "register": {
        "title": "자격 증명 등록"
      },
      "rotate": {
        "title": "자격 증명 교체"
      },
      "messages": {
        "testPassed": "연결 테스트를 통과했습니다.",
        "saved": "자격 증명을 저장했습니다.",
        "rotated": "자격 증명을 교체했습니다.",
        "deleted": "자격 증명을 삭제했습니다."
      },
      "error": {
        "rbac": "권한이 없습니다.",
        "notFound": "자격 증명을 찾을 수 없습니다.",
        "testFailed": "연결 테스트에 실패했습니다."
      },
      "errors": {
        "load": "자격 증명을 불러오지 못했습니다.",
        "usage": "사용처를 불러오지 못했습니다.",
        "save": "자격 증명을 저장하지 못했습니다.",
        "rotate": "자격 증명을 교체하지 못했습니다.",
        "delete": "자격 증명을 삭제하지 못했습니다."
      },
      "demo": {
        "labels": {
          "maskedDescriptor": "마스킹된 설명자:",
          "scope": "범위",
          "testAndRotation": "테스트 및 회전",
          "lastTested": "마지막 테스트",
          "rotated": "회전됨",
          "ownerAndPolicy": "소유자 및 정책",
          "linkedScenario": "연결된 시나리오"
        },
        "openTrustCenter": "데모 신뢰 센터 열기",
        "noProject": "마스킹된 자격 증명, 범위, 회전, 감사 증거를 확인하려면 데모 신뢰 센터를 여세요.",
        "chips": {
          "sharedDemo": "공유 데모",
          "maskedDescriptorsOnly": "마스킹된 설명자만"
        },
        "subtitle": "월별 원가 변동 시나리오에 대한 합성 자격 증명 증거. 비밀 값은 표시되지 않으며 데모 자격 증명은 등록·회전·삭제할 수 없습니다.",
        "actions": {
          "billingProof": "빌링 증거",
          "aiDataUseProof": "AI 데이터 사용 증거",
          "governanceProof": "거버넌스 증거",
          "pricing": "요금제"
        },
        "notice": "자격 증명 샘플은 비밀이 숨겨진 설명자입니다. 비밀을 노출하지 않고 커넥터 상태, 범위, 소유자, 회전 상태, 연결된 워크플로우, 승인 정책, 감사 참조를 보여줍니다."
      }
    },
    "billing": {
      "live": {
        "quota": {
          "projectCount": "프로젝트 수",
          "userCount": "활성 편집자",
          "workflowRuns": "워크플로우 실행",
          "ontologyObjects": "온톨로지 객체",
          "aiActions": "AI 액션"
        },
        "tiers": {
          "free": "Free",
          "starter": "Starter",
          "pro": "Pro",
          "enterprise": "Enterprise"
        },
        "errors": {
          "load": "빌링 사용량 불러오기에 실패했습니다"
        },
        "loading": "빌링 사용량을 불러오는 중입니다.",
        "overageConsent": {
          "on": "초과 사용 동의 켜짐",
          "off": "초과 사용 동의 꺼짐"
        },
        "labels": {
          "activeEditorsBilled": "과금 대상 활성 편집자:",
          "policy": "정책:"
        },
        "table": {
          "metric": "지표",
          "period": "기간",
          "consumed": "사용량",
          "overage": "초과량",
          "charge": "요금"
        },
        "empty": "아직 사용량이 기록되지 않았습니다.",
        "summary": {
          "consumed": "사용량 {{value}}",
          "overage": "초과 {{value}}",
          "charge": "초과 요금 {{amount}}"
        }
      },
      "demo": {
        "openTrustCenter": "데모 신뢰 센터 열기",
        "noProject": "빌링 사용량, 할당량, 초과 사용 제어를 확인하려면 데모 신뢰 센터를 여세요.",
        "chips": {
          "sharedDemo": "공유 데모"
        },
        "labels": {
          "currentPlan": "현재 요금제",
          "billingPeriod": "빌링 기간:",
          "status": "상태:",
          "nextAlert": "다음 알림:",
          "approvalOwner": "승인 담당자:",
          "monthlyCap": "월 상한",
          "capReachedBehavior": "상한 도달 시 동작"
        },
        "sections": {
          "pricingVocabulary": "이 콘솔에서 사용하는 가격 용어",
          "overageControls": "초과 사용 제어"
        },
        "status": {
          "healthy": "정상"
        },
        "actions": {
          "aiDataUseProof": "AI 데이터 사용 증거",
          "credentialVaultProof": "자격 증명 보관소 증거",
          "governanceProof": "거버넌스 증거",
          "pricing": "요금제"
        }
      },
      "title": "빌링",
      "table": {
        "metric": "지표",
        "usedLimit": "사용량 / 한도",
        "forecast": "예측",
        "status": "상태",
        "source": "소스"
      },
      "menu": "빌링"
    },
    "userApproval": {
      "errors": {
        "list": "사용자 목록을 불러오지 못했습니다.",
        "generic": "작업에 실패했습니다.",
        "adminRequired": "관리자 권한이 필요합니다."
      },
      "status": {
        "pending": "Pending",
        "approved": "승인됨",
        "rejected": "거부됨"
      },
      "tabs": {
        "all": "전체"
      },
      "title": "사용자 가입 승인",
      "description": "신규 가입은 대기 상태로 시작하며 승인된 사용자만 앱을 사용할 수 있습니다.",
      "actions": {
        "loading": "불러오는 중...",
        "refresh": "새로고침",
        "approve": "승인",
        "reject": "거부",
        "remove": "제거"
      },
      "columns": {
        "email": "이메일",
        "name": "이름",
        "status": "상태",
        "createdAt": "가입일",
        "lastSeen": "최근 접속",
        "approver": "승인자 / 시각",
        "actions": "작업"
      },
      "empty": "표시할 사용자가 없습니다."
    }
  },
  "permissionGuard": {
    "loadingProjects": "프로젝트를 불러오는 중입니다",
    "loadingProjectsDescription": "접근 가능한 프로젝트와 권한을 확인하고 있습니다.",
    "serverError": "프로젝트 로드 오류",
    "dockerHint": "백엔드 서버와 인증 상태를 확인한 뒤 다시 시도하세요.",
    "noPermissionTitle": "접근 권한이 없습니다",
    "noAccessibleProjects": "접근 가능한 프로젝트가 없습니다",
    "noAccessibleProjectsDescription": "이 계정으로 접근할 수 있는 프로젝트가 없습니다. 새 프로젝트를 만들거나 관리자에게 권한을 요청하세요.",
    "noProjectMembershipDescription": "현재 선택된 프로젝트의 멤버가 아니거나 필요한 권한이 없습니다.",
    "createProject": "프로젝트 만들기",
    "selectProjectTitle": "프로젝트를 선택하세요",
    "selectProjectDescription": "작업을 계속하려면 접근 가능한 프로젝트를 선택하세요.",
    "selectPageProjectDescription": "이 페이지를 열려면 먼저 접근 가능한 프로젝트를 선택하세요.",
    "noCurrentProjectAccessTitle": "현재 프로젝트에 접근할 수 없습니다",
    "selectOtherProjectDescription": "현재 프로젝트에 대한 권한이 없습니다. 다른 프로젝트를 선택하거나 프로젝트 관리에서 권한을 확인하세요.",
    "accessibleProjects": "접근 가능한 프로젝트",
    "accessibleProjectsColon": "접근 가능한 프로젝트:",
    "otherAccessibleProjects": "다른 접근 가능한 프로젝트",
    "otherAccessibleProjectsColon": "다른 접근 가능한 프로젝트:",
    "projectRoleSummary": "역할: {{role}} | {{description}}",
    "insufficientPermissionTitle": "권한이 부족합니다",
    "cannotUseFeatureWithRole": "현재 역할({{role}})로는 이 기능을 사용할 수 없습니다.",
    "cannotAccessPageWithRole": "현재 역할({{role}})로는 이 페이지에 접근할 수 없습니다.",
    "askProjectAdmin": "프로젝트 관리자에게 권한을 요청하세요.",
    "goToProjectManagement": "프로젝트 관리로 이동",
    "demoLoginFailed": "테스트 로그인에 실패했습니다.",
    "startingDemo": "테스트 계정 시작 중...",
    "startAiBuildDemo": "테스트 계정으로 AI Build 시작",
    "aiBuildDemoDescription": "로컬 테스트 계정으로 로그인하고 샘플 프로젝트를 선택해 AI Build가 컨텍스트를 로드할 수 있게 합니다."
  },
  "onboardingRunner": {
    "steps": {
      "define-closed-loop-policy": {
        "title": "Loop 정책 정의",
        "actionLabel": "정책 작성 열기",
        "failureGuidance": "정책 작성(Policy Authoring) 화면에서 Decision Table 을 publish 하여 policy.decision_table.published 이벤트를 발생시키세요."
      }
    }
  },
  "readyMadePacks": {
    "wizard": {
      "title": "{{packName}} 설치 마법사",
      "description": "입력 값은 Plan 단계에서 검증되며, Publish 이전에는 어떤 산출물도 생성되지 않습니다.",
      "prepareHelp": "필수 질문, 커넥션 ID, 샘플 데이터, 승인 조건을 한 번에 채워줍니다.",
      "readyTitle": "{{packName}} ({{packId}})",
      "readinessDetail": "{{detail}}",
      "sampleDataStatusLabel": "샘플 데이터 상태: {{status}}",
      "workflowStatusLabel": "워크플로 설정 상태: {{status}}",
      "ontologyStatusLabel": "스키마/온톨로지 설정 상태: {{status}}",
      "reportStatusLabel": "리포트 설정 상태: {{status}}",
      "nextAction": "다음 단계: Plan 미리보기를 검토한 뒤 준비된 팩을 Publish 하세요.",
      "noInstallQuestions": "이 팩에는 별도의 설치 질문이 없습니다.",
      "unansweredRequired": "필수 질문 {{count}}개가 아직 답변되지 않았습니다.",
      "fieldMappingInfo": "필드 매핑은 Plan 단계에서 조정할 수 있습니다. 기본값으로 계속 진행해도 됩니다.",
      "noCredentialSlots": "이 팩에는 자격 증명(Credential) 슬롯이 필요하지 않습니다.",
      "noSampleData": "이 팩에는 샘플 데이터가 없습니다.",
      "seedSampleData": "샘플 데이터를 InstanceRegistry 에 적재(seed)합니다.",
      "secretWarning": "비밀 값을 직접 입력하지 마세요. 등록된 자격 증명(Credential) ID 만 선택하세요.",
      "unbound": "(미연결)",
      "registeredCredential": "등록된 자격 증명: {{credentialId}}",
      "unboundCredentialSlots": "연결되지 않은 자격 증명 슬롯이 {{count}}개 있습니다.",
      "sampleDataStatus": {
        "ready": "준비 완료: 설치 시 샘플 데이터가 자동 적재됩니다.",
        "notSelected": "선택되지 않음.",
        "notRequired": "샘플 데이터가 필요하지 않습니다.",
        "available": "사용 가능: 샘플 실행 준비 버튼을 클릭하세요."
      },
      "workflowStatus": {
        "ready": "워크플로 설치 상태: {{count}}개 준비 완료",
        "none": "이 팩에는 워크플로 템플릿이 없습니다."
      },
      "ontologyStatus": {
        "ready": "온톨로지 설치 상태: {{count}}개 준비 완료",
        "none": "이 팩에는 스키마/온톨로지 템플릿이 없습니다."
      },
      "reportStatus": {
        "ready": "리포트 설치 상태: {{count}}개 준비 완료",
        "none": "이 팩에는 리포트 템플릿이 없습니다."
      },
      "steps": {
        "installQuestions": "설치 질문",
        "fieldMappings": "필드 매핑",
        "credentialSlots": "자격 증명 슬롯",
        "sampleData": "샘플 데이터"
      },
      "credentialRecovery": {
        "title": "자격 증명(Credential) 연결이 필요합니다",
        "noCredentials": "이 프로젝트에 등록된 자격 증명이 없어 슬롯을 연결할 수 없습니다. 먼저 자격 증명을 등록하세요.",
        "unboundSlots": "{{count}}개 슬롯이 연결되지 않았습니다. 등록된 자격 증명 ID 를 선택해 연결하세요.",
        "details": "비밀 값을 직접 입력하지 마세요. 등록된 자격 증명 ID 만 선택하세요."
      },
      "errors": {
        "samplePreparation": "샘플 실행 준비에 실패했습니다."
      },
      "actions": {
        "prepareScenarioInputs": "샘플 실행 준비",
        "prepareSampleRun": "샘플 실행 준비",
        "preparingSampleRun": "샘플 실행 준비 중",
        "openCredentialRegistry": "자격 증명 레지스트리 열기",
        "openCredentialRegistryDisabled": "자격 증명 레지스트리 화면이 아직 앱 라우터에 등록되지 않았습니다. 레지스트리가 추가될 때까지 이 작업은 비활성화됩니다.",
        "focusUnboundSlot": "연결되지 않은 슬롯으로 이동",
        "back": "이전",
        "next": "다음",
        "viewPlanPreview": "Plan 미리보기 열기"
      },
      "approvalsStale": "샘플 실행 준비 이후 답변을 바꿨습니다. 계속하기 전에 “샘플 실행 준비”를 다시 눌러 주세요 — 그러지 않으면 게시가 거부되고 샘플 데이터만 설치됩니다. 입력한 답변은 그대로 유지됩니다."
    },
    "artifacts": {
      "data": "데이터",
      "workflow": "워크플로우",
      "ontology": "온톨로지",
      "report": "리포트",
      "tutorial": "튜토리얼",
      "missing": "누락"
    },
    "readiness": {
      "sampleReady": "샘플 준비됨",
      "sampleMissing": "샘플 누락",
      "noSampleRequired": "샘플 불필요",
      "credentialsLabel": "자격 증명:",
      "credentialsRequiredSuffix": "필요",
      "credentialsNotRequired": "자격 증명 불필요"
    },
    "estimatedInstallMinutes": "예상 설치 시간: 약 {{count}}분",
    "actions": {
      "configureInstall": "설치 구성",
      "defineClosedLoopPolicy": "Loop 정책 정의",
      "packFeedback": "팩 피드백",
      "openReport": "리포트 열기"
    },
    "catalog": {
      "errors": {
        "load": "팩 로드에 실패했습니다"
      },
      "title": "Ready Made Packs",
      "description": "데이터, 워크플로우, 온톨로지, 리포트, 튜토리얼 경로를 구성할 팩을 선택하세요.",
      "searchPlaceholder": "이름, 태그 또는 대상으로 검색",
      "filters": {
        "industry": "산업",
        "allIndustries": "전체 산업",
        "function": "기능",
        "allFunctions": "전체 기능",
        "scenario": "시나리오",
        "allScenarios": "전체 시나리오"
      },
      "empty": {
        "search": "검색 결과가 없습니다.",
        "default": "등록된 Ready Made Pack이 없습니다."
      }
    },
    "plan": {
      "actions": {
        "editInputs": "입력으로 돌아가 편집",
        "editInputsDisabled": "이 화면에서는 입력 단계로 돌아갈 수 없습니다. Ready Made Packs 페이지에서 마법사를 다시 여세요.",
        "keepDraft": "초안 유지",
        "publish": "게시",
        "publishBlockedByCollision": "차단됨 (충돌 해결 필요)"
      },
      "description": "Plan 응답에는 부수 효과가 없습니다 (sideEffects=false). 어떤 산출물도 생성하지 않습니다.",
      "blocked": "게시가 차단되었습니다. 아래의 게시 차단 요인을 해결하세요.",
      "recovery": {
        "blockedTitle": "게시 차단: 설치 입력 또는 템플릿 검증 오류",
        "warningTitle": "검증 경고가 감지되었습니다",
        "blockedSummary": "publishBlockers 또는 템플릿 검증 결과를 해결한 뒤 Plan을 다시 생성하세요. 차단 요인이 남아 있는 동안 게시는 비활성화됩니다.",
        "warningSummary": "검증 경고 {{count}}건이 있습니다. 내용을 확인한 뒤 진행하세요."
      },
      "sections": {
        "publishBlockers": "게시 차단 요인",
        "artifactDiff": "산출물 diff",
        "validationFindings": "검증 결과",
        "workflowDryRuns": "워크플로우 dry-run",
        "ontologyImpact": "온톨로지 영향",
        "reportPreviewAvailability": "리포트 미리보기 가용성"
      },
      "table": {
        "direction": "방향",
        "kind": "종류",
        "title": "제목",
        "definitionKey": "정의 키"
      },
      "direction": {
        "create": "생성",
        "update": "업데이트"
      },
      "collision": {
        "title": "이미 설치된 다른 Pack과 충돌 {{count}}건",
        "confirm": "충돌 사항을 확인했으며 그대로 설치를 진행합니다.",
        "conflictDetail": "충돌 대상: {{packId}} / {{artifact}} ({{kind}})",
        "severity": {
          "block": "차단",
          "warn": "경고"
        },
        "code": {
          "pack_install.collision.workflow_definition_key": "동일한 workflow definition key가 다른 Pack에 이미 설치되어 있습니다.",
          "pack_install.collision.ontology_class": "동일한 ontology class id가 다른 Pack에 이미 설치되어 있습니다.",
          "pack_install.collision.report_title": "동일한 report title이 다른 Pack에 이미 설치되어 있습니다.",
          "pack_install.collision.credential_slot": "동일한 credential slot이 다른 Pack에 이미 사용되고 있습니다."
        }
      },
      "reinstall": {
        "same": "동일 버전 재설치",
        "newer": "버전 업그레이드 설치",
        "older": "이전 버전으로 다운그레이드 (주의)",
        "unknown": "이 프로젝트에 이미 설치된 Pack입니다",
        "versionsLine": "현재 설치: v{{current}} → 새 버전: v{{incoming}}"
      },
      "title": "설치 계획 — {{packId}} v{{version}}",
      "canProceed": "설치할 준비가 되었습니다. 산출물 {{count}}개를 만듭니다.",
      "workflowDryRunSummary": "워크플로 {{templateIndex}}번 — 예정 작업 {{plannedCount}}건 · 승인 {{approvalCount}}건 · 데이터 기록 {{graphCount}}건",
      "ontologyImpactSummary": "온톨로지 {{templateIndex}}번 — 클래스 {{objectTypeCount}}개 {{direction}}",
      "reportPreviewSummary": "리포트 {{templateIndex}}번 — {{title}} · 섹션 {{sectionCount}}개 {{direction}}"
    },
    "recommendation": {
      "errors": {
        "request": "추천 요청에 실패했습니다"
      },
      "title": "팩 추천",
      "description": "\"재무 원가 변동 리포트\" 또는 \"반도체 공정 원가 분석\" 같은 비즈니스 의도를 입력하세요.",
      "placeholder": "비즈니스 의도",
      "submit": "추천 받기",
      "empty": "일치하는 팩이 없습니다. 다른 표현으로 시도해보세요.",
      "missingPrerequisites": "해결 필요:",
      "openInstallWizard": "설치 마법사 열기",
      "score": "적합도 {{value}}"
    },
    "useCase": {
      "copyPackUnavailable": "이 시나리오는 읽기 전용 배경 자료입니다. 설치 가능한 authoring pack이 연결되지 않아 복사할 수 없습니다."
    },
    "install": {
      "previousSampleData": "이전에 설치된 팩 리포트가 있습니다.",
      "previousWorkflow": "이전에 설치된 워크플로우 설정은 Workflows에서 확인할 수 있습니다.",
      "previousOntology": "이전에 설치된 스키마/온톨로지 설정은 온톨로지 증거에서 확인할 수 있습니다.",
      "previousReport": "리포트는 리포트 빌더에서 확인할 수 있습니다.",
      "nextOpenGeneratedReport": "생성된 리포트를 여세요.",
      "installedTitleLabel": "Ready Made Pack이 설치되었습니다:",
      "sampleDataStatusLabel": "샘플 데이터 상태:",
      "workflowSetupStatusLabel": "워크플로우 설정 상태:",
      "ontologySetupStatusLabel": "스키마/온톨로지 설정 상태:",
      "reportSetupStatusLabel": "리포트 설정 상태:",
      "nextActionLabel": "다음 작업:",
      "sampleDataEnabled": "샘플 데이터를 활성화하여 설치되었습니다.",
      "sampleDataDisabled": "샘플 데이터 없이 설치되었습니다.",
      "noSampleDataRequired": "샘플 데이터가 필요하지 않습니다.",
      "workflowPublishedSuffix": "개의 워크플로우 정의가 게시되었습니다.",
      "noWorkflowCreated": "생성된 워크플로우 정의가 없습니다.",
      "ontologyPublishedSuffix": "개의 스키마/온톨로지 초안이 게시되었습니다.",
      "noOntologyCreated": "생성된 스키마/온톨로지 초안이 없습니다.",
      "reportPublishedSuffix": "개의 리포트 산출물이 게시되었습니다.",
      "noReportCreated": "생성된 리포트 산출물이 없습니다.",
      "nextOpenReport": "생성된 리포트를 열고 게시된 워크플로우를 실행하세요.",
      "nextOpenWorkflow": "Workflows를 열고 게시된 워크플로우를 실행하세요.",
      "publishBlocked": "게시가 거부되어 워크플로·리포트가 만들어지지 않았습니다 (샘플 데이터는 이미 설치되었을 수 있습니다). 사유:",
      "previouslyInstalledTitleLabel": "이 프로젝트에 이미 설치된 팩:"
    },
    "tabs": {
      "catalog": "카탈로그",
      "recommend": "추천",
      "install": "설치",
      "plan": "Plan"
    },
    "overview": {
      "title": "Ready Made Packs 이란?",
      "purpose": "검증된 업무 자동화 묶음(데이터 구조 + 워크플로 + 리포트 + 샘플 데이터)을 한 번에 설치합니다. 처음부터 만들지 않고, 이미 돌아가는 완성품을 먼저 체험한 뒤 내 데이터로 바꿔 쓰는 곳입니다.",
      "direction": "방향: ① \"받은 메일 정리해서 담당자에게 보내기\" 같은 5분짜리 쉬운 사례부터 넓혀갑니다. ② 모든 팩은 \"예시 입력 → 실제 결과\"를 눈으로 확인하는 방식으로 바뀝니다. ③ 대표 사례에는 동영상 데모가 붙습니다.",
      "knownIssues": "알려진 이슈: 일부 팩 문구가 아직 전문용어 중심이고, 일부 설치 산출물(워크플로·리포트 이름)이 영어입니다 — 쉬운 한국어로 바꾸는 작업이 진행 중입니다. 설치 직후에는 샘플 데이터 기준으로 동작하며, 내 데이터 연결은 커넥션 등록 후 가능합니다."
    },
    "tier": {
      "starter": "5분 입문",
      "standard": "표준",
      "advanced": "심화"
    }
  },
  "policyAuthoring": {
    "title": "정책 정의",
    "description": "Loop 정책을 의사결정 테이블(Decision Table)로 정의합니다. 각 규칙은 주제 클래스의 속성 조건 집합이며, 모든 조건이 일치하면 dispatcher가 해당 규칙의 LoopAction을 발행해 결과를 다음 workflow 입력으로 자동 연결합니다.",
    "backToList": "목록으로 돌아가기",
    "list": {
      "title": "의사결정 테이블",
      "subheader": "저장/게시된 loop 정책 (서버 목록)",
      "createNew": "새로 만들기",
      "empty": "저장된 Decision Table 이 없습니다. 새로 만들어 시작하세요.",
      "headers": {
        "tableId": "테이블 ID",
        "title": "제목",
        "subject": "주제",
        "latestVersion": "최신 버전",
        "createdBy": "작성자",
        "createdAt": "작성 시간",
        "actions": "작업",
        "published": "게시 상태"
      },
      "tooltips": {
        "edit": "편집",
        "history": "이력",
        "publish": "PolicyRegistry에 게시",
        "forget": "이 디바이스에서 제거"
      },
      "refresh": "새로고침",
      "footerHint": "서버에 저장된 전체 목록입니다 (모든 기기/사용자 공통).",
      "noTime": "시간 정보 없음",
      "publishedVersion": "게시 v{{version}}",
      "draftOnly": "초안"
    },
    "editor": {
      "metadataTitle": "의사결정 테이블",
      "metadataSubheader": "Loop Type B 정책을 위한 비개발자 작성 화면",
      "tableId": "테이블 ID",
      "tableIdLocked": "잠금됨 — table_id는 PolicyRegistry의 안정적 식별자입니다",
      "tableIdHint": "안정적인 식별자 (예: inv-low-onhand)",
      "tableTitle": "제목",
      "subjectClass": "주제 클래스 (IRI)",
      "subjectClassHint": "예: ig:Inventory",
      "bindingVar": "바인딩 변수",
      "bindingVarLocked": "W1-A4에서 \"subject\"로 고정됨",
      "createdBy": "작성자",
      "rules": "규칙",
      "addRule": "규칙 추가",
      "ruleId": "규칙 ID",
      "ruleSummaryCondition_one": "{{count}}개 조건",
      "ruleSummaryCondition_other": "{{count}}개 조건",
      "ruleDeleteMin": "테이블에는 최소 한 개의 규칙이 있어야 합니다",
      "ruleDelete": "규칙 삭제",
      "conditionsTitle": "조건 (AND)",
      "addCondition": "조건 추가",
      "actionTitle": "액션",
      "preview": "미리보기",
      "saveDraft": "초안 저장",
      "publish": "게시",
      "savePromptBeforePublish": "게시 전 초안을 저장하세요 — Publish는 가장 최근 저장된 버전을 PolicyRegistry에 승격합니다.",
      "compilePreview": "컴파일 미리보기",
      "projectId": "프로젝트 ID",
      "projectIdHint": "정책이 감시할 프로젝트. 비우면 (레거시) 기본 그래프를 조회해 프로젝트 데이터와 매칭되지 않습니다",
      "warningsTitle": "저작 경고 — 게시 전 확인하세요"
    },
    "compile": {
      "compiling": "컴파일 중…",
      "clickPreview": "\"미리보기\"를 클릭하여 의사결정 테이블을 컴파일하고 생성된 SPARQL + LoopAction 템플릿을 확인하세요.",
      "workflowId": "workflow_id: {{id}}",
      "versionUnsaved": "version: (미저장)",
      "version": "version: {{version}}",
      "triggerSparql": "trigger_sparql (SELECT)",
      "askSparql": "ask_sparql (ASK)",
      "actionTemplate": "action_template (LoopAction)"
    },
    "condition": {
      "propertyPath": "속성 경로 (IRI)",
      "propertyHintWithClass": "예: ig:onHand on {{subjectClass}}",
      "propertyHint": "예: ig:onHand",
      "operator": "연산자",
      "value": "값",
      "datatype": "데이터 타입",
      "deleteMin": "규칙에는 최소 한 개의 조건이 있어야 합니다",
      "delete": "조건 제거"
    },
    "action": {
      "kind": "액션 종류",
      "definitionId": "정의 ID",
      "definitionVersion": "정의 버전 (SemVer)",
      "definitionVersionHint": "예: 1.0.0 — 정확한 SemVer 2.0.0 문자열",
      "reversibility": "되돌릴 수 있는가",
      "approvalRequired": "승인 필요",
      "approvalForced": "되돌릴 수 없거나 비용이 큰 액션이므로 loop 불변식에 의해 승인이 필수입니다.",
      "parameters": "파라미터 (JSON)",
      "mustBeJsonObject": "JSON 객체여야 합니다",
      "invalidJson": "잘못된 JSON",
      "bindingHint": "`subject` 바인딩(이중 중괄호 표기)을 사용하여 매칭된 주제 IRI를 행별로 참조하세요. 플레이스홀더는 컴파일 시점이 아닌 디스패치 시점에 치환됩니다.",
      "reportId": "리포트 ID",
      "reportVersion": "리포트 버전",
      "namedGraph": "Named graph",
      "namedGraphHint": "`master`는 loop 불변식에 의해 금지됩니다",
      "aggregateId": "집계 ID",
      "scope": "범위 (JSON)",
      "channel": "채널",
      "templateId": "템플릿 ID",
      "approvalInfo": "승인 요청은 다른 LoopAction을 감싸는 구조입니다. 디스패처는 wrapper를 큐에 넣고, 승인자가 결정한 후에 내부 액션을 발행합니다.",
      "approverRole": "승인자 역할",
      "timeoutSeconds": "타임아웃 (초)",
      "pendingAction": "보류 액션 (내부 LoopAction)",
      "pendingActionKind": "보류 액션 종류"
    },
    "dialogs": {
      "publishTitle": "PolicyRegistry에 게시하시겠습니까?",
      "publishBody": "이 작업은 <strong>{{tableId}}</strong>의 가장 최근 저장된 버전을 PolicyRegistry에 승격합니다. dispatcher는 다음 평가 사이클에서 매칭되는 주제에 대해 액션 발행을 시작합니다.",
      "publishWarning": "이것은 컨트롤 플레인 변경입니다. 진행하기 전에 미리보기 출력과 승인 게이트가 올바른지 확인하세요.",
      "publishCancel": "취소",
      "publishConfirm": "게시",
      "historyTitle": "이력 — {{tableId}}",
      "historyEmpty": "버전이 없습니다.",
      "historyClose": "닫기",
      "historyAuthor": "작성자: {{author}}",
      "historyUnknownTime": "시간 정보 없음"
    },
    "toast": {
      "saved": "버전 {{version}}이 저장되었습니다",
      "published": "{{policyId}} v{{policyVersion}} 게시 완료 ({{operation}})"
    },
    "auditLog": {
      "title": "Loop 디스패치 이력",
      "description": "각 행은 인배리언트 평가 틱을 기록합니다. 비어 있으면 아직 리컨실러가 이 정책을 한 번도 트리거하지 않은 것입니다.",
      "refresh": "새로고침",
      "loading": "감사 로그를 불러오는 중…",
      "empty": "이 정책에서 아직 인배리언트가 발화된 적이 없습니다.",
      "colTime": "시간",
      "colInvariant": "인배리언트",
      "colStatus": "상태",
      "colDispatched": "디스패치된 액션",
      "colCooldown": "쿨다운 종료 시각",
      "inferredChip": "추론 유래"
    },
    "tabs": {
      "decisionTables": "의사결정 테이블",
      "securityPolicies": "보안 정책",
      "invariantPolicies": "Invariant 정책"
    },
    "invariant": {
      "title": "Closed Loop Invariant 정책",
      "description": "reconcile tick마다 SPARQL ASK로 상태 불변식을 평가하고, 위반 시 LoopAction을 발화하는 정책입니다. '추론 결과 포함'을 켜면 온톨로지 추론으로 도출된 사실도 평가 대상이 됩니다.",
      "noProject": "프로젝트를 먼저 선택하세요.",
      "accessNotice": "Invariant 정책 관리는 EDITOR 이상 권한이 필요합니다",
      "empty": "등록된 Invariant 정책이 없습니다. 새 정책을 만들어 자동 재실행을 시작하세요.",
      "createButton": "새 Invariant 정책",
      "includeInferredOn": "추론 포함",
      "includeInferredOff": "미포함",
      "enabledOn": "활성",
      "enabledOff": "비활성",
      "editAria": "정책 수정",
      "deleteAria": "정책 삭제",
      "columns": {
        "label": "정책",
        "loopAction": "Loop Action",
        "includeInferred": "추론 결과",
        "enabled": "상태",
        "updatedAt": "최근 수정",
        "actions": "작업"
      },
      "form": {
        "createTitle": "Invariant 정책 생성",
        "editTitle": "Invariant 정책 수정",
        "labelLabel": "정책 이름",
        "descriptionLabel": "설명 (선택)",
        "askQueryLabel": "ASK 쿼리 (SPARQL)",
        "askQueryHelper": "ASK { ... } 형식. 결과가 true면 불변식 위반으로 판단합니다.",
        "selectQueryLabel": "SELECT 쿼리 (SPARQL)",
        "selectQueryHelper": "위반 대상을 나열하는 SELECT. ?subject 바인딩이 반드시 포함되어야 합니다.",
        "actionKindLabel": "Loop Action 타입",
        "workflowIdLabel": "워크플로 정의 ID",
        "workflowIdHelper": "위반 시 실행할 게시된 워크플로 정의 ID (예: uwf-...)",
        "workflowVersionLabel": "정의 버전",
        "reportIdLabel": "리포트 ID",
        "reportVersionLabel": "리포트 버전",
        "namedGraphLabel": "네임드 그래프",
        "namedGraphHelper": "리프레시 대상 그래프입니다. master 그래프는 closed loop에서 읽기 전용이므로 선택할 수 없습니다.",
        "aggregateIdLabel": "집계 ID",
        "aggregateScopeLabel": "스코프 (JSON)",
        "aggregateScopeHelper": "재계산 스코프(GraphSelector) 객체 — 서버 계약상 자유 형식 JSON입니다.",
        "notificationChannelLabel": "채널",
        "notificationTemplateLabel": "템플릿 ID",
        "approverRoleLabel": "승인자 역할",
        "approvalTimeoutLabel": "타임아웃 (초)",
        "approvalTimeoutHelper": "0보다 커야 합니다.",
        "pendingActionLabel": "대기 액션 (JSON)",
        "pendingActionHelper": "승인 게이트 뒤에 실행할 LoopAction을 JSON으로 입력하세요 — 서버에서 LoopAction 스키마로 재귀 검증됩니다.",
        "actionConfigLabel": "액션 설정 (JSON)",
        "actionConfigHelper": "{{kind}} 액션의 나머지 필드를 JSON으로 입력하세요. 서버에서 LoopAction 스키마로 검증됩니다.",
        "includeInferredLabel": "추론 결과 포함 (include_inferred)",
        "includeInferredHelper": "추론으로 도출된 사실도 정책 평가에 포함합니다 (asserted ∪ inferred 그래프 union으로 평가).",
        "enabledLabel": "정책 활성화 (reconcile tick에서 평가)",
        "cancel": "취소",
        "submitCreate": "생성",
        "submitSave": "저장"
      },
      "dialogs": {
        "deleteTitle": "Invariant 정책 삭제",
        "deleteBody": "'{{target}}' 정책을 삭제할까요? 정책 버전 이력은 감사 목적으로 보존되지만, 더 이상 평가되지 않습니다.",
        "deleteCancel": "취소",
        "deleteConfirm": "삭제"
      },
      "toast": {
        "created": "Invariant 정책이 생성되었습니다.",
        "updated": "Invariant 정책이 수정되었습니다 (새 버전 생성).",
        "deleted": "Invariant 정책이 삭제되었습니다."
      },
      "errors": {
        "actionConfigJson": "액션 설정 JSON을 해석할 수 없습니다: {{error}}",
        "scopeJson": "스코프 JSON을 해석할 수 없습니다: {{error}}",
        "pendingActionJson": "대기 액션 JSON을 해석할 수 없습니다: {{error}}"
      }
    },
    "security": {
      "title": "객체/필드 읽기 보안 정책",
      "description": "클래스(객체) 또는 특정 필드를 읽을 수 있는 최소 프로젝트 역할을 정의합니다. 정책이 1건이라도 있으면 raw SPARQL 실행은 모든 정책의 최소 역할을 충족하는 사용자만 가능합니다.",
      "noProject": "프로젝트를 먼저 선택하세요.",
      "accessNotice": "보안 정책 관리는 프로젝트 ADMIN 이상만 가능합니다",
      "curatedSourceNotice": "큐레이티드(시스템) 리포트 소스는 이 정책의 적용 대상이 아닙니다. 정책 생성 이전부터 해당 필드를 사용하던 리포트는 계속 값을 표시할 수 있습니다 — 필요하면 해당 리포트/위젯을 함께 정리하세요.",
      "curatedSourceListLabel": "이 프로젝트의 큐레이티드 소스 ({{count}}개):",
      "curatedSourceListEmpty": "현재 이 프로젝트에 등록된 큐레이티드(시스템) 리포트 소스가 없습니다.",
      "empty": "등록된 보안 정책이 없습니다.",
      "deleteAria": "정책 삭제",
      "columns": {
        "class": "클래스",
        "field": "필드",
        "minRole": "최소 역할",
        "createdBy": "생성자",
        "createdAt": "생성 일시",
        "actions": "작업"
      },
      "form": {
        "title": "새 보안 정책",
        "classLabel": "클래스",
        "fieldLabel": "필드",
        "wholeObject": "(객체 전체)",
        "allClasses": "모든 클래스 (*)",
        "minRoleLabel": "최소 역할",
        "submit": "정책 추가"
      },
      "dialogs": {
        "deleteTitle": "보안 정책 삭제",
        "deleteBody": "'{{target}}' 정책을 삭제하시겠습니까? 삭제 즉시 해당 대상의 읽기 제한이 해제됩니다.",
        "deleteCancel": "취소",
        "deleteConfirm": "삭제"
      },
      "toast": {
        "created": "보안 정책이 생성되었습니다.",
        "deleted": "보안 정책이 삭제되었습니다."
      }
    }
  },
  "unifiedDesigner": {
    "page": {
      "openOntologyGraphTooltip": "온톨로지 그래프 탭을 엽니다",
      "openOntologyGraph": "온톨로지 그래프 보기",
      "tabWorkflowCanvas": "워크플로우 캔버스",
      "tabOntologyGraph": "온톨로지 그래프",
      "tabApprovals": "승인",
      "selectProjectForWorkflows": "워크플로우를 보려면 프로젝트를 선택하세요.",
      "emailRequiredForApprovals": "승인 항목을 보려면 현재 사용자 이메일이 필요합니다.",
      "selectProjectForApprovals": "승인 항목을 보려면 프로젝트를 선택하세요."
    },
    "ontology": {
      "addRelation": {
        "title": "두 비즈니스 레코드 연결",
        "fromRecord": "출발 레코드",
        "describeConnection": "관계 설명",
        "describePlaceholder": "예: 소속, 결제 대상, 포함",
        "describeHelp": "두 레코드 사이에 자연스럽게 읽히는 짧은 표현입니다.",
        "howManyLink": "몇 개까지 연결할 수 있나요?",
        "connectsTo": "연결 대상",
        "selfLinkError": "자기 자신과는 연결할 수 없습니다. 다른 대상 레코드를 선택하세요.",
        "cancel": "취소"
      },
      "classNode": {
        "dragToLink": "드래그하여 연결",
        "new": "신규",
        "sharedRecord": "공유 레코드",
        "moreField": "개 필드 더 있음",
        "usedBy": "사용처"
      },
      "graphView": {
        "title": "온톨로지 그래프",
        "businessRecord": "비즈니스 레코드",
        "notationGuideTooltip": "표기법 가이드 — 1:1, 1:N 의미",
        "addLink": "연결 추가",
        "resetLayoutTooltip": "레이아웃 초기화 — 자동 정렬된 위치로 복원",
        "resetLayout": "레이아웃 초기화",
        "reloadRegistry": "레지스트리 다시 불러오기",
        "notationGuide": "표기법 가이드",
        "one2oneDesc": "각 레코드는 정확히 하나의 다른 레코드와 연결됩니다",
        "one2nLabel": "▷ 1:N",
        "one2nDesc": "각 레코드는 여러 레코드와 연결될 수 있습니다",
        "searchPlaceholder": "레코드 검색…",
        "recordTypes": "레코드 타입",
        "showUnlinkedOnly": "연결 없는 항목만 표시",
        "findOrphans": "(고립된 항목 찾기)",
        "noRecords": "아직 비즈니스 레코드가 없습니다",
        "noRecordsHelp": "워크플로우 캔버스 탭에서 워크플로우를 만들고 저장할 비즈니스 레코드를 선택하세요. 생성되는 즉시 여기에 표시됩니다.",
        "goToWorkflow": "워크플로우 캔버스로 이동",
        "templateComingTooltip": "곧 제공 — 표준 P2P / O2C 온톨로지에서 시작",
        "startWithTemplate": "템플릿으로 시작",
        "unsavedTitle": "저장되지 않은 워크플로우 변경",
        "unsavedBody": "워크플로우 캔버스에 저장되지 않은 변경이 있습니다. 지금 Ontology Graph를 떠나도 변경은 유실되지 않지만, 브라우저를 닫기 전에 반드시 돌아와서 저장하세요. 계속할까요?",
        "cancel": "취소",
        "continue": "계속",
        "recordCount": "비즈니스 레코드 {{count}}개"
      }
    },
    "panels": {
      "classDetail": {
        "selectHint": "캔버스에서 비즈니스 레코드를 선택하면 상세를 볼 수 있습니다.",
        "sharedRecord": "공유 레코드",
        "descriptionPlaceholder": "이 레코드가 무엇을 나타내는지 설명",
        "instances": "인스턴스",
        "usedByWorkflows": "사용 중인 워크플로우 (",
        "noWorkflowUses": "이 레코드를 사용하는 워크플로우가 없습니다.",
        "fields": "필드 (",
        "addField": "+ 필드 추가",
        "noFields": "정의된 필드가 없습니다.",
        "links": "링크 (",
        "noLinks": "정의된 링크가 없습니다.",
        "editInWorkflow": "워크플로우에서 편집…",
        "discard": "버리기",
        "closeAria": "클래스 상세 닫기",
        "confirmIntro": "다음 작업을 수행하려고 합니다",
        "confirmAffect": ". 이는",
        "confirmEnd": "에 영향을 미칩니다. 저장 후 각 항목이 필드를 다르게 읽거나 쓰게 됩니다. 계속할까요?",
        "cancel": "취소",
        "continue": "계속",
        "noWorkflowsYet": "이 레코드를 사용하는 워크플로우가 아직 없습니다",
        "parentClass": "부모 클래스",
        "noParent": "없음 (최상위 클래스)"
      },
      "ontologyBinding": {
        "fieldNamePlaceholder": "필드 이름",
        "removeFieldAria": "필드 제거",
        "addField": "필드 추가",
        "controlStepInfo": "이 단계는 컨트롤 단계입니다 — 비즈니스 레코드를 저장하지 않으므로 레코드 매핑이 필요 없습니다.",
        "chooseRecord": "온톨로지 클래스 선택",
        "useExisting": "기존 클래스 사용",
        "createNewType": "새 클래스 타입 생성",
        "sharedRecord": "공유 클래스",
        "searchRecords": "온톨로지 클래스 검색",
        "searchPlaceholder": "검색어 입력 (예: invoice)",
        "noMatch": "일치하는 레코드가 없습니다",
        "createNewHint": "기존 레코드 타입과 같지 않을 때만 새로 생성하세요.",
        "createNewPrefix": "다음 이름으로 새 레코드 타입 생성: \"",
        "createNewSuffix": "\"",
        "createNewWarn": "기존 레코드 타입과 같지 않을 때만 새로 생성하세요.",
        "newRecord": "새 비즈니스 레코드",
        "recordName": "레코드 이름",
        "recordCategory": "레코드 카테고리",
        "fieldsTitle": "필드",
        "mapFields": "필드 매핑",
        "mapHint": "각 단계 출력 필드를 일치하는 레코드 필드에 연결하세요.",
        "addMapping": "매핑 추가",
        "noMappings": "아직 매핑이 없습니다. 저장할 단계 출력 필드마다 행이 필요합니다.",
        "stepField": "단계 필드",
        "recordField": "레코드 필드",
        "removeMappingAria": "매핑 제거",
        "optional": "선택",
        "linkToOthers": "다른 레코드와 연결",
        "showLinkFields": "링크 필드 보기",
        "hideLinkFields": "링크 필드 숨기기",
        "addLink": "링크 추가",
        "noLinksFromStep": "이 단계의 링크가 없습니다. 예: Invoice를 Supplier에 연결.",
        "linkName": "링크 이름",
        "linkedRecord": "연결된 레코드",
        "count": "개수",
        "removeLinkAria": "링크 제거",
        "alsoCaptured": "다른 곳에서도 캡처됨",
        "alsoCapturedDesc": "이 링크들은 다른 워크플로우에서 이 레코드에 이미 정의되어 있습니다.",
        "tabLabel": "온톨로지 바인딩",
        "whatIsThis": "이 스텝의 실행 결과를 온톨로지 클래스에 연결합니다. 연결된 데이터는 Object Explorer와 리포트에서 자동으로 조회됩니다.",
        "noClassesYet": "아직 등록된 온톨로지 클래스가 없습니다. 온톨로지 그래프 탭에서 먼저 클래스를 만드세요.",
        "bindingOn": "온톨로지에 저장",
        "bindingOff": "온톨로지 저장 안 함",
        "bindingDisabledInfo": "이 스텝의 결과는 온톨로지에 저장되지 않고 다음 스텝으로만 전달됩니다."
      },
      "propertyInUse": {
        "title": "필드 사용 중",
        "noConflictDetails": "충돌 상세 정보가 없습니다.",
        "close": "닫기",
        "stillInUseTitle": "필드가 여전히 사용 중입니다",
        "referencedBy": "다음에서 참조됨",
        "stillInUseBody": "여기서 삭제하기 전에 해당 워크플로우 단계에서 필드를 제거하세요. 그렇지 않으면 단계가 존재하지 않는 바인딩을 가리키게 됩니다.",
        "usedIn": "사용 위치",
        "couldNotResolve": "차단 워크플로우를 확인할 수 없습니다.",
        "arrow": "→",
        "uses": "(사용:",
        "suggested": "권장 다음 단계",
        "technical": "기술 상세",
        "errorCode": "errorCode:",
        "cancelSave": "저장 취소"
      },
      "stepConfig": {
        "stepName": "단계 이름",
        "stepType": "단계 종류",
        "connectorRef": "커넥터 참조 (선택)",
        "connectorRefPlaceholder": "예: supabase:invoices",
        "inputFields": "입력 필드",
        "addField": "필드 추가",
        "noInputFields": "선언된 입력 필드가 없습니다. 이 단계가 생성하는 행 컬럼을 추가하면 온톨로지 속성에 매핑할 수 있습니다.",
        "fieldNamePlaceholder": "필드 이름"
      },
      "typeConflict": {
        "title": "충돌",
        "noConflictDetails": "충돌 상세 정보가 없습니다.",
        "close": "닫기",
        "inconsistentFormat": "데이터 형식 불일치",
        "isAlreadySavedAs": "는 이미 다음 타입으로 저장되었습니다:",
        "workflowTryingToSave": "이 워크플로우는 다음 타입으로 저장하려 합니다:",
        "mixingWarning": ". 둘을 혼합하면 합계, 평균, 비교가 신뢰할 수 없게 됩니다.",
        "alreadyUsedIn": "이미 사용 중:",
        "couldNotResolve": "원본 정의를 확인할 수 없습니다.",
        "arrow": "→",
        "suggested": "권장 다음 단계",
        "technical": "기술 상세",
        "existingDataType": "existingDataType:",
        "attemptedDataType": "attemptedDataType:",
        "errorCode": "errorCode:",
        "cancelSave": "저장 취소"
      }
    },
    "inspectors": {
      "source": {
        "title": "데이터 가져오기",
        "description": "DB·API·파일에서 데이터를 읽어옵니다. 커넥터는 Designer > Connect 메뉴에서 먼저 등록하세요.",
        "noConnections": "아직 등록된 SQL 연결이 없습니다. Designer > Connections에서 데이터베이스 연결을 먼저 등록하세요.",
        "noConnectionsShort": "등록된 연결이 없어 선택할 수 없습니다.",
        "goToConnections": "연결 등록하러 가기",
        "connectionHelp": "등록된 연결을 선택하세요. 실행 시 이 연결로 데이터를 읽어옵니다.",
        "advancedLegacy": "고급 (legacy)",
        "legacyMode": "Legacy connectorRef (sample_csv:, sparql_select:, rest_pull:)",
        "legacyHelp": "하위 호환용 문자열 스킴입니다. 가능하면 위의 연결 등록 방식을 사용하세요.",
        "legacyNote": "연결 선택을 비워 두면 이 legacy 스킴이 사용됩니다."
      },
      "transform": {
        "title": "데이터 변환",
        "description": "이 스텝은 현재 backend config.transformations 배열로만 동작합니다. 시각적 변환 규칙 UI는 Phase 2의 Set Fields 노드로 대체될 예정입니다."
      },
      "output": {
        "title": "결과 저장",
        "description": "file, rest, connector 중 출력 타입을 선택하고 해당 타입의 필드만 입력하세요. 빈 sink config는 실행 시 OUTPUT_SINK_CONFIG_MISSING 오류를 발생시킵니다."
      },
      "notification": {
        "title": "알림 발송",
        "description": "이메일·Slack·Webhook으로 알림을 보냅니다. {{변수}}로 이전 스텝 결과를 참조하세요."
      },
      "approval": {
        "title": "승인 요청",
        "description": "지정된 담당자가 승인할 때까지 워크플로우를 일시 중지합니다."
      },
      "validation": {
        "title": "검증",
        "description": "현재 카드 결제 도메인 규칙만 적용합니다. 일반 스키마/SPARQL 검증은 Phase 2 범위입니다."
      },
      "action": {
        "title": "액션 실행",
        "description": "등록된 bounded action을 실행합니다."
      },
      "wait": {
        "title": "대기",
        "description": "설정된 시간 동안 또는 조건이 충족될 때까지 실행을 중지합니다."
      },
      "query": {
        "title": "쿼리",
        "description": "SPARQL 또는 SQL 쿼리를 실행합니다."
      },
      "object_query": {
        "title": "객체 조회",
        "description": "Object Explorer에서 온톨로지 인스턴스를 조회합니다."
      },
      "graph_write": {
        "title": "그래프 쓰기",
        "description": "온톨로지 그래프에 인스턴스를 생성·수정·삭제합니다."
      },
      "report_generate": {
        "title": "리포트 생성",
        "description": "데이터 또는 그래프 컨텍스트로 리포트를 생성합니다."
      },
      "trigger": {
        "title": "트리거",
        "description": "워크플로우 시작 조건을 설정합니다."
      },
      "decision": {
        "title": "조건 분기",
        "description": "조건에 따라 다음 스텝을 결정합니다."
      },
      "http_request": {
        "title": "HTTP 요청",
        "description": "외부 REST API를 커넥터 사전 등록 없이 직접 호출합니다. URL/본문에 {{row.필드명}} 치환을 사용해 입력 row 마다 다르게 호출할 수 있습니다."
      },
      "set_fields": {
        "title": "필드 가공",
        "description": "row 의 필드를 추가/변경명/삭제/계산합니다. row 수는 유지되며, row 자체를 거르려면 Filter 노드를 사용하세요."
      },
      "filter": {
        "title": "필터",
        "description": "조건에 맞는 row 만 통과시킵니다. Simple 모드는 필드/연산자/값을 선택하고, Expression 모드는 safe-AST 평가기로 직접 식을 작성합니다. 통과한 row 는 모든 필드를 유지합니다."
      },
      "code": {
        "title": "코드",
        "description": "RestrictedPython 샌드박스 안에서 사용자가 작성한 Python 을 실행합니다. import / file·network I/O / eval·exec 모두 차단됩니다. Set Fields 와 Filter 로 표현할 수 없는 가공 (예: OCR raw text 다단계 정규화) 에 사용합니다."
      },
      "merge": {
        "title": "병합",
        "description": "여러 입력 브랜치를 하나의 row 스트림으로 합칩니다. 모드: append (모든 브랜치 단순 concat), merge_by_key (공통 key 로 dict 병합, 충돌 시 후행 브랜치 우선), inner_join (매칭된 pair 만 유지), left_join (left 모든 row 유지, right 미매칭 필드는 null)."
      },
      "sub_workflow": {
        "title": "하위 워크플로",
        "description": "다른 unified workflow를 한 step으로 호출합니다. 자기 자신 호출(self-reference), 순환 호출(cycle), 깊이 10 초과는 실행 시 차단됩니다."
      },
      "loop": {
        "title": "반복",
        "description": "body step을 리스트의 각 항목별로 (for_each) 또는 조건이 참인 동안 (while) 반복 실행합니다. 법인카드 거래 1건에 첨부된 여러 영수증을 각각 OCR 처리할 때 for_each 모드를 사용합니다. while 모드는 조건이 만족될 때까지 재시도하는 경우에 사용합니다. self-reference 와 존재하지 않는 body step ID 는 실행 시 차단됩니다 (LOOP_BODY_SELF_REFERENCE / LOOP_BODY_NOT_FOUND)."
      },
      "parallel": {
        "title": "병렬 실행",
        "description": "여러 분기 step 을 동시에 실행하고 결과를 합칩니다. 검증과 매칭을 동시에 처리해야 하거나, ontologyBinding 에서 Receipt / ApprovalCase / Vendor / Employee 를 sibling 으로 동시 기록할 때 사용합니다. 중첩된 parallel 과 존재하지 않는 stepRef 는 실행 시 차단됩니다 (PARALLEL_NESTED_NOT_SUPPORTED / PARALLEL_BRANCH_STEP_NOT_FOUND)."
      },
      "fields": {
        "connectorId": "커넥터 ID",
        "query": "SQL / 쿼리 / Path",
        "params": "파라미터",
        "outputField": "출력 필드명",
        "type": "출력 타입",
        "outputTypeHelp": "OutputSinkDispatcher가 읽는 필수 discriminator입니다: file, rest, connector.",
        "path": "파일 경로",
        "outputPathHelp": "file 출력 필수값입니다. 백엔드는 data/output 아래에만 쓰고 외부 경로는 거부합니다.",
        "outputFormatHelp": "file 출력 필수값입니다. 지원값은 csv, json, jsonl입니다.",
        "url": "URL",
        "outputUrlHelp": "REST 출력 필수값입니다. URL 템플릿은 렌더링 후 백엔드 SSRF guard로 검사됩니다.",
        "method": "HTTP 메서드",
        "outputMethodHelp": "REST 출력 선택값입니다. 백엔드는 POST와 PUT을 지원하며, 비우면 POST를 사용합니다.",
        "headers": "헤더",
        "outputHeadersHelp": "선택 REST headers 객체입니다. 템플릿 값은 전송 전에 렌더링됩니다.",
        "bodyTemplate": "본문 템플릿",
        "outputBodyTemplateHelp": "선택 REST JSON body template입니다. 비우면 {\"rows\": input rows}를 전송합니다.",
        "auth": "인증",
        "outputAuthHelp": "선택 REST auth 객체입니다. bearer, basic, api_key 타입을 지원합니다.",
        "connectorSlug": "커넥터 slug",
        "connectorSlugHelp": "toolAction에 커넥터 slug가 포함되지 않은 connector 출력에서 필수입니다.",
        "toolAction": "도구 액션",
        "toolActionHelp": "connector 출력 필수값입니다. 예: append_rows 또는 google_sheets.append_rows.",
        "payloadTemplate": "페이로드 템플릿",
        "payloadTemplateHelp": "백엔드가 렌더링하는 선택 connector payload template 객체입니다.",
        "transformations": "Transformations (raw JSON)",
        "transformationsHelp": "Backend transformations array 전용. Phase 2의 Set Fields 노드 (TASK_202)가 정식 시각 UI를 대체할 예정입니다.",
        "channel": "채널",
        "recipient": "수신자",
        "subject": "제목",
        "template": "메시지 본문",
        "approverRole": "승인자 역할",
        "approvalMessage": "승인 요청 메시지",
        "timeoutHours": "자동처리 대기 (시간)",
        "onTimeout": "타임아웃 처리",
        "validationType": "검증 타입",
        "validationTypeHelp": "validator 엔진을 선택합니다. schema/sparql_ask/rules/expression은 도메인 중립이며, card_validation은 Finance Controller pack (기존 13 필드)입니다.",
        "validationTypeSchema": "JSON Schema",
        "validationTypeSparqlAsk": "SPARQL ASK",
        "validationTypeRules": "Rules engine",
        "validationTypeExpression": "Safe expression",
        "validationTypeCardValidation": "카드 검증 (Finance Controller pack)",
        "failureMode": "실패 처리",
        "failureModeHelp": "fail_step: 첫 reject row에서 워크플로 중단. route_reject: pass / reject lane으로 분리 (lane target 필수). notify_only: issue 첨부 후 계속 진행.",
        "failureModeFailStep": "스텝 실패 (워크플로 중단)",
        "failureModeRouteReject": "reject lane으로 라우팅",
        "failureModeNotifyOnly": "통지만 (issue 첨부 후 계속)",
        "validationJsonSchema": "JSON Schema",
        "validationJsonSchemaHelp": "JSON Schema Draft 2020-12 객체. row를 인스턴스로 검증합니다.",
        "validationAskQuery": "SPARQL ASK 쿼리",
        "validationAskQueryHelp": "row에 대한 SPARQL ASK. row field를 VALUES binding으로 주입하며 ASK=true이면 row가 통과합니다.",
        "validationSparqlEndpoint": "SPARQL 엔드포인트 (선택)",
        "validationSparqlEndpointHelp": "공란일 경우 프로젝트 Fuseki dataset을 사용합니다.",
        "validationRules": "규칙 (JSON 배열)",
        "validationRulesHelp": "{kind, field, ...} 배열. 지원 kind: required, tolerance, enum, range, regex.",
        "validationExpression": "Boolean 식",
        "validationExpressionHelp": "안전 AST 평가 boolean 식. row field는 bare name으로 참조합니다 (예: amount > 0 and merchant != '').",
        "validationPassNextStepId": "Pass lane → 다음 스텝 ID",
        "validationPassNextStepIdHelp": "failureMode=route_reject 일 때 필수. lane id 계약: 'pass'. 검증 통과 row가 여기로 흐릅니다.",
        "validationRejectNextStepId": "Reject lane → 다음 스텝 ID",
        "validationRejectNextStepIdHelp": "failureMode=route_reject 일 때 필수. lane id 계약: 'reject'. reject row가 validationIssues 첨부 후 여기로 흐릅니다.",
        "requiredEvidence": "필수 증빙",
        "requiredEvidenceHelp": "배열로 입력합니다. 지원값: cardApproval, receiptOrTaxInvoice, purpose.",
        "onMissing": "증빙 누락 처리",
        "onMissingHelp": "필수 증빙 또는 고액 필드가 없을 때 validation issue에 기록할 action입니다.",
        "validateEvidenceMatch": "증빙 일치 검증",
        "validateEvidenceMatchHelp": "JSON boolean true/false로 입력합니다. true이면 금액, 가맹점, 시각, 사업자번호를 비교합니다.",
        "onEvidenceMismatch": "증빙 불일치 처리",
        "onEvidenceMismatchHelp": "증빙 일치 검증에서 불일치가 발견될 때 기록할 action입니다.",
        "onViolation": "위반 처리",
        "onViolationHelp": "중복, 월 한도, 심야, 주말 목적 누락 위반에 기록할 action입니다.",
        "amountToleranceKrw": "금액 허용 오차 (원)",
        "amountToleranceKrwHelp": "카드 승인금액과 증빙 금액 비교 허용 오차입니다. 기본값은 100원입니다.",
        "matchToleranceMinutes": "시각 허용 오차 (분)",
        "matchToleranceMinutesHelp": "카드 승인시각과 증빙 발행시각 비교 허용 오차입니다. 기본값은 30분입니다.",
        "highAmountThreshold": "고액 기준 금액 (원)",
        "highAmountThresholdHelp": "amount가 이 값을 초과하면 고액 추가 필드를 검사합니다.",
        "highAmountExtraFields": "고액 추가 필드",
        "highAmountExtraFieldsHelp": "고액 건에서 필수로 요구할 row field 이름 배열입니다. businessPurpose는 purpose로도 인정됩니다.",
        "duplicateRule": "중복 결제 규칙",
        "duplicateRuleHelp": "객체로 입력합니다. 예: {\"fields\":[\"amount\",\"merchantName\"],\"timeWindowMinutes\":10}.",
        "monthlyLimitKrw": "월 한도 금액 (원)",
        "monthlyLimitKrwHelp": "row amount가 이 값을 초과하면 월 한도 초과 issue를 기록합니다.",
        "lateNightStartHour": "심야 시작 시각",
        "lateNightStartHourHelp": "transactionAt의 hour가 이 값 이상이면 심야 사용 issue를 기록합니다.",
        "weekendRequiresPurpose": "주말 목적 필수",
        "weekendRequiresPurposeHelp": "JSON boolean true/false로 입력합니다. true이면 주말 거래에 purpose가 필요합니다.",
        "actionId": "액션 ID",
        "inputPayload": "입력 페이로드",
        "retryCount": "재시도 횟수",
        "waitType": "대기 방식",
        "duration": "대기 시간 (초)",
        "until": "대기 종료 시각",
        "queryType": "쿼리 종류",
        "endpoint": "엔드포인트 (선택)",
        "classRef": "클래스 ID",
        "filter": "필터 조건 (JSON)",
        "limit": "최대 반환 수",
        "writeOp": "작업",
        "mapping": "필드 매핑 (JSON)",
        "templateId": "리포트 템플릿 ID",
        "reportTitle": "리포트 제목",
        "format": "출력 형식",
        "triggerType": "트리거 종류",
        "cron": "Cron 표현식",
        "webhookPath": "Webhook Path",
        "condition": "분기 조건 (표현식)",
        "truePath": "참(true) 경로 스텝 ID",
        "falsePath": "거짓(false) 경로 스텝 ID",
        "httpMethod": "HTTP 메서드",
        "httpMethodHelp": "GET / POST / PUT / PATCH / DELETE / HEAD 중 선택.",
        "httpUrl": "요청 URL",
        "httpUrlHelp": "전체 https URL. 자격증명은 ${secret.이름} 으로, row 별 치환은 {{row.필드명}} 으로 입력합니다.",
        "httpHeaders": "헤더 (JSON 객체)",
        "httpHeadersHelp": "헤더 객체. secret/row 템플릿은 전송 전에 치환됩니다.",
        "httpBody": "본문 (JSON 또는 문자열)",
        "httpBodyHelp": "요청 본문. 객체/배열은 JSON 으로 직렬화되고 문자열은 그대로 전송됩니다. GET/HEAD 는 비워두세요.",
        "httpAuth": "인증",
        "httpAuthHelp": "선택. {\"type\":\"bearer\",\"token\":\"${secret.토큰}\"} 또는 {\"type\":\"basic\",\"username\":\"...\",\"password\":\"${secret.비밀번호}\"}.",
        "httpTimeoutSeconds": "타임아웃 (초)",
        "httpTimeoutSecondsHelp": "요청당 타임아웃. 기본 30, 최대 120.",
        "httpRetry": "재시도 정책 (JSON)",
        "httpRetryHelp": "선택. attempts 1-5, backoffMs 100-5000. POST/PATCH 는 allowNonIdempotent:true 가 있어야 재시도합니다.",
        "httpResponseFormat": "응답 형식",
        "httpResponseFormatHelp": "json: 본문을 row 로 파싱. text/raw: metadata 에만 기록.",
        "httpFailOn": "실패 처리 기준",
        "httpFailOnHelp": "이 상태 코드 범위에 도달하면 스텝을 실패로 표시합니다.",
        "httpIterateRows": "입력 row 마다 호출",
        "httpIterateRowsHelp": "JSON boolean. true 면 입력 row 마다 한 번씩 호출하고 {{row.필드명}} 을 치환합니다.",
        "filterMode": "모드",
        "filterModeHelp": "Simple: 필드/연산자/값으로 지정. Expression: safe-AST 평가기로 직접 작성 (Set Fields 와 동일 문법).",
        "filterField": "필드",
        "filterFieldHelp": "비교 대상 row 필드. 점 경로 지원 (예: _httpResponse.body.status).",
        "filterOperator": "연산자",
        "filterOperatorHelp": "Simple 모드는 eq/ne/gt/gte/lt/lte/is_empty/is_not_empty 만 지원. contains/in 은 Expression 모드 필요.",
        "filterValue": "값",
        "filterValueHelp": "필드와 비교할 값. 문자열은 자동으로 따옴표 처리되고, 숫자는 따옴표 없이 입력합니다.",
        "filterExpression": "표현식",
        "filterExpressionHelp": "boolean 식. 예: ${amount} >= 500000 && ${status} != 'rejected'. 결과가 boolean 이 아니면 거부됩니다.",
        "codeLanguage": "언어",
        "codeLanguageHelp": "v1 은 Python 만 지원. JavaScript 는 노출만 되고 백엔드가 CODE_LANGUAGE_NOT_SUPPORTED 로 거부합니다.",
        "codeSource": "소스 코드",
        "codeSourceHelp": "Python 소스. 결과는 output alias (기본값: result) 변수에 할당해야 합니다. import / open / eval / exec / subprocess 는 샌드박스가 차단합니다.",
        "codeIterateRows": "입력 row 마다 실행",
        "codeIterateRowsHelp": "JSON boolean. true (기본): row 마다 한 번씩 실행, output alias 는 dict 여야 함. false: 전체 row 리스트를 한 번에 받아 실행, output alias 는 list[dict] 여야 함.",
        "codeInputAlias": "입력 alias",
        "codeInputAliasHelp": "사용자 코드가 입력 row 를 읽을 변수명. 기본값은 iterateRows=true 면 row, false 면 rows.",
        "codeOutputAlias": "출력 alias",
        "codeOutputAliasHelp": "사용자 코드가 결과를 할당할 변수명. 기본값은 result. 입력 alias 와 달라야 합니다.",
        "codeTimeoutSeconds": "타임아웃 (초)",
        "codeTimeoutSecondsHelp": "SIGALRM 기반 실행 wall-clock 한도. 기본 5, 최대 30. 초과 시 CODE_TIMEOUT 으로 스텝이 실패합니다.",
        "mergeMode": "모드",
        "mergeModeHelp": "append: 모든 브랜치 concat. merge_by_key: 공통 key 필드로 row 그룹화. inner_join: 매칭된 left × right pair 만 유지. left_join: left 모든 row 유지, right 미매칭은 null 채움.",
        "mergeKey": "병합 key 필드",
        "mergeKeyHelp": "브랜치 간 공통 key 필드명. 같은 key 값을 가진 row 는 dict spread 로 병합되며, 필드 충돌 시 후행 브랜치 값이 우선합니다 (right-wins).",
        "mergeLeftBranch": "Left 브랜치 (upstream step ID)",
        "mergeLeftBranchHelp": "join 의 left 측을 공급하는 연결된 upstream step ID. 연결되지 않은 ID 는 MERGE_BRANCH_NOT_FOUND 로 실패합니다.",
        "mergeRightBranch": "Right 브랜치 (upstream step ID)",
        "mergeRightBranchHelp": "join 의 right 측을 공급하는 연결된 upstream step ID. left 와 달라야 합니다.",
        "mergeLeftKey": "Left join key",
        "mergeLeftKeyHelp": "Left 브랜치 row 에서 join key 로 사용할 필드명. 허용 타입: string/number/boolean/null.",
        "mergeRightKey": "Right join key",
        "mergeRightKeyHelp": "Right 브랜치 row 에서 join key 로 사용할 필드명. 허용 타입: string/number/boolean/null.",
        "mergeBranchOrder": "브랜치 순서 (JSON 배열)",
        "mergeBranchOrderHelp": "선택 사항. append / merge_by_key 의 반복 순서를 지정하는 upstream step ID JSON 배열. 미입력 시 edge 등록 순서를 사용합니다. 연결되지 않은 ID 가 포함되면 MERGE_BRANCH_NOT_FOUND, 누락된 연결 브랜치는 자동으로 tail 에 추가됩니다.",
        "loopMode": "모드",
        "loopModeHelp": "for_each: iterableExpr 가 만든 리스트의 모든 항목을 순회. while: conditionExpr 이 false 가 될 때까지 반복 (매 반복 전 재평가).",
        "loopBody": "Body step ID",
        "loopBodyHelp": "매 반복마다 실행할 body step ID. 같은 워크플로의 다른 step 을 가리켜야 하며, 자기 자신을 가리키면 LOOP_BODY_SELF_REFERENCE, 존재하지 않는 ID 면 LOOP_BODY_NOT_FOUND 가 발생합니다.",
        "loopIterableExpr": "Iterable 표현식 (for_each)",
        "loopIterableExprHelp": "loop 입력 context 에서 평가되어 리스트를 반환해야 하는 표현식. 카드 거래 1건에 영수증이 첨부된 경우 예시: ${input.rows[0].receipts}. 결과가 리스트가 아니면 LOOP_VALIDATION_ERROR.",
        "loopConditionExpr": "조건 표현식 (while)",
        "loopConditionExprHelp": "매 반복 전에 재평가되는 boolean 식. 예: ${context.attemptCount} < 3. 결과는 boolean 이어야 합니다.",
        "loopIterationVar": "반복 변수명",
        "loopIterationVarHelp": "body 의 prior_outputs context 에서 현재 항목에 바인딩되는 변수명. 기본값 'item'.",
        "loopIndexVar": "Index 변수명",
        "loopIndexVarHelp": "body 의 prior_outputs context 에서 현재 반복 index 에 바인딩되는 변수명. 기본값 'idx'.",
        "loopMaxIterations": "최대 반복 횟수",
        "loopMaxIterationsHelp": "안전 상한. 기본 1000, 최대 100000. for_each 모드에서 리스트 길이가 이 값을 넘으면 첫 iteration 전에 LOOP_MAX_ITERATIONS_EXCEEDED 로 실패합니다.",
        "loopConcurrency": "동시 실행 수",
        "loopConcurrencyHelp": "병렬 반복 수. 현재 1만 지원하며, 1 초과 값은 worker pool 구현 전까지 LOOP_VALIDATION_ERROR 로 거부됩니다.",
        "loopPerIterationTimeoutSeconds": "반복당 타임아웃 (초)",
        "loopPerIterationTimeoutSecondsHelp": "body 1회 실행 wall-clock 상한. 기본 30. 초과 시 해당 반복이 LOOP_TIMEOUT_EXCEEDED 로 실패합니다.",
        "loopTotalTimeoutSeconds": "전체 타임아웃 (초)",
        "loopTotalTimeoutSecondsHelp": "loop 전체 wall-clock 상한. 기본 300. 초과 시 LOOP_TIMEOUT_EXCEEDED 가 발생하며 loopTrace 에 totalIterations 가 기록됩니다.",
        "loopCollectResults": "결과 수집 모드",
        "loopCollectResultsHelp": "aggregate: 모든 반복의 출력 row 를 concat (기본). last: 마지막 반복의 row 만 유지. none: row 는 버리고 loopTrace metadata 만 남김.",
        "loopEarlyExit": "조기 종료 (JSON 객체)",
        "loopEarlyExitHelp": "선택. {\"conditionExpr\":\"...\"} 형태. 각 반복 후 평가되는 boolean 식. true 이면 loop 가 조기 종료되고 loopTrace.earlyExitTriggered 에 기록됩니다."
      }
    },
    "workflow": {
      "runResult": {
        "labelObjectSet": "객체 집합",
        "labelSourceRefs": "소스 참조",
        "labelGraphRefs": "그래프 참조",
        "labelPolicyDecision": "정책 결정",
        "labelActionExecutionRef": "액션 실행 참조",
        "labelApprovalRef": "승인 참조",
        "labelEnvelopeError": "엔벨로프 오류",
        "labelSnapshot": "스냅샷",
        "labelExecutionSnapshot": "실행 스냅샷",
        "replay": "재실행",
        "rowsIn": "입력 행:",
        "rowsOut": "→ 출력 행:",
        "executionSnapshot": "실행 스냅샷",
        "viewRecords": "BI 리포트 열기",
        "captured": "캡처됨",
        "records": "레코드",
        "domainError": "도메인 오류",
        "suggestedActions": "권장 액션",
        "semanticEnvelope": "시맨틱 엔벨로프",
        "runResultTitle": "실행 결과",
        "closeAria": "실행 결과 패널 닫기",
        "runningWorkflow": "워크플로우 실행 중…",
        "runId": "실행 ID:",
        "noStepResults": "이 실행에 기록된 단계 결과가 없습니다.",
        "clickRunHint": "워크플로우를 실행하려면 \"Run\"을 클릭하세요.",
        "statusLabels": {
          "succeeded": "성공",
          "failed": "실패",
          "running": "실행 중…",
          "pending": "대기",
          "paused": "일시 중지 (승인 대기)",
          "cancelled": "중지됨"
        },
        "stop": "중지"
      },
      "stepPalette": {
        "title": "단계 팔레트"
      },
      "unifiedStepNode": {
        "noRecordYet": "온톨로지 바인딩 없음",
        "chooseRecordType": "레코드 타입 선택",
        "controlStep": "제어 step",
        "removeStep": "단계 제거",
        "chooseRecord": "비즈니스 레코드 선택",
        "openInOntologyTooltip": "이 비즈니스 레코드를 Ontology 탭에서 열기",
        "orphanBinding": "레코드 누락",
        "orphanBindingTooltip": "이 단계가 바인딩한 비즈니스 레코드가 더 이상 이 프로젝트에 존재하지 않습니다. 다른 레코드를 선택하거나 삭제된 레코드를 복원하세요 — 그대로 저장하면 실패합니다.",
        "caseColorOverflow": "분기 case {{count}}개 초과",
        "caseColorOverflowTooltip": "처음 {{count}}개 분기 case만 서로 다른 색상을 받습니다. 추가 case는 overflow 색상을 사용하므로 라벨을 함께 확인하세요.",
        "binding": {
          "writesTo": "{{className}} 에 기록",
          "readsFrom": "{{className}} 에서 읽음",
          "reportsOn": "{{className}} 기반 보고",
          "willCaptureTo": "{{className}} 에 기록 예정",
          "fallbackClassName": "비즈니스 레코드",
          "tooltipGraphWrite": "이 step 이 실행되면 ontology 에 instance 가 직접 기록됩니다 (SPARQL INSERT/DELETE/LINK).",
          "tooltipObjectQuery": "이 step 은 ontology 에서 instance 를 읽어옵니다. 자체적으로 instance 를 만들지 않습니다.",
          "tooltipReportGenerate": "이 step 은 해당 클래스 instance 기반 보고서를 생성합니다. Ontology 를 수정하지 않습니다.",
          "tooltipPostHookCapture": "Instance 는 workflow run 시점에 post-execution hook 으로 ontology 에 기록됩니다. 저장은 binding 만 등록합니다.",
          "tooltipUnboundCapable": "비즈니스 레코드를 선택해야 이 단계가 행을 저장할 수 있습니다.",
          "tooltipControlStep": "이 단계는 워크플로우를 제어하며 레코드를 생성하지 않습니다."
        }
      },
      "workflowCanvas": {
        "backToOntology": "← 온톨로지로 돌아가기",
        "workflowName": "워크플로우 이름",
        "description": "설명",
        "unsavedChanges": "저장되지 않은 변경",
        "restore": "복원",
        "discard": "버리기",
        "foundUnsaved": "이전 세션의 저장되지 않은 변경을 발견했습니다 (",
        "arrowsOrder": "화살표 = 워크플로우 순서",
        "recordLinksInside": "각 단계 안에 레코드 링크가 표시됩니다.",
        "startWithGetData": "'데이터 가져오기' 단계 추가로 시작",
        "exampleHint": "예: 인보이스 가져오기, 구매 주문 가져오기, 공급사 비용 로드. 그 후 '처리' 또는 '저장' 단계를 추가해 흐름을 완성합니다.",
        "addGetDataStep": "'데이터 가져오기' 단계 추가",
        "stepLabel": "단계",
        "closeStepInspectorAria": "단계 인스펙터 닫기",
        "tabConfig": "설정",
        "tabBusinessRecord": "온톨로지 바인딩",
        "selectStepOrArrow": "단계나 화살표를 선택해 편집하세요.",
        "dragFromPalette": "왼쪽 팔레트에서 단계를 캔버스로 끌어 흐름을 시작하세요.",
        "leaveTitle": "저장하지 않고 떠나시겠습니까?",
        "leaveBody": "저장되지 않은 워크플로우 변경이 있습니다. 이 페이지를 떠나면 잃게 됩니다.",
        "stayOnPage": "페이지에 머무르기",
        "leaveAnyway": "그래도 떠나기",
        "runTitle": "이 워크플로우를 실행하시겠습니까?",
        "runBody": "이 워크플로우를 실행하면 모든 단계가 실행되고 프로젝트 그래프에 온톨로지 레코드가 생성됩니다. 계속할까요?",
        "cancel": "취소",
        "runWorkflow": "워크플로우 실행",
        "removeStepTitle": "단계를 제거할까요?",
        "removeStepBody": "연결된 화살표가 제거됩니다. 이 단계가 참조하는 기존 비즈니스 레코드는 삭제되지 않습니다.",
        "removeStep": "단계 제거",
        "arrowLabel": "화살표",
        "closeEdgeInspectorAria": "엣지 인스펙터 닫기",
        "fromField": "From 필드 (선택)",
        "toField": "To 필드 (선택)",
        "removeArrow": "화살표 제거",
        "saving": "저장 중…",
        "saveChanges": "변경 저장",
        "saved": "저장됨",
        "runShort": "실행",
        "runningShort": "실행 중…",
        "runDisabledDefault": "이 워크플로우 실행",
        "showFieldContracts": "필드 계약 표시",
        "fieldContractWarning": "fromField/toField는 trace 라벨일 뿐입니다. 현재 backend는 이 필드를 강제하지 않습니다."
      },
      "dryRun": {
        "title": "Dry-run 미리보기",
        "runDryRun": "Dry-run 실행",
        "ontologyChanges": "온톨로지 변경:",
        "noGraphWrites": "예정된 그래프 쓰기가 없습니다.",
        "approvalsNeeded": "실행 전에 필요한 승인 (",
        "openApprovalsTab": "승인 탭 열기",
        "noApprovalsNeeded": "운영자 처리가 필요한 승인 단계가 없습니다.",
        "step": "단계:",
        "requiredApprover": "필요 승인자 —",
        "close": "닫기"
      },
      "listPane": {
        "title": "워크플로우",
        "newWorkflow": "새 워크플로우",
        "noWorkflowsPrefix": "워크플로우가 아직 없습니다. Ready Made Pack을 설치하거나",
        "noWorkflowsClick": "새 워크플로우",
        "noWorkflowsSuffix": "를 클릭해 설계를 시작하세요.",
        "startRun": "실행 시작",
        "dryRun": "Dry-run",
        "recentRuns": "최근 실행",
        "unifiedWorkflows": "Unified 워크플로우 (캔버스에서 편집 가능)",
        "unifiedBadge": "Unified",
        "execute": "실행",
        "openInCanvas": "캔버스에서 열기",
        "executeSucceeded": "실행 성공: {{runId}}",
        "executeStarted": "실행 시작: {{runId}}",
        "executeCancelled": "실행을 중지했습니다: {{runId}}",
        "executeFailed": "실행 실패: {{runId}}",
        "executeFailedStep": "실패 스텝: {{stepId}}",
        "executePaused": "승인 대기 중 — {{runId}}",
        "executePausedCta": "승인 대기함으로",
        "executeViewHistory": "실행 이력 보기"
      },
      "recentRuns": {
        "title": "최근 실행",
        "noRunsYet": "이 워크플로우에 기록된 실행이 없습니다.",
        "viewResult": "결과 보기",
        "close": "닫기"
      }
    }
  },
  "autoInsightShared": {
    "operatorAlerts": {
      "notifications": "알림",
      "operatorNotifications": "운영자 알림"
    },
    "projectStates": {
      "bootstrapSampleProject": "샘플 프로젝트 부트스트랩",
      "retryProjectAccess": "프로젝트 접근 재시도",
      "tutorialRecoveryRequired": "튜토리얼 복구 필요",
      "tutorialRecoveryDesc": "이 튜토리얼 링크는 현재 레지스트리에 없는 튜토리얼 또는 팩을 참조합니다. 유효한 튜토리얼 프로젝트를 만들려면 샘플 부트스트랩을 선택하거나 링크 수정 후 재시도하세요.",
      "unknownTutorialId": "알 수 없는 튜토리얼 ID:",
      "unknownTutorialPack": "알 수 없는 튜토리얼 팩:",
      "needProjectDesc": "Auto Insight가 객체 탐색, 리포트, 워크플로우, 팩 패널을 로드하려면 접근 가능한 프로젝트가 필요합니다. 동작하는 온톨로지와 promoted-pack 데이터로 시작하려면 샘플 프로젝트를 부트스트랩하거나, 프로젝트 접근 권한이 부여된 후 재시도하세요.",
      "bootstrapNote": "샘플 부트스트랩은 /api/tutorial-projects/sample/bootstrap을 사용합니다. 부트스트랩이 실패하면 오류가 여기에 표시되고 폴백 프로젝트는 선택되지 않습니다.",
      "queryUnavailableHeading": "요청한 프로젝트에 접근할 수 없습니다",
      "noAccessHeading": "접근 가능한 프로젝트가 없습니다"
    },
    "consolePanels": {
      "emailRequiredToOpen": "여는 데 현재 사용자 이메일이 필요합니다",
      "workflowsTooltip": "워크플로우"
    },
    "consoleSurface": {
      "emailRequiredForBootstrap": "샘플 프로젝트를 부트스트랩하려면 현재 사용자 이메일이 필요합니다.",
      "operatorAttention": "운영자 조치가 필요한 항목이 {{count}}건 있습니다.",
      "operatorNotifications": "운영 알림 {{count}}건이 갱신되었습니다."
    },
    "reportCard": {
      "sourceRefs": "소스 참조:",
      "dataSources": "데이터 소스:",
      "hash": "해시:"
    },
    "projectResolution": {
      "samplePromotedDescription": "Promoted-pack 준비가 된 샘플 프로젝트."
    }
  },
  "closedLoopWalkthroughPage": {
    "when": "시점",
    "whatHappened": "발생 내용",
    "outcome": "결과",
    "detail": "상세",
    "showTechnicalDetail": "기술 상세 보기",
    "cycleIdLabel": "cycleId:",
    "parentCycleIdLabel": "parentCycleId:",
    "graphDeltaLabel": "graphDelta:",
    "eventFallback": "이벤트",
    "outcomeMissing": "-",
    "eventLabels": {
      "ontology_capture_triggered": "온톨로지 패턴 캡처됨",
      "report_refreshed": "리포트 업데이트됨",
      "cycle_continued": "새 분석 사이클 시작",
      "closed_loop_trigger_dispatched": "분석 사이클 트리거됨",
      "loop_continuation_started": "연속 사이클 시작됨",
      "loop_continuation_completed": "연속 사이클 완료됨",
      "workflow_completed": "워크플로 완료",
      "workflow_started": "워크플로 시작",
      "report_generated": "리포트 생성됨"
    },
    "outcomeLabels": {
      "success": "완료",
      "failure": "실패",
      "pending": "진행 중"
    }
  },
  "schemaCanvasView": {
    "selectProjectHint": "TBox 스키마를 모델링하려면 프로젝트를 선택하세요."
  },
  "aiBuildProposals": {
    "readyMadePackRecommendation": "Ready Made Pack 추천",
    "workflowDraftProposal": "워크플로우 초안 제안",
    "schemaAndCaptureProposal": "스키마 및 캡처 제안",
    "reportDraftProposal": "리포트 초안 제안",
    "connectorAndCredentialRequirements": "커넥터 및 자격 증명 요구사항"
  },
  "serviceErrors": {
    "plannerNoFallback": "프로젝트 그라운딩에 설치된/활성화된/플래너 사용 가능한 항목이 없습니다. 플래너 오케스트레이션이 호출되지 않았으며 폴백 초안이 생성되지 않았습니다.",
    "ontologyImpactUnavailable": "이 프로젝트에는 온톨로지 영향 API가 아직 사용 불가합니다. 생산자, 소비자, 종속 리포트, 영향 받은 팩을 확인할 수 없습니다.",
    "unknownError": "알 수 없는 오류가 발생했습니다."
  },
  "connection": {
    "status": {
      "connected": "연결됨",
      "configured": "설정됨",
      "failed": "실패",
      "disabled": "비활성",
      "unknown": "알 수 없음"
    },
    "types": {
      "supabase": "PostgreSQL 기반 오픈소스 Firebase 대안",
      "firestore": "Google Cloud 실시간 NoSQL 데이터베이스",
      "mongodb": "문서 기반 NoSQL 데이터베이스",
      "bigquery": "Google Cloud 서버리스 데이터 웨어하우스",
      "snowflake": "클라우드 데이터 웨어하우스 플랫폼",
      "databricks": "통합 분석 플랫폼",
      "postgresql": "관계형 데이터베이스 (ERP/MES 연동)",
      "mysql": "관계형 데이터베이스 (MySQL/MariaDB)",
      "mssql": "Microsoft SQL Server 데이터베이스",
      "csv": "CSV 파일 직접 업로드",
      "csvName": "CSV 파일",
      "unknown": "알 수 없는 연결 유형"
    },
    "validation": {
      "supabaseUrl": "Supabase URL이 필요합니다",
      "supabaseKey": "Anon Key 또는 Service Key가 필요합니다",
      "connectionString": "연결 문자열이 필요합니다",
      "databaseName": "데이터베이스 이름이 필요합니다",
      "projectId": "프로젝트 ID가 필요합니다",
      "datasetName": "데이터셋 이름이 필요합니다",
      "credentialsJson": "서비스 계정 인증 JSON이 필요합니다",
      "account": "계정이 필요합니다",
      "userName": "사용자 이름이 필요합니다",
      "password": "비밀번호가 필요합니다",
      "warehouse": "웨어하우스가 필요합니다",
      "database": "데이터베이스가 필요합니다",
      "workspaceUrl": "워크스페이스 URL이 필요합니다",
      "accessToken": "액세스 토큰이 필요합니다",
      "httpPath": "HTTP 경로가 필요합니다",
      "host": "호스트가 필요합니다"
    }
  },
  "authMessages": {
    "passwordChanged": "비밀번호가 성공적으로 변경되었습니다",
    "passwordChangeFailed": "비밀번호 변경에 실패했습니다",
    "accessDenied": "접근이 거부되었습니다",
    "sessionExpiredRelogin": "세션이 만료되었습니다. 다시 로그인해주세요.",
    "sessionExpiringInactivity": "비활성으로 인해 세션이 만료됩니다",
    "sessionExpiringSoon": "세션이 곧 만료됩니다",
    "loginSuccess": "성공적으로 로그인되었습니다",
    "loginFailed": "로그인 시도가 실패했습니다",
    "tokenExpired": "인증 토큰이 만료되었습니다",
    "loggedOutInactivity": "비활성으로 인해 로그아웃됩니다"
  },
  "apiErrors": {
    "sampleBootstrapFailed": "샘플 프로젝트 부트스트랩에 실패했습니다.",
    "loadOperatorAttention": "운영자 관심 상태를 불러오지 못했습니다.",
    "loadCredentialOptions": "자격 증명 옵션을 불러오지 못했습니다.",
    "loadClass": "클래스를 불러오지 못했습니다.",
    "fusekiUnreachable": "Fuseki에 접근할 수 없습니다. 잠시 후 다시 시도하세요.",
    "saveChangesFailed": "변경 저장에 실패했습니다.",
    "loadBusinessRecord": "비즈니스 레코드 상세를 불러오지 못했습니다.",
    "addLinkFailed": "링크 추가에 실패했습니다.",
    "loadBusinessRecords": "비즈니스 레코드를 불러오지 못했습니다.",
    "loadWorkflow": "워크플로우를 불러오지 못했습니다.",
    "saveWorkflow": "워크플로우 저장에 실패했습니다.",
    "loadClasses": "클래스를 불러오지 못했습니다.",
    "loadWorkflows": "워크플로우를 불러오지 못했습니다.",
    "loadUnifiedWorkflows": "Unified 워크플로우를 불러오지 못했습니다.",
    "loadRecentRuns": "최근 실행을 불러오지 못했습니다.",
    "executeWorkflow": "워크플로우 실행에 실패했습니다.",
    "replayWorkflow": "워크플로우 재실행에 실패했습니다.",
    "dryRunFailed": "워크플로우 dry-run에 실패했습니다.",
    "loadCredentialOptionsAlt": "자격 증명 옵션을 불러오지 못했습니다.",
    "loadDataCanvasMetrics": "DataCanvas 지표를 불러오지 못했습니다.",
    "loadDataCanvasSources": "DataCanvas 데이터 소스를 불러오지 못했습니다.",
    "loadDataCanvasRelations": "DataCanvas 관계 통계를 불러오지 못했습니다.",
    "cancelWorkflowRun": "워크플로 실행을 중지하지 못했습니다."
  },
  "marketing": {
    "footer": {
      "copyright": "© {{year}} Infergraph. AI 기반 원가 분석 · 온톨로지 · 에이전틱 자동화.",
      "bestEffortNotice": "본 서비스는 1인 운영자의 자체 호스팅이며 best-effort 운영입니다."
    },
    "nav": {
      "logoAlt": "Infergraph",
      "signIn": "로그인",
      "console": "콘솔"
    },
    "lifecycle": {
      "design": {
        "label": "설계 (Design)",
        "summary": "AI Build가 자연어로 워크플로우·온톨로지·리포트 초안을 동시에 설계합니다."
      },
      "execute": {
        "label": "실행 (Execute)",
        "summary": "Workflow Engine이 한 번만 실행 보장과 자동 재시도로 외부 IT 위에서 운영 작업을 실행합니다."
      },
      "capture": {
        "label": "기억 (Capture)",
        "summary": "Ontology Capture가 실행 결과를 RDF graph와 lineage로 정본화하여 운영 지식으로 축적합니다."
      },
      "explain": {
        "label": "설명 (Explain)",
        "summary": "Insight Report가 결과를 리포트·대시보드로 설명하고 정량 인사이트를 환원합니다."
      },
      "continue": {
        "label": "환원 (Continue)",
        "summary": "Loop Evidence가 단일 사이클 결과와 근거를 모으고, trigger·parameter·policy를 다음 사이클 입력으로 자동 연결합니다."
      },
      "transverse": {
        "connectors": {
          "label": "Connectors",
          "summary": "DB · SaaS · REST · 파일 · MCP · RPA — 외부 IT를 그대로 두고 5단계 cycle이 그 위에서 동작합니다."
        },
        "governance": {
          "label": "Governance",
          "summary": "자격증명 · 승인 · 감사 · 정책 — 모든 단계가 동일한 통제 layer 위에서 안전하게 실행됩니다."
        }
      }
    },
    "onboardingSummary": {
      "title": "처음 사용하시나요?",
      "readOnlyBody": "ready-made pack 설치 → workflow → ontology 캡처 → report → loop 정책 준비까지 6 단계.",
      "startAfterLogin": "로그인하고 시작",
      "openGuide": "시작 가이드 열기"
    },
    "contact": {
      "title": "문의",
      "subtitle": "실 운영 시나리오 · 통합 범위 · 지원 SLA 별 견적 문의를 준비합니다.",
      "alerts": {
        "deliveryNotConnected": "제출하면 입력 내용이 담긴 메일 작성 창이 열립니다. 메일 앱에서 보내기를 누르면 접수가 완료됩니다.",
        "submitLocalOnly": "메일 작성 창을 열었습니다. 메일 앱에서 보내기를 누르면 접수됩니다. 창이 열리지 않았다면 화면의 주소로 직접 보내주세요."
      },
      "fields": {
        "name": "이름",
        "company": "회사",
        "email": "업무 이메일",
        "type": "문의 유형",
        "message": "문의 내용"
      },
      "submit": "문의 내용 확인",
      "support": {
        "title": "지원",
        "body": "제품 사용, 기술 검토, 보안/구매 검증, 운영 이슈는 위 문의 양식에 내용을 남겨주세요. 이 배포에서는 자동 접수 backend가 연결되기 전까지 입력 형식 확인만 수행합니다."
      }
    },
    "docs": {
      "title": "문서",
      "subtitle": "Infergraph를 빠르게 시작하고, 외부 시스템과 연결하고, 직접 통합하는 데 필요한 가이드입니다."
    },
    "docsDetail": {
      "footerPrefix": "막힐 때는",
      "contactLink": "문의하기",
      "footerSuffix": "또는 콘솔 우상단 도움말 버튼을 사용하세요."
    },
    "pricing": {
      "title": "요금제",
      "subtitle": "Free 로 평가를 시작하고, 팀 규모와 운영 범위에 따라 Starter / Pro / Enterprise 로 확장합니다.",
      "recommended": "추천",
      "activeEditors": "활성 편집자",
      "allowOverage": "워크플로우 초과 사용 과금 허용",
      "checkoutLoading": "결제 세션 생성 중...",
      "compareTitle": "기능 / quota 비교",
      "itemColumn": "항목",
      "addonTitle": "애드온 (사용량 기반)",
      "addonSubtitle": "Add-on은 연결 범위와 사용량 정책에 따라 별도 산정하며, 세부 한도는 계약 또는 운영 환경 기준으로 확정됩니다.",
      "packTitle": "Ready Made Packs",
      "packSubtitle": "각 도메인의 workflow · ontology · report template 을 한 번에 설치합니다. 현재는 콘솔에서 pack을 검토하고 프로젝트에 적용할 수 있습니다.",
      "viewDetails": "자세히 보기",
      "packBillingNote": "※ Pack과 add-on 과금 정책은 배포/계약 조건에 맞춰 확정됩니다.",
      "securityChecklist": {
        "title": "보안 및 구매 검증 체크리스트",
        "subtitle": "구매자에게 보이는 각 주장은 콘솔 증명 화면에 연결되거나 현재 지원 상태를 명확히 표시합니다.",
        "item": "체크 항목",
        "state": "상태",
        "proof": "증명",
        "verify": "검증 내용"
      },
      "compareNote": "커스텀 견적이 필요하다면 영업팀에 문의주세요.",
      "contactSales": "영업 문의",
      "policySyncUnavailable": "가격 정책 API 동기화에 실패했습니다. 현재 화면에는 정적 가격 정책을 표시합니다.",
      "tiers": {
        "free": {
          "name": "무료",
          "cadence": "계속 무료",
          "tagline": "개인 / 평가용",
          "features": {
            "0": "1개 프로젝트 · 활성 편집자 1명",
            "1": "샘플 프로젝트 viewer 접근",
            "2": "워크플로우 실행 월 20회",
            "3": "온톨로지 객체 1K sample cap",
            "4": "AI 작업 월 10회",
            "5": "샘플 프로젝트 평가",
            "6": "커뮤니티 지원"
          },
          "cta": "무료로 시작"
        },
        "starter": {
          "name": "Starter",
          "cadence": "/활성 편집자/월",
          "tagline": "소규모 팀",
          "features": {
            "0": "최대 3개 프로젝트 · 활성 편집자 5명",
            "1": "Viewer와 admin은 plan 한도 적용",
            "2": "워크플로우 실행 월 2,500회",
            "3": "온톨로지 객체 25K sample policy",
            "4": "AI 작업 월 100회",
            "5": "DB + REST + 파일 커넥터",
            "6": "기본 지원 채널"
          },
          "cta": "Starter 시작"
        },
        "pro": {
          "name": "Pro",
          "cadence": "/활성 편집자/월",
          "tagline": "운영 팀",
          "features": {
            "0": "최대 10개 프로젝트 · 활성 편집자 25명",
            "1": "워크플로우 실행 월 10K회",
            "2": "온톨로지 객체 100K sample policy",
            "3": "AI 작업 월 1,000회",
            "4": "모든 connector",
            "5": "루프 증거 + 거버넌스 허브",
            "6": "감사 로그 export",
            "7": "운영 지원 옵션"
          },
          "cta": "Pro 시작"
        },
        "enterprise": {
          "name": "Enterprise",
          "price": "문의",
          "cadence": "맞춤",
          "tagline": "엔터프라이즈",
          "features": {
            "0": "전용 tenancy + on-prem 옵션",
            "1": "계약 기반 프로젝트, 사용자, 사용량 한도",
            "2": "커스텀 커넥터 통합",
            "3": "AI 프로바이더 BYO",
            "4": "SSO + SCIM + 고급 감사",
            "5": "전담 지원 / SLA 협의"
          }
        }
      },
      "quota": {
        "projectEnvironments": "프로젝트 환경",
        "contractBased": "계약 기준",
        "activeEditors": "활성 편집자",
        "viewerAccess": "Viewer 접근",
        "sampleReadOnly": "샘플 읽기 전용",
        "planLimited": "Plan 한도",
        "adminRoles": "Admin 역할",
        "ownerAdmin": "소유자/관리자",
        "workflowRuns": "워크플로우 실행 / 월",
        "proWorkflowRuns": "10,000 + 승인된 초과 사용",
        "evidencePacks": "Evidence packs / 월",
        "sampleOnly": "샘플만",
        "ontologyObjects": "온톨로지 객체",
        "contractEnvironmentBased": "계약/환경 기준",
        "aiActions": "AI 작업 / 월",
        "overageConsent": "초과 사용 동의",
        "approvalRequired": "승인 필요",
        "configurableCap": "한도 설정 가능",
        "basicConnectors": "DB / REST / 파일 커넥터",
        "mcpRpa": "MCP / RPA 연합",
        "evidenceDashboard": "증거 대시보드",
        "governanceHub": "거버넌스 허브",
        "sso": "SSO (SAML / SCIM)",
        "auditExport": "감사 로그 export",
        "onPrem": "온프레미스 / 전용 테넌시",
        "support": "지원",
        "community": "커뮤니티",
        "basicSupport": "기본 지원 채널",
        "operationalSupport": "운영 지원 옵션",
        "negotiated": "협의"
      },
      "objectQuotaNote": "Ontology object는 활성 도메인 엔티티 인스턴스 기준입니다. Raw source row, RDF triple, workflow log, evidence artifact, schema class/property는 object quota로 세지 않으며, 표시된 수치는 self-serve sample policy입니다. 대량 원천 이력과 high-fanout graph는 Enterprise 또는 federated storage 정책으로 산정합니다.",
      "addons": {
        "aiProvider": {
          "label": "AI 프로바이더 패스스루",
          "desc": "배포 환경에 설정된 AI provider 또는 사용자의 BYO key 정책에 따라 별도 과금됩니다."
        },
        "trino": {
          "label": "Trino 연합 쿼리",
          "desc": "연합 조회 용량, 연결 데이터 소스, 배포 정책에 따라 사용량 과금과 운영 한도를 별도 산정합니다."
        },
        "workflowSlot": {
          "label": "동시 워크플로우 슬롯",
          "desc": "동시 실행량은 프로젝트 실행 정책과 운영 한도에 맞춰 산정합니다."
        },
        "customConnector": {
          "label": "커스텀 커넥터 어댑터",
          "desc": "고객 시스템별 범위 산정 후 견적을 제공합니다."
        }
      },
      "packs": {
        "finance": {
          "name": "재무 팩",
          "domain": "재무",
          "desc": "월 단가 변동 분석 + 협상 자동화 시나리오 즉시 활성화.",
          "bundled": {
            "0": "재무 변동 모니터 템플릿",
            "1": "Finance workflow templates 4종",
            "2": "재무 온톨로지 계약",
            "3": "재무 리포트 템플릿"
          }
        },
        "procurement": {
          "name": "구매 팩",
          "domain": "구매",
          "desc": "공급사 견적 자동 비교 + 결재 라우팅 시나리오.",
          "bundled": {
            "0": "구매 변동 템플릿",
            "1": "Procurement workflow templates 3종",
            "2": "구매 온톨로지 계약",
            "3": "구매 리포트 템플릿"
          }
        },
        "operations": {
          "name": "생산 팩",
          "domain": "생산",
          "desc": "수율 손실 + 스크랩 비용 + 제조 검토 시나리오.",
          "bundled": {
            "0": "운영 다운타임 템플릿",
            "1": "Operations workflow templates 5종",
            "2": "운영 온톨로지 계약",
            "3": "생산 리포트 템플릿"
          }
        },
        "semiconductor": {
          "name": "스텝 원가 이상치 팩",
          "domain": "공정 원가",
          "desc": "반도체 step cost anomaly + cost impact 시나리오.",
          "bundled": {
            "0": "스텝 원가 이상치 탐지 워크플로우",
            "1": "스텝 원가 영향 요약 리포트",
            "2": "공정 원가 온톨로지 계약",
            "3": "설비/자재 영향 증거"
          }
        },
        "distribution": {
          "name": "유통 마진 팩",
          "domain": "유통 마진",
          "desc": "출하 + 반품 + allowance + 마진 누수 검토 시나리오.",
          "bundled": {
            "0": "유통 마진 누수 검토 워크플로우",
            "1": "유통 마진 누수 리포트",
            "2": "유통 마진 온톨로지 계약",
            "3": "채널/고객/사유별 누수 위젯"
          }
        }
      },
      "checkout": {
        "dryRun": "결제는 현재 dry-run 모드입니다. 운영팀에 문의해주세요 — /contact 로 이동합니다.",
        "missingUrl": "결제 URL이 응답에 포함되지 않았습니다.",
        "unavailable": "결제 연결이 현재 준비되지 않았습니다. 영업 문의 화면으로 이동합니다."
      }
    },
    "platform": {
      "title": "AI가 설계하고, 워크플로가 실행하고, 온톨로지가 기억하고, 리포트가 설명합니다.",
      "subtitle": "같은 온톨로지를 공유하는 네 모듈이 입력 → 실행 → 캡처 → 리포트 사이클을 지원하며, 결과는 다음 자동화 입력으로 자동 환류됩니다.",
      "eyebrow": "AI Operations Platform with Ontology",
      "modulesHeading": "플랫폼 모듈",
      "transverseHeading": "공통 기반",
      "architectureHeading": "플랫폼 아키텍처",
      "architectureSubtitle": "모든 모듈은 같은 온톨로지 백본을 기준으로 운영 데이터를 읽고, 작업을 실행하고, 근거를 남깁니다.",
      "backboneHeading": "백본이 정렬하는 운영 사실",
      "openModule": "모듈 상세 보기",
      "backbone": {
        "schema": "온톨로지 스키마",
        "instances": "운영 인스턴스",
        "relations": "관계와 트리플",
        "lineage": "리니지와 증거"
      },
      "contractsHeading": "모듈 책임 분리",
      "contractsSubtitle": "각 모듈은 같은 데이터를 다시 설명하지 않고, 설계·실행·정본화·통제·증거라는 분리된 역할을 맡습니다.",
      "contracts": {
        "build": {
          "title": "설계 화면은 통제된 변경을 만듭니다",
          "desc": "AI Build가 작업을 제안하고, Workflow Engine이 실행하며, Governance가 적용 가능 여부를 통제합니다."
        },
        "ground": {
          "title": "데이터는 인사이트가 되기 전에 정본화됩니다",
          "desc": "Connectors가 실제 시스템을 온톨로지 클래스와 관계에 묶어 리포트가 의미 모델을 읽게 합니다."
        },
        "prove": {
          "title": "모든 결과는 추적 가능한 근거를 남깁니다",
          "desc": "Insight Report와 Loop Evidence가 무엇이 일어났고 왜 일어났는지, 다음 운영 입력은 무엇인지 보여줍니다."
        }
      },
      "modules": {
        "aiBuild": {
          "title": "AI Build",
          "role": "작성 계층",
          "desc": "자연어 의도에서 워크플로우, 온톨로지 변경안, 리포트 초안을 제안합니다."
        },
        "workflow": {
          "title": "Workflow Engine",
          "role": "실행 런타임",
          "desc": "승인, 분기, 재시도, 외부 action을 운영 절차로 실행하고 실행 로그를 남깁니다."
        },
        "ontology": {
          "title": "Ontology Backbone",
          "role": "의미 기반 백본",
          "desc": "스키마, 인스턴스, 관계, lineage를 같은 의미 체계로 묶어 운영 지식의 기준점을 만듭니다."
        },
        "connector": {
          "title": "Data / Connectors",
          "role": "데이터 경계",
          "desc": "DB, SaaS, REST, 파일, MCP, RPA 연결을 운영 데이터 경계로 관리합니다."
        },
        "loopEvidence": {
          "title": "Loop Evidence",
          "role": "증거 계층",
          "desc": "실행 결과, 의사결정 근거, 다음 작업 입력이 어떻게 이어졌는지 추적합니다."
        },
        "insightReport": {
          "title": "인사이트 리포트",
          "role": "의사결정 계층",
          "desc": "온톨로지에 정본화된 운영 결과를 리포트, 대시보드, 분석 화면으로 설명합니다."
        },
        "governance": {
          "title": "Governance",
          "role": "통제 계층",
          "desc": "자격증명, 권한, 승인, 정책, 감사 로그를 플랫폼 공통 통제면으로 관리합니다."
        }
      },
      "moduleDetail": {
        "aiBuild": {
          "name": "AI 빌드",
          "oneLiner": "자연어로 워크플로우, 데이터 구조, 보고서를 한 번에 설계해주는 AI",
          "capabilities": {
            "selfRepair": "AI가 실수하면 스스로 고쳐가며 완성",
            "threeDrafts": "워크플로우 · 데이터 구조 · 리포트 3종을 동시 초안 생성",
            "projectContext": "내 프로젝트의 실제 데이터와 도구만 참고해 초안 작성",
            "safetyFlow": "검증 · 모의 실행 · 게시 · 적용 4단계 안전 워크플로우",
            "trace": "AI가 어떤 도구를 왜 호출했는지 한 화면에 표시"
          },
          "areas": {
            "intent": "자연어 의도 입력",
            "drafts": "워크플로우 · 온톨로지 · 리포트 초안",
            "validation": "검증 · 모의 실행 · 승인 · 게시",
            "catalog": "프로젝트 catalog 기반 제안"
          },
          "readiness": "프로젝트와 AI provider 설정이 준비된 환경에서 사용할 수 있습니다."
        },
        "workflow": {
          "name": "워크플로우 엔진",
          "oneLiner": "실행 보장, 자동 재시도, 외부 시스템 연결까지 처리하는 워크플로우 런타임",
          "capabilities": {
            "triggers": "스케줄 · 웹훅 · 자동 트리거 · 수동 실행 모두 지원",
            "steps": "읽기 · 쓰기 · 승인 · 분기 · 병합 step 지원",
            "durable": "한 번만 실행 보장, 자동 재시도, 영구 로그",
            "closedLoop": "단일 사이클 실행·캡처·리포트와 다음 워크플로우로의 자동 입력 연결까지 지원",
            "controls": "취소 · 일시 정지 · 재개와 승인 대기 상태 관리"
          },
          "areas": {
            "triggers": "스케줄 · 웹훅 · 수동 실행",
            "actions": "승인 · 분기 · 알림 · action step",
            "logs": "실행 로그와 재시도 상태",
            "loop": "다음 workflow 입력 자동 연결"
          },
          "readiness": "콘솔의 Workflow 화면과 Ready Made Pack 설치 흐름에서 사용할 수 있습니다."
        },
        "ontology": {
          "name": "온톨로지 캡처",
          "oneLiner": "워크플로우 실행 결과를 자동으로 운영 지식으로 축적",
          "capabilities": {
            "separation": "예시 데이터와 실제 운영 데이터를 자동으로 분리 저장",
            "validation": "저장 규칙 자동 검증",
            "lineage": "워크플로우 → 데이터 → 리포트의 데이터 출처 추적",
            "sparql": "Object Explorer와 리포트 위젯에서 SPARQL 조회",
            "storage": "Fuseki + PostgreSQL 이중 저장으로 빠른 조회"
          },
          "areas": {
            "objects": "워크플로우 결과의 객체/관계 저장",
            "explorer": "Object Explorer 조회",
            "sparql": "SPARQL 기반 탐색",
            "refs": "source reference와 변경 이력"
          },
          "readiness": "프로젝트 ontology와 graph storage가 구성된 환경에서 사용할 수 있습니다."
        },
        "connector": {
          "name": "커넥터",
          "oneLiner": "기존 DB · SaaS · API · 파일 · 자동화 봇을 옮기지 않고 그대로 연결",
          "capabilities": {
            "databases": "주요 warehouse, DB, SaaS 저장소 연결",
            "federation": "운영 데이터를 옮기지 않고 그 자리에서 조회",
            "api": "REST API · 파일 · MCP 서버 · RPA 봇 연결",
            "credentials": "자격 증명을 안전하게 보관, 회전, 권한 관리",
            "wizard": "마법사로 스키마 자동 발견, 클래스 매핑, 동기화"
          },
          "areas": {
            "setup": "DB · REST · File connector 설정",
            "vault": "자격 증명 보관소",
            "mapping": "스키마 탐색과 매핑",
            "health": "동기화와 connector health 상태"
          },
          "readiness": "Federated 조회는 배포 환경의 네트워크와 권한 설정에 맞춰 활성화됩니다."
        },
        "loopEvidence": {
          "name": "루프 근거",
          "oneLiner": "사용 사례 → 워크플로우 → 데이터 → 리포트의 cycle을 한 화면에서 추적",
          "capabilities": {
            "timeline": "한 시나리오의 워크플로우, 데이터, 리포트가 한 줄에 연결",
            "freshness": "데이터가 기준 시간 이상 갱신되지 않으면 경고",
            "staleness": "데이터 소스 지연 자동 감지",
            "crossRef": "여러 시스템을 가로질러 자동 cross-reference"
          },
          "areas": {
            "workflowRuns": "workflow 실행 이력",
            "capture": "ontology capture 결과",
            "freshness": "연결된 report freshness",
            "nextCycle": "staleness와 다음 사이클 상태"
          },
          "readiness": "Ready Made Pack 또는 workflow 실행 데이터가 있는 프로젝트에서 의미 있는 값을 보여줍니다."
        },
        "governance": {
          "name": "거버넌스",
          "oneLiner": "자격 증명 · 승인 · 정책 · 모니터링을 한 곳에서",
          "capabilities": {
            "hub": "거버넌스 허브에서 자격 증명, 승인함, cycle 추적",
            "rbac": "역할 기반 권한, 도구 사용 허용 목록, 승인 게이트",
            "observability": "응답 시간, 성공률, 오류 예산 모니터링",
            "journey": "사용자 여정 회귀 추적",
            "audit": "감사 로그 export"
          },
          "areas": {
            "vault": "자격 증명 보관소",
            "approval": "승인 정책과 승인함",
            "observability": "런타임 관찰성",
            "audit": "감사와 compliance export"
          },
          "readiness": "관찰성과 감사 export는 배포 환경의 로깅, 보관, 권한 정책에 맞춰 구성됩니다."
        },
        "insightReport": {
          "name": "인사이트 리포트",
          "oneLiner": "워크플로우 실행 결과를 자동 리포트와 대시보드로 설명하고, 다음 사이클 입력 연결까지 준비하는 ontology-grounded 리포트 엔진",
          "capabilities": {
            "instantReport": "워크플로우 실행 결과를 ontology에 정본화된 데이터로 즉시 리포트화",
            "naturalLanguageWidget": "자연어로 차트·표·KPI 요청 → AI가 BI 위젯 초안 생성",
            "loopFeedback": "리포트 기반 next-workflow trigger / parameter / threshold 자동 연결",
            "simulationAnomaly": "What-if 시뮬레이션·이상 탐지가 같은 ontology 위에서 동작",
            "evidenceTrace": "모든 리포트는 source ref · evidence · manifest hash로 출처 추적"
          },
          "areas": {
            "autoReport": "자동 리포트 생성",
            "biBuilder": "BI 대시보드 빌더 (자연어 + 드래그)",
            "aiChat": "AI 분석 채팅 (ontology grounding)",
            "simulationAnomaly": "What-if 시뮬레이션 · 이상 탐지"
          },
          "consoleAreas": {
            "reportLibrary": "Auto Insight > Report Library",
            "biBuilder": "Auto Insight > BI Report Builder",
            "aiChat": "Auto Insight > AI Chat",
            "simulationAnomaly": "Auto Insight > Simulation / Anomaly Detection"
          },
          "readiness": "Report Library, BI Report Builder, AI Chat, Simulation / Anomaly Detection과 함께 플랫폼 분석 계층으로 제공됩니다.",
          "applyCta": "리포트 라이브러리 열기"
        },
        "productOverline": "플랫폼 구성 요소",
        "tryInConsole": "콘솔에서 확인",
        "viewDemo": "데모 보기",
        "contactSales": "문의하기",
        "sections": {
          "capabilities": "핵심 기능",
          "consoleAreas": "콘솔에서 연결되는 영역",
          "readiness": "서비스 내 위치"
        },
        "breadcrumbRoot": "플랫폼"
      },
      "demo": {
        "breadcrumb": "데모",
        "readOnly": "읽기 전용 데모",
        "title": "{{name}} 데모",
        "intro": "로그인 전에 이 모듈이 콘솔에서 어떤 작업 단위로 구성되는지 확인할 수 있습니다. 실제 실행과 데이터 변경은 승인된 콘솔에서만 수행됩니다.",
        "openConsole": "실제 콘솔 열기",
        "checkApproval": "승인 상태 확인",
        "loginForConsole": "로그인 후 실제 콘솔 열기",
        "backToModule": "모듈 설명으로 돌아가기",
        "noWrite": "저장/실행 없음",
        "capabilityLabel": "기능 {{number}}",
        "sections": {
          "flow": "콘솔 작업 흐름",
          "preview": "읽기 전용 시연 화면",
          "connected": "서비스 내 연결 위치"
        }
      }
    },
    "solutions": {
      "title": "Ready Made Packs",
      "subtitle": "현재 콘솔에서 설치해 검증할 수 있는 운영 pack입니다. 각 pack은 ontology, workflow, report 템플릿을 함께 제공합니다."
    },
    "readyMadePacks": {
      "title": "레디메이드 팩",
      "subtitle": "콘솔에 설치하면 데이터·워크플로우·온톨로지·리포트가 한 벌로 들어와 바로 가동되는 시나리오 묶음. 사이클 결과는 다음 자동화의 입력으로 자동 연결됩니다.",
      "breadcrumbRoot": "레디메이드 팩",
      "cardCta": "자세히 보기",
      "packTag": "Ready Made Pack",
      "fallbackNotice": "실시간 catalog를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
      "filters": {
        "industry": "산업",
        "function": "기능",
        "scenario": "시나리오",
        "all": "전체"
      },
      "empty": {
        "search": "검색 결과가 없습니다.",
        "default": "등록된 레디메이드 팩이 없습니다."
      },
      "detail": {
        "applyCta": "내 프로젝트에 설치",
        "lifecycle": {
          "title": "사이클 4단계와 다음 루프 연결",
          "subtitle": "입력부터 리포트까지 실행되고, 리포트는 다음 workflow의 trigger/input으로 자동 연결됩니다.",
          "stages": {
            "design": {
              "title": "설계",
              "desc": "데이터·워크플로우·온톨로지·정책을 한 화면에서 설계합니다."
            },
            "execute": {
              "title": "실행",
              "desc": "에이전트와 승인 흐름이 정해진 시점에 자동으로 실행됩니다."
            },
            "capture": {
              "title": "기억",
              "desc": "실행 결과가 운영 그래프에 객체와 관계로 저장됩니다."
            },
            "explain": {
              "title": "설명",
              "desc": "리포트와 lineage가 의사결정 근거를 설명합니다."
            },
            "continue": {
              "title": "재순환",
              "desc": "결과를 다음 자동화로 자동 연결하는 loop 정책."
            }
          }
        }
      }
    },
    "solutionDetail": {
      "contactSales": "문의하기",
      "startTrial": "무료로 시작하기",
      "sections": {
        "problems": "왜 자동화가 필요한가",
        "flow": "Infergraph 적용 흐름",
        "savedItems": "운영 지식으로 자동 저장되는 항목"
      },
      "table": {
        "class": "클래스",
        "sample": "샘플 인스턴스 / triple"
      },
      "reportExampleLabel": "리포트 예시",
      "operationalKpi": "운영 KPI",
      "viewPack": "콘솔에서 Pack 보기",
      "finance": {
        "industry": "재무",
        "title": "월별 비용 변동을 감지하고 승인 리포트로 닫습니다",
        "subtitle": "Finance Cost Variance pack은 비용 계산 객체를 기준으로 월별 변동을 찾고, 승인 흐름과 요약 리포트까지 함께 설치합니다.",
        "problems": {
          "1": "비용 변동 감지, 승인 요청, 보고서 작성이 분리되어 있음",
          "2": "월 마감 시 기준 초과 건을 일관된 방식으로 추적하기 어려움",
          "3": "승인 이력과 리포트 근거를 같은 운영 데이터로 남기기 어려움"
        },
        "steps": {
          "1": "월별 비용 변동 스캔을 스케줄로 실행",
          "2": "임계값을 넘는 cost_calculation 항목 조회",
          "3": "검토 대상 건을 승인 흐름으로 라우팅",
          "4": "승인 결과와 변동 정보를 운영 그래프에 기록",
          "5": "Monthly Cost Variance Summary 리포트 생성"
        },
        "classes": {
          "costCalculation": "비용 계산",
          "approvalRequest": "승인 요청"
        },
        "reportExample": "월별 비용 변동 요약 리포트"
      },
      "kpi": {
        "installTime": "설치 예상 시간",
        "mainObjects": "주요 객체",
        "defaultCadence": "기본 실행 주기"
      },
      "procurement": {
        "industry": "구매",
        "title": "공급사 견적 변동을 감지하고 구매 검토로 연결합니다",
        "subtitle": "Procurement Price Variance pack은 공급사 견적, 품목 기준가, 구매 요청/주문을 연결해 기준 초과 견적을 검토 대상으로 만듭니다.",
        "problems": {
          "1": "공급사 견적 차이를 사람이 일일이 검토해야 함",
          "2": "승인 기준이 분산되어 일관성 있게 적용되지 못함",
          "3": "협상 결과가 운영 데이터로 정리되지 않아 다음 협상에 활용 불가"
        },
        "steps": {
          "1": "ERP 구매 데이터와 공급사 견적 소스를 connector 또는 sample mode로 바인딩",
          "2": "품목별 기준가 대비 공급사 견적 변동률 조회",
          "3": "기준 초과 견적을 구매 검토 승인 흐름으로 라우팅",
          "4": "견적, 변동률, 승인 상태를 운영 그래프에 기록",
          "5": "Procurement Supplier Quote Variance Report 생성"
        },
        "classes": {
          "supplierQuote": "공급사 견적",
          "purchaseRequest": "구매 요청 / 주문",
          "varianceReview": "가격 변동 검토"
        },
        "reportExample": "공급사 견적 변동 리포트"
      },
      "operations": {
        "industry": "생산",
        "title": "생산 수율 손실과 스크랩 비용을 한 흐름에서 추적합니다",
        "subtitle": "Production Yield/Loss Cost pack은 생산 오더, 라인, 배치, 수율 손실, 스크랩 비용을 연결해 고손실 이벤트를 제조 검토로 보냅니다.",
        "problems": {
          "1": "생산량, 손실량, 스크랩 비용이 서로 다른 표와 리포트에 흩어져 있음",
          "2": "고손실 이벤트가 검토와 후속 조치로 이어지는 기준이 불명확함",
          "3": "라인/배치별 손실 근거를 운영 그래프로 추적하기 어려움"
        },
        "steps": {
          "1": "생산 오더, 라인, 배치, 자재 사용 데이터를 sample 또는 connector mode로 준비",
          "2": "고손실 이벤트와 스크랩 비용을 조회",
          "3": "기준 초과 손실을 제조 검토 승인 흐름으로 라우팅",
          "4": "수율 손실 이벤트와 비용 영향을 운영 그래프에 기록",
          "5": "Production Yield/Loss Cost Report 생성"
        },
        "classes": {
          "lineBatch": "생산 라인 / 배치",
          "yieldLoss": "수율 손실 이벤트",
          "scrapReview": "스크랩 비용 / 검토"
        },
        "reportExample": "생산 수율 / 손실 원가 리포트"
      },
      "semiconductor": {
        "industry": "공정 원가",
        "title": "공정 step 원가 이상을 장비와 자재 영향까지 연결합니다",
        "subtitle": "Semiconductor Cost Analysis pack은 공정 step, 장비, 자재, 수율, 스크랩, 원가 배부를 연결해 Step Cost Anomaly Detection workflow와 Step Cost Impact Summary report를 제공합니다.",
        "problems": {
          "1": "공정 step 원가 초과의 원인이 장비, 자재, 수율 데이터에 흩어져 있음",
          "2": "비정상 cost allocation이 승인 검토와 리포트 근거로 바로 연결되지 않음",
          "3": "Fab 운영팀과 원가팀이 같은 evidence trail을 보며 판단하기 어려움"
        },
        "steps": {
          "1": "MES step cost와 yield/scrap warehouse 데이터를 sample 또는 connector mode로 준비",
          "2": "계획 대비 step cost가 임계값을 넘는 공정 step을 조회",
          "3": "비정상 원가 배부를 process cost approval 흐름으로 라우팅",
          "4": "장비, 자재, 수율, 스크랩 영향과 승인 결과를 운영 그래프에 기록",
          "5": "Step Cost Impact Summary 생성"
        },
        "classes": {
          "processStep": "공정 / Step",
          "equipmentMaterial": "장비 / 자재",
          "costSignal": "원가 배부 / 원가 신호"
        },
        "reportExample": "스텝 원가 영향 요약"
      },
      "distribution": {
        "industry": "유통 마진",
        "title": "출하와 반품 이후의 마진 누수를 추적합니다",
        "subtitle": "Distribution Margin Leakage pack은 고객, 채널, 주문, 출하, 운임, 반품, allowance, 매출/원가를 연결해 Distribution Margin Leakage Review workflow와 Distribution Margin Leakage Report를 제공합니다.",
        "problems": {
          "1": "운임, 반품, allowance가 매출/원가와 분리되어 마진 누수를 늦게 발견함",
          "2": "고객, 채널, 누수 사유별 손실 규모를 같은 리포트에서 비교하기 어려움",
          "3": "마진 누수 승인 검토와 후속 조치 근거가 운영 데이터로 남지 않음"
        },
        "steps": {
          "1": "OMS, TMS, returns/allowance 데이터를 sample 또는 connector mode로 준비",
          "2": "출하, 운임, 반품, allowance, 매출/원가를 대조해 마진 누수 이벤트를 조회",
          "3": "중요 누수 건을 distribution margin approval 흐름으로 라우팅",
          "4": "누수 이벤트와 고객, 채널, 주문, 출하, 사유 관계를 운영 그래프에 기록",
          "5": "Distribution Margin Leakage Report 생성"
        },
        "classes": {
          "orderShipment": "유통 주문 / 출하",
          "freightReturn": "운임 / 반품 / Allowance",
          "leakageEvent": "마진 누수 이벤트"
        },
        "reportExample": "유통 마진 누수 리포트"
      }
    }
  },
  "agentMarketplace": {
    "templates": {
      "finance": {
        "name": "재무 변동 모니터",
        "shortDescription": "월 단가 변동을 지속 모니터링하고 기준 초과 시 워크플로우를 자동 트리거합니다.",
        "outputs": {
          "0": "월별 variance trend report",
          "1": "상위 5개 공급사 변동 분석",
          "2": "다음 cycle 협상 input ontology triple"
        }
      },
      "procurement": {
        "name": "구매 가격 추적기",
        "shortDescription": "공급사 quote 변동을 감지하고 기준 초과 시 승인 라우팅과 ontology 정본화를 수행합니다.",
        "outputs": {
          "0": "공급사별 quote variance 주별 report",
          "1": "승인 주기 KPI",
          "2": "next-cycle 협상 trigger"
        }
      },
      "operations": {
        "name": "운영 원인 분석기",
        "shortDescription": "공정 downtime 이벤트를 자동 분류하고 root cause와 다음 cycle maintenance policy를 갱신합니다.",
        "outputs": {
          "0": "공정별 가동률 trend",
          "1": "근본 원인 분류",
          "2": "preventive maintenance policy 자동 갱신"
        }
      }
    },
    "title": "에이전트 템플릿 마켓플레이스",
    "subtitle": "외부 범용 agent와 결합되는 도메인 agent template을 설치하고 프로젝트에 적용, 변형, 공유합니다.",
    "catalogLabel": "읽기 전용 카탈로그",
    "catalogBody": "공식 에이전트 템플릿을 검토할 수 있으며 프로젝트 설치는 워크스페이스 관리자 승인 후 진행됩니다.",
    "tabs": {
      "community": "커뮤니티 (0)",
      "mine": "내 templates (0)"
    },
    "empty": {
      "community": "공개 커뮤니티 템플릿은 관리자 검증 후 카탈로그에 표시됩니다.",
      "mine": "승인된 설치 요청과 조직 템플릿이 여기에 표시됩니다."
    },
    "sections": {
      "tools": "도구",
      "outputs": "산출물",
      "compatibleClients": "호환 클라이언트"
    },
    "status": {
      "official": "공식 템플릿",
      "community": "커뮤니티"
    },
    "requestInstallApproval": "관리자 승인 후 설치",
    "requestInstallApprovalTooltip": "워크스페이스 관리자가 승인하면 설치할 수 있습니다.",
    "connectTitle": "외부 agent와 연결하기",
    "connectBody": "템플릿을 설치하지 않아도 Infergraph MCP 서버에 외부 에이전트를 연결해 도구를 직접 호출할 수 있습니다.",
    "customTemplate": "커스텀 템플릿 문의"
  },
  "useCase": {
    "project": {
      "chips": {
        "useCase": "상용 데모",
        "sharedDemoReadOnly": "공유 데모 (읽기 전용)",
        "copiedEditable": "복사됨 · 편집 가능",
        "recommendedScenarioSet": "추천 시나리오",
        "approvalEvidenceTracks": "승인 및 증거 트랙",
        "readOnlyDemoTemplate": "읽기 전용 데모 템플릿",
        "scenarioCount": "{{count}}개 비즈니스 시나리오",
        "readOnlyTemplate": "읽기 전용 템플릿",
        "lastSampleRun": "마지막 샘플 실행: 2026-Q1 결산",
        "nextScenario": "다음: {{name}}",
        "sampleDemoState": "샘플 데모 상태",
        "readOnlySharedProject": "읽기 전용 공유 프로젝트",
        "readOnlySynthetic": "읽기 전용 합성 샘플"
      },
      "actions": {
        "copyDisabled": "읽기 전용 공유 프로젝트는 복사할 수 없습니다",
        "inspectReadOnlyWorkflow": "읽기 전용 워크플로우 확인",
        "openReport": "리포트 열기",
        "openEvidenceTrail": "증거 트레일 열기",
        "openGovernanceDecision": "거버넌스 결정 열기",
        "openAgentTrace": "에이전트 트레이스 열기",
        "browseReadyMadePacks": "Ready Made Pack 둘러보기",
        "selectPrimaryPack": "주 팩 선택",
        "openTutorialRunner": "튜토리얼 러너 열기",
        "openScenario": "시나리오 열기",
        "openGovernanceTrail": "거버넌스 트레일 열기",
        "copyScenario": "내 프로젝트로 시나리오 복사",
        "selectedDemoProject": "선택된 데모 프로젝트",
        "openDemoProject": "데모 프로젝트 열기",
        "openCaseFile": "케이스/워크스트림 열기"
      },
      "firstRun": {
        "title": "추천 Ready Made Pack으로 시작",
        "description": "{{projectName}}이(가) 팩 선택 준비가 되었습니다. 추천 팩을 선택한 뒤 설치 마법사에서 데이터, 워크플로우, 온톨로지, 리포트 설정을 검토하세요."
      },
      "overview": "공유 워크플로우 템플릿, 시나리오 리포트, 거버넌스 증거를 확인하세요. 변경 사항을 저장하거나 변경 가능한 실행을 시작하기 전에 워크플로우를 편집 가능한 프로젝트로 복사하세요.",
      "description": "재무, 구매, 생산, 반도체, 마진 누수 워크플로우와 샘플 증거 및 리포트.",
      "name": "제조 원가 관리 & 마진 누수 데모"
    },
    "case": {
      "flagshipTitle": "3월 마감 매출총이익 사례",
      "hubSummary": "{{period}} 마감: 계획 GM {{plannedGm}} vs 실제 GM {{actualGm}}, 총 영향 {{impact}}.",
      "sales": "매출",
      "plannedGm": "계획 GM",
      "actualGm": "실제 GM",
      "totalImpact": "총 영향",
      "recoverableNow": "즉시 회수 가능",
      "avoidableNextMonth": "다음 달 회피 가능",
      "accountingCloseAdjustment": "회계 마감 조정",
      "residualMonitored": "잔여 모니터링",
      "evidenceRowSummary": "소스 {{sourceRows}} / 예외 {{exceptionRows}} / 연결 {{linkedObjectRows}}",
      "status": "상태",
      "impact": "영향",
      "objectChain": "객체 체인",
      "accountingTreatment": "회계 처리",
      "evidenceRows": "증거 행",
      "sourceRowsCount": "소스 행 {{count}}개",
      "exceptionRowsCount": "예외 행 {{count}}개",
      "linkedObjectRowsCount": "연결 객체 행 {{count}}개",
      "selectedWorkstream": "선택된 워크스트림",
      "workstream": "워크스트림",
      "due": "마감일",
      "nextReviewState": "다음 검토: 컨트롤러 사인오프 마감 {{dueDate}}",
      "periodChip": "기간 {{period}}",
      "impactChip": "영향 {{impact}}",
      "plan": "계획",
      "actual": "실제",
      "needsDecision": "결정 필요",
      "creditActions": "크레딧 액션",
      "openSynthetic": "읽기 전용 합성",
      "caseFile": "3월 마감 케이스 파일",
      "periodAndDueDate": "기간 {{period}} · 컨트롤러 사인오프 마감 {{dueDate}}"
    },
    "library": {
      "catalogTitle": "업무 사례 둘러보기",
      "problemOrigin": "문제 원인",
      "enterpriseDilemma": "엔터프라이즈 딜레마",
      "currentWorkaround": "현재 우회 방법",
      "whyExistingToolsFail": "단절된 도구가 실패하는 이유",
      "infergraphResolution": "Infergraph 해결책",
      "implementedDemoResult": "구현된 데모 결과",
      "limitations": "제약 사항",
      "copyBridge": "프로젝트 복사 상태",
      "installPackBridge": "소스 작성 팩",
      "productizationStatus": "팩 제품화 상태",
      "backgroundDoc": "배경 문서",
      "title": "데모 라이브러리",
      "showCaseDetail": "사례 배경 자세히 보기",
      "hideCaseDetail": "사례 배경 접기",
      "backToList": "사례 목록으로",
      "cardAudience": "대상: {{buyers}}",
      "copyCta": "사례를 내 프로젝트로 복사",
      "copyCtaDisabled": "읽기 전용 사례",
      "showOperational": "설치되는 구성 자세히 보기",
      "hideOperational": "설치되는 구성 접기"
    },
    "fallback": {
      "unknownScenario": "알 수 없는 시나리오 링크. 기본 추천 상용 데모 시나리오를 표시합니다."
    },
    "technical": {
      "none": "없음",
      "hide": "기술 상세 숨기기",
      "show": "기술 상세 보기",
      "scenarioId": "시나리오 ID",
      "packId": "팩 ID",
      "nativePackStatus": "네이티브 팩 상태",
      "installPackId": "설치 팩 ID",
      "nativePackId": "네이티브 팩 ID",
      "proxyPackId": "프록시 팩 ID",
      "assetBundleId": "자산 번들 ID",
      "sourcePackId": "소스 작성 팩",
      "sourcePackRationale": "소스 팩 근거",
      "workflowKey": "워크플로우 키",
      "ontologyRefs": "온톨로지 참조",
      "widgetIds": "위젯 ID",
      "evidenceRefs": "증거 참조",
      "approvalId": "승인 ID",
      "agentRunId": "에이전트 실행 ID"
    },
    "sections": {
      "copyPreview": "미리보기 복사",
      "ownerOutcome": "소유자 및 결과",
      "workflow": "워크플로우",
      "reportPreview": "리포트 미리보기",
      "report": "리포트",
      "evidenceGovernance": "증거 및 거버넌스",
      "credentialRequirements": "자격 증명 요구사항"
    },
    "labels": {
      "packStatus": "팩 상태",
      "installPackId": "설치 팩 ID",
      "packRoleId": "팩 역할 ID",
      "sourceScenarioId": "소스 시나리오 ID",
      "sourceDemoProjectId": "소스 데모 프로젝트 ID",
      "assetBundleId": "자산 번들 ID",
      "installTimestamp": "설치 타임스탬프",
      "sampleDataMaturity": "샘플 데이터 성숙도",
      "ontologyObjects": "온톨로지 객체",
      "workflows": "워크플로우",
      "reports": "리포트",
      "credentialSlots": "자격 증명 슬롯",
      "connectorSlots": "커넥터 슬롯",
      "governancePolicyPresets": "거버넌스 정책 프리셋",
      "excludedArtifacts": "제외된 공유 데모 산출물",
      "businessOwner": "비즈니스 소유자",
      "nextAction": "다음 작업",
      "sourceData": "소스 데이터",
      "systems": "시스템",
      "businessTables": "비즈니스 테이블",
      "ontologyModel": "온톨로지 모델",
      "widgets": "위젯",
      "approvalPolicy": "승인 정책",
      "thresholds": "임계값"
    },
    "decision": {
      "recommendedCase": "추천 사례",
      "preview": "미리보기",
      "experienceSample": "샘플 결과까지 바로 확인",
      "experienceLight": "간단 샘플 확인",
      "experienceBackground": "사례 설명 중심",
      "installable": "내 프로젝트로 설치 가능",
      "readOnly": "읽기 전용"
    }
  },
  "projectManagement": {
    "currentProject": "현재 프로젝트:",
    "empty": {
      "title": "접근 가능한 프로젝트가 없습니다",
      "description": "프로젝트를 먼저 만들거나 기존 프로젝트에 초대받으세요."
    },
    "actions": {
      "createProject": "프로젝트 생성"
    },
    "journey": {
      "projectRequired": "Ready Made Packs 또는 Onboarding을 열기 전에 프로젝트를 선택하거나 생성하세요.",
      "readyMadePacksLoading": "Ready Made Packs 로드 중...",
      "onboardingLoading": "Onboarding 로드 중..."
    },
    "messages": {
      "loginRequired": "로그인이 필요합니다.",
      "projectCreateFailedShort": "프로젝트 생성에 실패했습니다.",
      "projectCreatedNamed": "프로젝트 '{{projectName}}'를 만들었습니다.",
      "projectDeleted": "프로젝트를 삭제했습니다.",
      "confirmDelete": "이 프로젝트를 삭제할까요? 되돌릴 수 없습니다.",
      "projectDeleteFailed": "프로젝트를 삭제하지 못했습니다. 다시 시도하세요."
    }
  },
  "console": {
    "greeting": {
      "context": "현재 프로젝트:",
      "openProjects": "프로젝트 열기",
      "switchProject": "프로젝트 전환",
      "lateNight": "늦은 밤이네요",
      "morning": "좋은 아침입니다",
      "afternoon": "좋은 오후입니다",
      "evening": "좋은 저녁입니다",
      "fallbackName": "운영자",
      "demoFallbackProject": "워크스페이스 설정"
    },
    "recent": {
      "title": "최근 활동",
      "viewAll": "전체 보기",
      "empty": "아직 활동이 없습니다. 워크플로우 실행 / 승인 / 캡처 이벤트가 여기 표시됩니다."
    },
    "onboarding": {
      "title": "5단계로 첫 단일 사이클 완성",
      "dismiss": "온보딩 닫기",
      "cta": "시작 가이드 열기",
      "steps": {
        "installPack": "Ready Made Pack 설치",
        "validateDraft": "워크플로우 초안 검증",
        "dryRun": "초안 dry-run 실행",
        "publishDraft": "초안 게시",
        "reviewReport": "리포트 출력 검토"
      }
    },
    "activity": {
      "demoWorkflow": {
        "caseTitle": "{{caseTitle}}이(가) 5억 9,520만원 GM 영향으로 세 개의 워크스트림을 열었습니다.",
        "caseTimestamp": "{{period}} 마감 · 컨트롤러 마감 {{dueDate}}",
        "caseStatus": "케이스 결정 대기"
      },
      "demoEvidence": {
        "caseTitle": "합성 증거 행은 소스, 예외, 연결 객체 수에 고정되어 있습니다.",
        "caseTimestamp": "증거 잠금 {{date}} · 읽기 전용 샘플 데이터",
        "status": "증거 준비됨"
      },
      "demoReport": {
        "caseTitle": "다음 검토: 회계 조정, 회수 액션, 4월 통제를 승인하세요.",
        "caseTimestamp": "워크스트림 {{count}}개 · {{impact}}",
        "status": "리포트 준비됨"
      }
    }
  },
  "agentConsole": {
    "_reserved": "(예약됨)"
  },
  "workflowShell": {
    "_reserved": "(예약됨)"
  },
  "dataHubWizard": {
    "steps": {
      "_reserved": "(예약됨)",
      "explore": {
        "description": "수집된 데이터를 미리보고 스키마를 확인합니다.",
        "label": "데이터 탐색"
      },
      "mapping": {
        "description": "새 클래스를 생성하거나 기존 클래스에 데이터를 매핑합니다.",
        "label": "매핑 설정"
      },
      "source": {
        "description": "CSV 파일을 업로드하거나 외부 데이터 연결을 선택합니다.",
        "label": "데이터 소스 선택"
      },
      "sync": {
        "description": "변환된 데이터를 Fuseki Named Graph에 저장합니다.",
        "label": "동기화 실행"
      }
    },
    "source": {
      "_reserved": "(예약됨)",
      "addConnection": "새 연결 추가",
      "connectionDescription": "PostgreSQL, Supabase, BigQuery, MongoDB 등 외부 데이터베이스",
      "connectionTitle": "외부 데이터 연결",
      "csvDescription": "로컬 CSV 파일을 직접 업로드합니다",
      "csvTitle": "CSV 파일 업로드",
      "errors": {
        "connectionRequired": "연결이 선택되지 않았습니다.",
        "connectionTestError": "연결 테스트 중 오류가 발생했습니다.",
        "connectionTestFailed": "연결 테스트 실패",
        "connectionsLoadFailed": "연결 목록을 불러오는데 실패했습니다.",
        "csvOnly": "CSV 파일만 업로드할 수 있습니다.",
        "csvProcessFailed": "CSV 처리 중 오류가 발생했습니다.",
        "csvUploadFailed": "CSV 업로드에 실패했습니다.",
        "fileTooLarge": "파일 크기가 너무 큽니다. 최대 50MB까지 업로드할 수 있습니다. (현재: {{size}}MB)",
        "ingestFailed": "데이터 수집에 실패했습니다.",
        "ingestProcessFailed": "데이터 수집 중 오류가 발생했습니다.",
        "tablesLoadFailed": "테이블 목록을 불러오는데 실패했습니다."
      },
      "noConnections": "\"새 연결 추가\"를 클릭하여 외부 데이터 소스를 연결하세요.",
      "noTables": "사용 가능한 테이블이 없습니다. 연결 상태를 확인해주세요.",
      "savedConnections": "저장된 연결",
      "selectFile": "파일 선택",
      "selectTableFor": "테이블 선택: {{name}}",
      "tableRows": "행: {{count}}",
      "tableType": "타입: {{type}}",
      "testConnection": "연결 테스트",
      "title": "데이터 소스 유형을 선택하세요"
    },
    "explore": {
      "_reserved": "(예약됨)",
      "avgLength": "평균 길이: {{value}}",
      "columnCount": "컬럼 수",
      "columnsChip": "{{count}}개 컬럼",
      "confidence": {
        "high": "높음",
        "low": "낮음",
        "medium": "보통"
      },
      "confidenceLabel": "신뢰도:",
      "confirmBeforeMapping": " — 매핑 전 타입을 확인해주세요.",
      "confirmTypeSuffix": " — 타입을 확인해주세요",
      "dateColumns": "날짜: {{count}}",
      "errors": {
        "previewLoadFailed": "데이터 미리보기를 불러오는데 실패했습니다."
      },
      "highNullColumns": "NULL 비율 높은 컬럼:",
      "highNullRate": "NULL 비율 높음",
      "keyCandidate": "키 컬럼 후보",
      "lowConfidenceColumns": "타입 추론 신뢰도 낮은 컬럼:",
      "maxValue": "최대값: {{value}}",
      "minValue": "최소값: {{value}}",
      "noData": "데이터가 없습니다.",
      "noSearchResults": "검색 결과가 없습니다.",
      "nullCount": "NULL 개수: {{count}}",
      "nullRate": "NULL 비율",
      "numericColumns": "숫자: {{count}}",
      "previewTitle": "데이터 미리보기",
      "recommendedPrimaryKey": "추천 기본 키:",
      "rowsPerPage": "페이지당 행:",
      "sampleValues": "샘플 값:",
      "schemaProfile": "스키마 프로파일",
      "searchPlaceholder": "검색...",
      "selectDataFirst": "데이터를 먼저 선택해주세요.",
      "session": "세션",
      "status": "상태",
      "stringColumns": "문자열: {{count}}",
      "totalRecords": "총 레코드: {{count}}",
      "totalRows": "총 행 수",
      "typeConfidenceLabel": "타입 추론 신뢰도 ({{label}})",
      "typeConfidenceSummary": "타입 신뢰도: {{percentage}} ({{label}})",
      "typeConfidenceTooltip": "타입 추론 신뢰도: {{percentage}} ({{label}})",
      "typeConfidenceValue": "타입 추론 신뢰도: {{percentage}}",
      "unique": "고유값:",
      "uniqueCount": "고유값 개수: {{count}}",
      "uniqueRate": "고유값 비율"
    },
    "sync": {
      "_reserved": "(예약됨)",
      "dataSource": "데이터 소스",
      "errorColumn": "컬럼: {{column}}",
      "errorDetails": "오류 상세 ({{count}}건)",
      "errorRow": "행 {{row}}: {{message}}",
      "errors": {
        "layersLoadFailed": "레이어 목록을 불러오는데 실패했습니다. 네트워크 연결을 확인해주세요.",
        "mappingConfigFailed": "매핑 설정 생성에 실패했습니다.",
        "missingSession": "세션 정보가 없습니다.",
        "syncFailed": "동기화에 실패했습니다.",
        "syncProcessFailed": "동기화 중 오류가 발생했습니다."
      },
      "execute": "동기화 실행",
      "existingClassMapping": "기존 클래스 매핑",
      "failure": "실패",
      "instructionsCanvas": "동기화 완료 후 데이터 캔버스에서 결과를 확인할 수 있습니다.",
      "instructionsLayer": "선택한 그래프 레이어에 새로운 인스턴스가 추가됩니다.",
      "instructionsTitle": "동기화 안내",
      "instructionsTransform": "동기화는 매핑 규칙에 따라 스테이징 데이터를 변환하여 Fuseki Named Graph에 저장합니다.",
      "key": "키",
      "mappingRulesTitle": "매핑 규칙 ({{count}}개)",
      "mappingSettings": "매핑 설정",
      "newClass": "새 클래스: {{name}}",
      "progress": {
        "completed": "동기화 완료! ({{seconds}}초)",
        "mappingConfig": "매핑 설정 생성 중...",
        "preparing": "동기화 준비 중...",
        "syncing": "Fuseki에 동기화 중..."
      },
      "progressRows": "{{current}} / {{total}} 행",
      "resultFailure": "동기화 실패",
      "resultSuccess": "동기화 완료",
      "retry": "다시 시도",
      "rowsChip": "{{count}}행",
      "ruleCount": "{{count}}개 규칙",
      "sourceColumn": "소스 컬럼",
      "status": {
        "completed": "완료",
        "failed": "실패",
        "inProgress": "진행 중... ({{progress}}%)"
      },
      "success": "성공",
      "summaryTitle": "동기화 요약",
      "syncing": "동기화 중...",
      "targetGraph": "대상 그래프",
      "targetProperty": "타겟 속성",
      "transform": "변환"
    },
    "mappingConfig": {
      "_reserved": "(예약됨)",
      "buttons": {
        "add": "추가",
        "addRule": "규칙 추가",
        "autoMapping": "자동 매핑",
        "createClass": "클래스 + 속성 생성",
        "creating": "생성 중...",
        "edit": "수정",
        "inferSchema": "AI 스키마 추론",
        "inferring": "추론 중...",
        "preview": "변환 미리보기"
      },
      "chips": {
        "key": "키",
        "newProperty": "새 속성",
        "prop": "속성",
        "reuse": "재사용 ({{confidence}}%)"
      },
      "dialog": {
        "addTitle": "매핑 규칙 추가",
        "editTitle": "매핑 규칙 수정"
      },
      "errors": {
        "autoMappingNotFound": "자동 매핑할 수 있는 컬럼을 찾지 못했습니다. 수동으로 매핑해주세요.",
        "classNameRequired": "클래스 이름을 입력해주세요.",
        "classesLoadFailed": "클래스 목록을 불러오는데 실패했습니다.",
        "createClassFailed": "클래스 생성에 실패했습니다. 다시 시도해주세요.",
        "inferenceFailed": "스키마 추론에 실패했습니다. 다시 시도해주세요.",
        "layersLoadFailed": "레이어 목록을 불러오는데 실패했습니다.",
        "missingSession": "스테이징 세션이 없습니다.",
        "missingSessionCollectData": "스테이징 세션이 없습니다. 이전 단계에서 데이터를 먼저 수집해주세요.",
        "noLayers": "프로젝트에 레이어가 없습니다. 레이어를 먼저 생성해주세요.",
        "previewFailed": "변환 미리보기에 실패했습니다.",
        "propertyRequired": "최소 하나의 속성을 포함해야 합니다.",
        "rulesRequired": "매핑 규칙을 먼저 설정해주세요.",
        "selectSourceAndTarget": "소스 컬럼과 타겟 속성을 선택해주세요."
      },
      "fields": {
        "caseMode": "변환 방식",
        "className": "클래스 이름",
        "classType": "클래스 타입",
        "defaultValue": "기본값",
        "description": "설명",
        "expression": "계산식",
        "regexPattern": "정규식 패턴",
        "separator": "구분자",
        "sourceColumn": "소스 컬럼",
        "targetClass": "대상 클래스 선택",
        "targetDataType": "타겟 데이터 타입",
        "targetLayer": "타겟 레이어",
        "targetProperty": "타겟 속성",
        "transformType": "변환 타입",
        "useAsKey": "키 속성으로 사용 (인스턴스 식별에 사용)"
      },
      "helpers": {
        "className": "영문 또는 한글로 클래스 이름을 입력하세요. 비워두면 자동 추론합니다.",
        "expression": "컬럼명을 중괄호로 감싸서 사용 (예: {price} * {quantity})",
        "regexPattern": "추출할 패턴을 정규식으로 입력",
        "separator": "여러 컬럼 값을 결합할 때 사용할 구분자"
      },
      "messages": {
        "classCreated": "클래스가 생성되었습니다. 매핑 규칙이 자동으로 설정되었습니다. 다음 단계에서 동기화를 실행할 수 있습니다.",
        "detectedColumns": "감지된 컬럼 ({{count}}개)",
        "inferenceConfidence": "추론 신뢰도: {{confidence}}%",
        "inferencePrompt": "\"AI 스키마 추론\" 버튼을 클릭하면 기존 온톨로지 속성과 자동 매칭하고 클래스 구조를 제안합니다.",
        "mappingRulesCount": "매핑 규칙 ({{count}}개)",
        "noRules": "매핑 규칙이 없습니다. \"자동 매핑\" 버튼을 클릭하거나 직접 규칙을 추가해주세요.",
        "noSchema": "감지된 스키마 정보가 없습니다. 이전 단계에서 데이터를 먼저 수집해주세요.",
        "previewErrors": "{{count}}건의 변환 오류가 발생했습니다.",
        "previewSummary": "성공: {{success}}건 / 실패: {{failed}}건 / 전체: {{total}}건",
        "previewTitle": "변환 미리보기 결과",
        "propertySelection": "속성 목록 ({{included}}/{{total}}개 선택)"
      },
      "placeholders": {
        "className": "예: Equipment, Material, Process",
        "defaultValue": "NULL일 때 사용할 기본값",
        "description": "클래스에 대한 설명을 입력하세요",
        "expression": "예: {price} * {quantity}",
        "regexPattern": "예: (\\\\d{4})-(\\\\d{2})",
        "selectColumn": "컬럼 선택",
        "separator": "예: , 또는 - 또는 빈칸"
      },
      "table": {
        "actions": "작업",
        "columnName": "컬럼명",
        "dataType": "데이터 타입",
        "key": "키",
        "matchInfo": "매칭 정보",
        "propertyLabel": "속성 라벨",
        "required": "필수",
        "sourceColumn": "소스 컬럼",
        "targetProperty": "타겟 속성",
        "transformType": "변환 타입"
      },
      "tabs": {
        "existingClass": "기존 클래스 매핑",
        "newClass": "새 클래스 생성"
      },
      "tooltips": {
        "reuseProperty": "기존 속성 재사용: {{propertyId}}"
      }
    },
    "buttons": {
      "reset": "처음부터",
      "startNew": "새로운 데이터 수집 시작"
    },
    "completion": {
      "message": "{{count}}건의 데이터가 Fuseki에 저장되었습니다.",
      "title": "데이터 동기화 완료!"
    },
    "description": "외부 데이터를 수집하고 온톨로지에 매핑하여 지식 그래프로 변환합니다.",
    "lastStep": "마지막 단계",
    "messages": {
      "projectRequired": "프로젝트를 먼저 선택해주세요."
    },
    "title": "데이터 허브"
  },
  "admin": {
    "shell": {
      "title": "운영자 콘솔",
      "openConsole": "콘솔 열기"
    },
    "sideNav": {
      "heading": "ADMIN",
      "ariaLabel": "관리자 메뉴",
      "readyMadePackAuthoring": "Ready Made Pack 작성"
    },
    "readyMadePackAuthoring": {
      "pageTitle": "Ready Made Pack 작성",
      "pageSubtitle": "운영자가 새 Pack을 작성하고 검증 / dry-run / 게시하는 관리자 콘솔입니다.",
      "newDraft": "새 Pack 만들기",
      "permissionDenied": "Ready Made Pack 작성은 글로벌 관리자만 사용할 수 있습니다.",
      "lifecycle": {
        "draft": "초안",
        "validating": "검증 중",
        "validated": "검증 통과",
        "validation_failed": "검증 실패",
        "dry_running": "Dry-run 실행 중",
        "dry_run_passed": "Dry-run 통과",
        "dry_run_failed": "Dry-run 실패",
        "publish_pending": "게시 대기",
        "published": "게시됨",
        "archived": "보관됨",
        "error": "오류"
      },
      "list": {
        "refresh": "새로고침",
        "blank": "Blank",
        "open": "열기",
        "duplicate": "복제",
        "archive": "보관",
        "archiveConfirm": "이 draft를 보관(archive)하시겠습니까? 보관된 draft는 카탈로그에서 숨겨집니다.",
        "archiveError": "보관 처리에 실패했습니다.",
        "duplicateError": "복제에 실패했습니다.",
        "empty": {
          "title": "아직 작성한 Ready Made Pack이 없습니다",
          "description": "Ready Made Pack은 워크플로 / 온톨로지 / 리포트 / 정책을 한 번에 설치 가능한 번들입니다. 새 Pack을 백지에서 시작하거나 기존 Pack을 fork하여 만들 수 있습니다."
        },
        "columns": {
          "name": "이름",
          "basePack": "소스",
          "state": "상태",
          "updatedAt": "마지막 수정",
          "owner": "소유자",
          "actions": "액션"
        },
        "filters": {
          "state": "상태",
          "stateAll": "전체",
          "ownership": "소유",
          "ownershipAll": "전체",
          "ownershipMine": "내 draft",
          "archived": "보관함",
          "archivedExclude": "보관 제외",
          "archivedInclude": "보관 포함"
        }
      },
      "breadcrumbs": {
        "list": "Ready Made Pack 작성"
      },
      "editor": {
        "untitled": "(이름 없음)",
        "notFound": "Draft 를 찾을 수 없습니다.",
        "forkedFrom": "Fork: {{base}}",
        "publishSuccess": "게시 완료. publishedAt={{ts}}",
        "publishError": "게시에 실패했습니다.",
        "draftIdLabel": "Draft ID: {{id}}"
      },
      "sections": {
        "metadata": "메타데이터",
        "installQuestions": "설치 질문",
        "workflowTemplates": "워크플로우 템플릿",
        "ontologyTemplates": "온톨로지 템플릿",
        "reportTemplates": "리포트 템플릿",
        "sampleData": "샘플 데이터 힌트",
        "policyPresets": "정책 프리셋",
        "aiAssist": "AI 보조"
      },
      "placeholder": {
        "phaseD": {
          "title": "Phase D에서 추가 예정",
          "body": "Unified Designer / Report Builder 컴포넌트의 templateMode 통합 후 활성화됩니다."
        },
        "phaseE": {
          "title": "Phase E에서 추가 예정",
          "body": "AI 보조 기능은 Phase E에서 추가됩니다."
        }
      },
      "workflowTemplates": {
        "sectionTitle": "워크플로우 템플릿",
        "add": "워크플로우 추가",
        "delete": "삭제",
        "unnamed": "(이름 없음)",
        "empty": "아직 워크플로우 템플릿이 없습니다. 우상단 \"워크플로우 추가\" 버튼으로 시작하세요.",
        "modeHint": "Pack 작성 모드: 프로젝트 데이터 연결이 비활성화되어 있습니다. 노드/엣지는 선언형 spec으로만 편집됩니다.",
        "name": "워크플로우 이름",
        "description": "설명",
        "nodes": "노드",
        "addNode": "노드 추가",
        "nodesEmpty": "노드를 추가해 워크플로우 단계를 정의하세요.",
        "nodeId": "노드 ID",
        "nodeType": "단계 종류",
        "nodeLabel": "라벨",
        "edges": "엣지",
        "addEdge": "엣지 추가",
        "edgesEmpty": "엣지를 추가해 노드 간 실행 순서를 정의하세요.",
        "edgeFrom": "From",
        "edgeTo": "To",
        "sandboxAvailable": "샌드박스 활성: 미리보기 가능",
        "sandboxPending": "Dry-run을 먼저 실행해주세요"
      },
      "workflowTrigger": {
        "eventLabel": "트리거 이벤트",
        "event": {
          "manual": "수동 (manual)",
          "schedule": "스케줄 (schedule)",
          "webhook": "웹훅 (webhook)"
        },
        "cronLabel": "Cron 표현식",
        "cronHelper": "예: 매주 평일 오전 9시는 0 9 * * 1-5",
        "webhookPathLabel": "웹훅 경로"
      },
      "ontologyTemplates": {
        "sectionTitle": "온톨로지 템플릿",
        "add": "온톨로지 추가",
        "delete": "삭제",
        "unnamed": "(이름 없음)",
        "empty": "아직 온톨로지 템플릿이 없습니다. 우상단 \"온톨로지 추가\" 버튼으로 시작하세요.",
        "modeHint": "Pack 작성 모드: 프로젝트 데이터 연결이 비활성화되어 있습니다. 클래스/관계는 선언형 spec으로만 편집됩니다.",
        "displayName": "온톨로지 라벨",
        "objectTypes": "오브젝트 타입",
        "addObjectType": "타입 추가",
        "objectTypesEmpty": "오브젝트 타입을 추가해 클래스 구조를 정의하세요.",
        "typeId": "typeId",
        "typeLabel": "라벨",
        "fields": "속성",
        "relationships": "관계",
        "addRelationship": "관계 추가",
        "relationshipsEmpty": "관계를 추가해 클래스 간 연결을 정의하세요.",
        "sandboxAvailable": "샌드박스 활성: 미리보기 가능",
        "sandboxPending": "Dry-run을 먼저 실행해주세요",
        "emptyState": {
          "title": "아직 비즈니스 레코드가 없습니다",
          "body": "두 가지 방법으로 시작할 수 있습니다: 클래스를 직접 정의하거나, 워크플로우의 save step에서 자동으로 파생되도록 두는 것입니다.",
          "addClassCta": "클래스 직접 추가",
          "defaultClassName": "새 비즈니스 레코드",
          "derivationHint": "또는 워크플로우 캔버스 탭에서 save step을 정의하면 비즈니스 레코드가 자동으로 여기에 나타납니다."
        }
      },
      "reportTemplates": {
        "sectionTitle": "리포트 템플릿",
        "add": "리포트 추가",
        "delete": "삭제",
        "unnamed": "(이름 없음)",
        "empty": "아직 리포트 템플릿이 없습니다. 우상단 \"리포트 추가\" 버튼으로 시작하세요.",
        "modeHint": "Pack 작성 모드: 프로젝트 데이터 연결이 비활성화되어 있습니다. 위젯 설정은 선언형 spec으로만 편집됩니다.",
        "title": "리포트 제목",
        "description": "설명",
        "sections": "섹션",
        "addSection": "섹션 추가",
        "sectionsEmpty": "섹션을 추가해 리포트의 위젯을 정의하세요.",
        "sectionId": "섹션 ID",
        "sectionTitle2": "섹션 제목",
        "sectionKind": "섹션 종류",
        "visualizationType": "시각화",
        "staticTextContent": "static_text 내용",
        "previewAvailable": "미리보기 가능 (샌드박스 활성)",
        "previewPending": "미리보기는 Dry-run 후 활성화됩니다"
      },
      "metadata": {
        "sectionTitle": "Pack 메타데이터",
        "id": "Pack ID",
        "idHelp": "kebab-case 권장 (예: finance-cost-variance)",
        "version": "버전",
        "versionHelp": "semver (예: 1.0.0)",
        "category": "카테고리",
        "categoryNone": "선택 안 함",
        "categoryOption": {
          "function": "기능 (function)",
          "industry": "산업 (industry)"
        },
        "estimatedInstallMinutes": "예상 설치 시간 (분)",
        "tags": "태그",
        "tagsHelp": "쉼표로 구분 (예: finance, variance, monthly)",
        "targetAudience": "대상 사용자",
        "targetAudienceHelp": "쉼표로 구분 (예: Finance Controller, Procurement Manager)",
        "i18nTitle": "다국어 (ko / en / ja)",
        "i18nDescription": "카탈로그가 현재 UI 언어를 우선 표시합니다. 비어 있으면 기본 name/description으로 폴백합니다.",
        "locale": {
          "ko": "한국어",
          "en": "English",
          "ja": "日本語"
        },
        "nameLocalized": "이름 ({{locale}})",
        "descriptionLocalized": "설명 ({{locale}})",
        "fallbackTitle": "기본 name / description (back-compat)",
        "fallbackDescription": "다국어 값이 비어 있을 때 사용되는 폴백입니다.",
        "nameFallback": "이름 (fallback)",
        "descriptionFallback": "설명 (fallback)"
      },
      "installQuestions": {
        "sectionTitle": "설치 질문",
        "add": "질문 추가",
        "empty": "아직 설치 질문이 없습니다. Workflow/Ontology 템플릿에서 installAnswer.<id> 토큰을 사용한다면 여기에 정의해야 합니다.",
        "id": "ID",
        "idHelp": "템플릿에서 installAnswer.<id> 로 참조됩니다",
        "kind": "종류 (kind)",
        "kindOption": {
          "string": "문자열",
          "number": "숫자",
          "boolean": "불리언",
          "credential_slot": "자격 증명 슬롯",
          "field_mapping": "필드 매핑"
        },
        "label": "라벨",
        "description": "설명",
        "required": "필수 입력",
        "default": "기본값",
        "moveUp": "위로 이동",
        "moveDown": "아래로 이동",
        "delete": "삭제"
      },
      "sampleData": {
        "sectionTitle": "샘플 데이터 힌트",
        "add": "추가",
        "empty": "아직 샘플 데이터 힌트가 없습니다. Dry-run에서 사용할 픽스처 파일이나 generated fixture를 등록하세요.",
        "id": "ID",
        "label": "라벨",
        "location": "위치 (location)",
        "locationHelp": "파일 경로 또는 generated fixture 이름",
        "description": "설명",
        "delete": "삭제"
      },
      "policyPresets": {
        "sectionTitle": "정책 프리셋",
        "description": "정책 프리셋은 승인 라우팅 룰을 정의합니다. 일반적인 승인 정책은 구조화 뷰를, 고급 편집은 JSON 뷰를 사용하세요.",
        "jsonLabel": "policyPresets JSON",
        "notArrayError": "policyPresets는 배열이어야 합니다.",
        "commit": "정책 적용",
        "viewStructured": "구조화",
        "viewJson": "JSON (고급)",
        "add": "정책 추가",
        "delete": "정책 삭제",
        "empty": "아직 정책 프리셋이 없습니다. \"정책 추가\" 버튼으로 시작하세요.",
        "id": "정책 ID",
        "idHelp": "고정 식별자, 예: policy.cost-variance",
        "name": "이름",
        "descriptionField": "설명",
        "approvalSectionTitle": "승인 정책",
        "approverRole": "승인자 역할",
        "approverRoleHelp": "config.assigneeRole 에 매핑됩니다 — 이 정책에 매칭된 이벤트의 승인을 담당하는 역할입니다.",
        "decisionRulesTitle": "Decision 룰",
        "decisionRulesHelp": "런타임이 평가하는 키-값 임계값입니다 (예: varianceAmountThreshold = 1000000). 중첩 구조나 SPARQL ASK 룰은 JSON 뷰를 사용하세요.",
        "decisionRulesEmpty": "아직 Decision 룰이 없습니다.",
        "addRule": "룰 추가",
        "deleteRule": "룰 삭제",
        "ruleKey": "키",
        "ruleKind": "타입",
        "ruleValue": "값",
        "ruleKindOption": {
          "string": "문자열",
          "number": "숫자",
          "boolean": "불리언"
        }
      },
      "aiPanel": {
        "sectionTitle": "AI 보조",
        "description": "AI가 reference pack / 설치 질문 schema / persona 어휘만 참조하여 초안을 제안합니다. 프로젝트 데이터는 절대 참조하지 않습니다.",
        "taskLabel": "작업 종류",
        "instructionLabel": "AI 지시문",
        "instructionPlaceholder": "예: 월간 비용 변동 워크플로 템플릿 초안 생성",
        "submit": "AI 제안 받기",
        "submitting": "제안 생성 중...",
        "submitDisabledByOperator": "운영자가 AI 보조를 비활성화하여 제안 요청을 보낼 수 없습니다.",
        "proposalTitle": "AI 제안",
        "diffTitle": "변경 사항 (Diff)",
        "warningsTitle": "경고",
        "groundingTitle": "Grounding sources",
        "apply": "초안에 적용",
        "applied": "적용 완료",
        "applyHint": "적용 버튼을 누르기 전까지 draft 는 변경되지 않습니다.",
        "applyDisabledEmpty": "제안된 변경 사항이 없어서 적용할 내용이 없습니다.",
        "errorMissingDraft": "Draft ID 가 없습니다.",
        "errorGeneric": "AI 제안 요청 중 오류가 발생했습니다.",
        "suggestedFix": "제안 수정: {{fix}}",
        "disabledByOperatorTitle": "운영자가 AI 보조를 비활성화했습니다.",
        "disabledByOperatorHint": "서비스 운영자가 PACK_AUTHORING_AI_ENABLED=true 환경 변수를 설정하면 활성화됩니다.",
        "status": {
          "ok": "정상",
          "blocked": "차단됨"
        },
        "tasks": {
          "draft_workflow": "워크플로 초안 생성",
          "draft_ontology": "온톨로지 초안 생성",
          "draft_report": "리포트 초안 생성",
          "suggest_install_questions": "설치 질문 제안",
          "suggest_sample_data_hints": "샘플 데이터 힌트 제안",
          "translate_metadata": "메타데이터 번역",
          "repair_validation_issues": "검증 이슈 복구"
        }
      },
      "actionBar": {
        "title": "라이프사이클",
        "saving": "저장 중...",
        "validate": "검증",
        "dryRun": "Dry-Run",
        "publish": "게시",
        "releaseNote": "릴리스 노트",
        "lastResults": "최근 결과",
        "collapse": "접기",
        "expand": "펼치기",
        "validationLabel": "검증",
        "validationOk": "검증 통과",
        "validationErrorCount": "{{count}}개의 오류",
        "validationWarningCount": "{{count}}개의 경고",
        "dryRunLabel": "Dry-Run",
        "dryRunStatus": {
          "ok": "통과",
          "blocked": "차단됨",
          "needs_approval": "승인 필요",
          "validation_failed": "검증 실패"
        },
        "plannedOperations": "{{count}}개 계획된 작업",
        "noValidationYet": "아직 검증 실행 전",
        "noDryRunYet": "아직 dry-run 실행 전"
      },
      "validation": {
        "code": {
          "pack_authoring.empty_pack_forbidden": "워크플로우 / 온톨로지 / 리포트 템플릿 중 최소 1개를 작성해야 합니다.",
          "pack_authoring.id_collision_disk": "이미 카탈로그에 등록된 디스크 Pack ID와 충돌합니다. 다른 ID를 사용하거나 fork-rename 하세요.",
          "pack_authoring.install_question_missing": "템플릿에서 참조하는 installAnswer 토큰이 설치 질문에 정의되어 있지 않습니다.",
          "pack_authoring.app_service_loop.orphan_workflow_ref": "appServiceLoop.workflowDefinitionKeys가 이 Pack에 정의되지 않은 워크플로우 키를 참조합니다.",
          "pack_authoring.app_service_loop.orphan_report_ref": "appServiceLoop.reportDefinitions가 이 Pack에 정의되지 않은 리포트 키를 참조합니다.",
          "pack_authoring.app_service_loop.orphan_object_type_ref": "appServiceLoop.ontologyObjectTypes가 이 Pack에 정의되지 않은 오브젝트 타입을 참조합니다.",
          "pack_authoring.schema.missing": "필수 항목입니다.",
          "pack_authoring.schema.string_type": "문자열 값이 필요합니다.",
          "pack_authoring.schema.int_parsing": "정수 값이 필요합니다.",
          "pack_authoring.schema.value_error": "값이 올바르지 않습니다.",
          "pack_authoring.schema.literal_error": "허용되지 않는 값입니다.",
          "pack_authoring.schema.enum": "허용된 값 중 하나여야 합니다."
        }
      },
      "dryRun": {
        "warningsHeader": "Dry-run 경고",
        "underlyingCodes": "하위 코드",
        "suggestedFixPrefix": "제안:",
        "code": {
          "pack_authoring.dry_run.template_workflow_failed": "워크플로우 템플릿이 dry-run install 중 검증에 실패했습니다.",
          "pack_authoring.dry_run.template_ontology_failed": "온톨로지 템플릿이 dry-run install 중 검증에 실패했습니다.",
          "pack_authoring.dry_run.template_report_failed": "리포트 템플릿이 dry-run install 중 검증에 실패했습니다.",
          "pack_authoring.dry_run_internal_error": "Dry-run install 실행 중 내부 오류가 발생했습니다. 서버 로그를 확인하세요.",
          "trigger.event_required": "트리거 이벤트를 설정해주세요 (manual / schedule / webhook 중 하나).",
          "trigger.not_object": "trigger는 'event' 문자열을 포함하는 JSON 객체여야 합니다.",
          "steps.empty": "워크플로우에 최소 1개 단계가 필요합니다.",
          "step.id_required": "각 단계에는 비어 있지 않은 'id'가 필요합니다.",
          "step.id_duplicate": "steps[] 안의 단계 id는 고유해야 합니다.",
          "definition.name_required": "워크플로우 이름을 입력해주세요.",
          "definition.not_object": "워크플로우 정의는 JSON 객체여야 합니다."
        }
      },
      "wizard": {
        "title": "새 Ready Made Pack 만들기",
        "modeLabel": "시작 모드",
        "modeBlank": "백지에서 시작 (Blank)",
        "modeFork": "기존 Pack에서 Fork",
        "forkFromLabel": "소스 Pack 선택",
        "forkFromPlaceholder": "— 선택 —",
        "forkFromHelp": "Fork 후 게시할 때는 새 ID 가 필요합니다.",
        "catalogLoading": "카탈로그 불러오는 중...",
        "seedNameLabel": "시드 이름",
        "seedNameHelp": "에디터에서 추후 다국어로 확장할 수 있습니다.",
        "packIdLabel": "Pack ID (선택)",
        "packIdHelp": "kebab-case (예: finance-cost-variance). 비어 있으면 에디터에서 나중에 설정합니다.",
        "kebabError": "소문자/숫자/하이픈만 허용됩니다 (kebab-case)",
        "cancel": "취소",
        "submit": "만들기"
      }
    }
  },
  "objectExplorer": {
    "actionPanel": {
      "contextActions": "컨텍스트 액션",
      "description": "현재 오브젝트 맥락에서 실행 가능한 governed action을 한 곳에서 실행합니다.",
      "empty": "아직 이 오브젝트에 연결된 governed action이 없습니다.",
      "execute": "실행",
      "notReadyForObjectType": "이 오브젝트 타입에서는 현재 실행 대상이 준비되지 않았습니다.",
      "primaryActions": "기본 액션",
      "title": "액션 패널"
    },
    "contract": {
      "availableActions": "사용 가능한 액션:",
      "title": "계약",
      "unavailable": "오브젝트 계약을 사용할 수 없습니다: {{error}}"
    },
    "detail": {
      "actionExecutions": {
        "empty": "아직 실행 이력이 없습니다."
      },
      "actionTooltip": {
        "approvalRequired": "승인 필요",
        "capability": "기능: {{value}}",
        "minimumRole": "최소 역할: {{value}}",
        "reason": "사유: {{value}}",
        "risk": "리스크: {{value}}"
      },
      "actions": {
        "empty": "이 오브젝트에 연결된 액션이 아직 없습니다.",
        "forkSavedWorkbench": "내 workbench로 fork",
        "openMyDivergedForks": "내 diverged forks 보기",
        "openTeamDivergedForks": "Team diverged forks 보기",
        "resetToForkSource": "fork source 기준으로 되돌리기",
        "resetToSourcePreset": "preset 기준으로 되돌리기",
        "restoreLatestRevision": "최신 revision으로 되돌리기"
      },
      "approvalRemediation": {
        "lastFailedWorkflowRun": "마지막 실패 워크플로 실행: {{value}}",
        "resumeOnly": "재개만",
        "retryLastFailedRun": "마지막 실패 실행 재시도",
        "title": "승인 조치"
      },
      "auditTrail": {
        "empty": "아직 연결된 감사 로그가 없습니다."
      },
      "authoring": {
        "blockingSteps": "차단 스텝: {{value}}",
        "title": "작성 준비 상태",
        "unreachableSteps": "도달 불가 스텝: {{value}}",
        "warningSteps": "경고 스텝: {{value}}"
      },
      "availableActions": "사용 가능한 액션",
      "branchTrace": {
        "actualValue": "실제 값: {{value}}",
        "branchKey": "브랜치 키: {{value}}",
        "caseBranchKey": "케이스 브랜치 키: {{value}}",
        "caseMatchMode": "케이스 매치 모드: {{value}}",
        "conditionCountSuffix": " · 조건 {{count}}개",
        "conditionKeys": "조건 키: {{value}}",
        "conditionResult": "조건 {{index}}: {{label}}{{branchKey}} · {{operator}} · 실제 {{actual}} · 매치 {{match}} · {{result}}",
        "matchValue": "매치 값: {{value}}",
        "matched": "매치됨",
        "notMatched": "매치 안 됨",
        "routedAround": "우회됨: {{value}}",
        "selectedCase": "선택된 케이스: {{value}}",
        "title": "브랜치 트레이스"
      },
      "closeObjectView": "오브젝트 뷰 닫기",
      "continueAutomation": "자동화 계속",
      "continueAutomationTitle": "자동화 계속: {{title}}",
      "disabled": "비활성",
      "enabled": "활성",
      "graphReadback": {
        "description": "이 라벨들은 런타임에 생성된 RDF 그래프 리드백 증거를 나타내며, 샘플이나 시드 레코드가 아닙니다.",
        "runtimeCreated": "runtime_created=true",
        "title": "런타임 그래프 리드백 증거"
      },
      "graphRefs": {
        "empty": "연결된 graph reference가 없습니다."
      },
      "linkedObjects": {
        "empty": "아직 연결된 오브젝트가 없습니다."
      },
      "none": "(없음)",
      "notificationTrace": {
        "actionRequiredItem": "조치 필요 항목: {{value}}",
        "emptyOrigins": "연결된 notification origin이 없습니다.",
        "latestNotification": "최신 알림: {{value}}",
        "title": "알림 트레이스"
      },
      "openReport": "리포트 열기",
      "operationalEvents": {
        "empty": "아직 연결된 운영 이벤트가 없습니다."
      },
      "policy": {
        "empty": "저장된 branch policy provenance가 없습니다.",
        "title": "정책 출처"
      },
      "provenance": {
        "captureRuns": "캡처 실행",
        "empty": "이 오브젝트에 기록된 출처 참조가 없습니다.",
        "reportRefs": "리포트 참조",
        "sourceConnectors": "소스 커넥터",
        "sourceRecords": "소스 레코드",
        "sourceWorkflows": "소스 워크플로"
      },
      "resolutionTrace": {
        "actionRequiredItem": "조치 필요 항목: {{value}}",
        "latestActionExecution": "최신 액션 실행: {{value}}",
        "latestAggregateArtifact": "최신 집계 산출물: {{value}}",
        "latestApprovalRequest": "최신 승인 요청: {{value}}",
        "latestAudit": "최신 감사: {{value}}",
        "latestEvent": "최신 이벤트: {{value}}",
        "latestNotification": "최신 알림: {{value}}",
        "latestWorkflowInstance": "최신 워크플로 인스턴스: {{value}}",
        "openLatestActionExecution": "최신 액션 실행 열기",
        "openLatestAggregateArtifact": "최신 집계 산출물 열기",
        "openLatestApprovalRequest": "최신 승인 요청 열기",
        "openLatestGovernanceNotification": "최신 거버넌스 알림 열기",
        "openLatestWorkflowInstance": "최신 워크플로 인스턴스 열기",
        "title": "해소 트레이스"
      },
      "revisionFields": {
        "filters": "필터",
        "forkStatus": "포크 상태",
        "forkedFromViewId": "포크 소스",
        "name": "이름",
        "objectType": "타입",
        "objectTypeLong": "오브젝트 타입",
        "search": "검색",
        "sourceId": "소스",
        "sourceLabel": "소스 라벨"
      },
      "revisionHistory": {
        "changedFromPrevious": "이전 대비 변경: {{value}}",
        "current": "현재",
        "filters": "필터: {{value}}",
        "name": "이름: {{value}}",
        "restoreImpact": "복원 영향: {{value}}",
        "restoreRevision": "revision 복원",
        "search": "검색: {{value}}",
        "title": "저장된 workbench revision 이력",
        "type": "타입: {{value}}"
      },
      "runtimeHealth": {
        "lastFailure": "마지막 실패: {{value}}",
        "lastRun": "마지막 실행: {{value}}",
        "title": "런타임 상태"
      },
      "savedWorkbench": {
        "base": "기본",
        "customized": "커스터마이즈됨",
        "divergedOn": "분기 시점: {{value}}",
        "downstreamForks": "다운스트림 포크: 총 {{total}} · 분기 {{diverged}} · 팀 분기 {{teamDiverged}}",
        "downstreamPreview": "다운스트림 미리보기",
        "filters": "필터: {{value}}",
        "forkToMine": "내 것으로 포크",
        "forkedFrom": "포크 원본: {{value}}",
        "openForkSource": "포크 소스 열기",
        "openRemediationQueue": "조치 큐 열기",
        "openSourceWorkbenchDetail": "소스 workbench 상세 열기",
        "reset": "초기화",
        "restoreImpact": "복원 영향: {{value}}",
        "restoreLatest": "최신 복원",
        "restored": "복원됨",
        "restoredImpact": "복원된 영향: {{value}}",
        "search": "검색: {{value}}",
        "sourcePreset": "소스 preset: {{value}}",
        "title": "저장된 workbench 거버넌스"
      },
      "sections": {
        "auditTrail": "감사 추적",
        "graphReferences": "그래프 참조",
        "linkedObjects": "연결된 오브젝트",
        "metadata": "메타데이터",
        "operationalEvents": "운영 이벤트",
        "recentActionExecutions": "최근 액션 실행",
        "sourceReferences": "소스 참조"
      },
      "template": {
        "defaultRoute": "기본 경로: {{value}}",
        "recommendedFor": "추천 대상: {{value}}",
        "title": "템플릿 거버넌스"
      },
      "triggerHealth": {
        "escalationOnSuppress": "억제 시 에스컬레이션: {{value}}",
        "escalationRequested": "에스컬레이션 요청됨: {{value}}",
        "failurePolicy": "실패 정책: 연속 {{value}}회 실패 후 자동 억제",
        "lastEvent": "마지막 이벤트: {{value}}",
        "lastResumed": "마지막 재개: {{value}}",
        "latestEscalationWorkflow": "최신 에스컬레이션 워크플로: {{value}}",
        "nextRun": "다음 실행: {{value}}",
        "pendingEscalationApproval": "대기 중 에스컬레이션 승인: {{value}}",
        "schedulerMissing": "스케줄러 없음",
        "schedulerRegistered": "스케줄러 등록됨",
        "suppressedAt": "억제 시각: {{value}}",
        "title": "트리거 상태"
      }
    },
    "duplicates": {
      "ariaLabel": "중복 후보",
      "columns": {
        "actions": "작업",
        "conflictingFields": "충돌 필드",
        "identityRule": "식별 룰",
        "score": "점수",
        "targetObject": "대상 Object"
      },
      "currentLineage": "현재 객체 lineage",
      "empty": "현재 식별된 중복 후보가 없습니다.",
      "errors": {
        "load": "duplicate-candidates 조회 실패"
      },
      "lineage": "리니지",
      "merge": "병합",
      "openCandidateLineageTooltip": "후보 객체의 전체 lineage 열기",
      "title": "중복 후보 (Duplicate Candidates)"
    },
    "errors": {
      "unsupportedObjectType": "Object Explorer에서 아직 직접 열 수 없는 오브젝트 타입입니다: {{objectType}}"
    },
    "filters": {
      "clearFilters": "필터 지우기",
      "quickFilters": "빠른 필터",
      "source": "소스",
      "sourceBoth": "둘 다",
      "sourceRdfOnly": "RDF만",
      "sourceSqlOnly": "SQL만"
    },
    "lineage": {
      "empty": "이 오브젝트에는 아직 리니지 엣지가 없습니다.",
      "retry": "재시도"
    },
    "merge": {
      "approvalId": "Approval ID (선택)",
      "approvalNeeded": "이 병합은 approval 이 필요합니다. 발급받은 approval id 를 첨부해 다시 시도하세요.",
      "approvalPlaceholder": "예: APR-2026-1234",
      "candidateObject": "후보 ({{id}})",
      "confirm": "병합 확정",
      "currentObject": "현재 객체 ({{id}})",
      "description": "{{candidateType}} 두 인스턴스를 하나로 합칩니다. 병합 결과는 audit log 에 기록됩니다.",
      "errors": {
        "crossType": "objectType 이 다른 객체끼리는 병합할 수 없습니다. (primary={{primary}}, candidate={{candidate}})",
        "failed": "병합 실패",
        "missingObjectId": "primary / secondary objectId 가 비어있습니다."
      },
      "identityRuleHelper": "후보 매칭에 사용된 룰. 감사 로그에 그대로 기록됩니다.",
      "identityRuleId": "Identity Rule Id",
      "primaryLabel": "Primary (살아남는 ID)",
      "title": "중복 객체 병합"
    },
    "objectView": {
      "currentType": "현재 타입",
      "description": "오브젝트를 선택하면 detail drawer에서 linked context와 governed action panel을 함께 확인할 수 있습니다.",
      "detailLoadFailed": "선택된 오브젝트 상세를 불러오지 못했습니다.",
      "objectCountAndDefaultView": "{{count}} objects · {{defaultViewId}}",
      "reconciliationDefaultReason": "RDF 그래프와 SQL 캐시가 다릅니다.",
      "reconciliationNeeded": "재조정 필요: {{reason}}",
      "selectFromList": "좌측 목록에서 오브젝트를 선택해주세요.",
      "selectedObject": "선택된 오브젝트",
      "title": "오브젝트 뷰"
    },
    "objects": {
      "empty": "표시할 오브젝트가 없습니다."
    },
    "presets": {
      "bootstrapVisible": "부트스트랩 표시",
      "empty": "현재 오브젝트 타입에 노출할 preset이 없습니다.",
      "title": "운영자 preset"
    },
    "readback": {
      "runtimeCreatedGraph": "runtime_created=true (런타임 생성 그래프, 샘플 시드 아님)",
      "source": {
        "mismatch": "불일치",
        "rdf": "정본: RDF graph",
        "sql": "캐시: SQL"
      }
    },
    "savedViews": {
      "activeWorkbench": "활성 workbench",
      "chips": {
        "impactFilters": "impact-filters",
        "impactSearch": "impact-search",
        "restoredImpactFilters": "restored-impact-filters",
        "restoredImpactSearch": "restored-impact-search"
      },
      "clearSourceFilter": "소스 필터 지우기",
      "copyLink": "링크 복사",
      "copyLinkLower": "링크 복사",
      "downstreamForkNotice": "이 source workbench를 기준으로 fork된 downstream view가 있습니다.",
      "empty": "저장된 view가 없습니다.",
      "errors": {
        "clipboardUnavailable": "클립보드 API를 사용할 수 없습니다.",
        "copyLinkFailed": "saved view 링크를 복사하지 못했습니다.",
        "deleteViewFailed": "저장된 Object Explorer view를 삭제하지 못했습니다.",
        "forkDownstreamForkFailed": "downstream fork workbench를 fork하지 못했습니다.",
        "forkSharedViewFailed": "shared saved view를 fork하지 못했습니다.",
        "forkSourceNotFound": "fork source saved view를 찾을 수 없습니다.",
        "loadDownstreamForksFailed": "downstream forked workbench를 불러오지 못했습니다.",
        "loadViewsFailed": "저장된 Object Explorer view를 불러오지 못했습니다.",
        "missingAuditId": "saved workbench 최신 revision 복구에 필요한 auditId가 없습니다.",
        "openDownstreamForkFailed": "downstream fork workbench를 직접 열지 못했습니다.",
        "openForkSourceFailed": "fork source saved view를 열지 못했습니다.",
        "resetDownstreamForkFailed": "downstream fork를 source 기준으로 되돌리지 못했습니다.",
        "resetOnlyMineDownstreamFork": "내 downstream forked workbench만 source 기준으로 되돌릴 수 있습니다.",
        "resetToForkSourceFailed": "fork source 기준으로 saved view를 되돌리지 못했습니다.",
        "resetToPresetFailed": "preset 기준으로 saved view를 되돌리지 못했습니다.",
        "restoreLatestRevisionFailed": "saved workbench 최신 revision 복구에 실패했습니다.",
        "restoreRevisionFailed": "saved workbench revision을 되돌리지 못했습니다.",
        "saveViewFailed": "Object Explorer view를 저장하지 못했습니다.",
        "sourceWorkbenchReadFailed": "source saved workbench 정보를 읽지 못했습니다."
      },
      "fork": "fork",
      "forkedFrom": "포크 원본: {{value}}",
      "messages": {
        "clearedDownstreamForkSourceFilter": "downstream fork source 필터를 해제했습니다.",
        "forkedSharedView": "shared saved view를 내 workbench로 fork했습니다: {{name}}",
        "forkedTeamDownstreamFork": "team downstream fork를 내 workbench로 fork했습니다: {{name}}",
        "linkCopied": "saved view 링크를 복사했습니다.",
        "openedDownstreamFork": "downstream fork workbench를 열었습니다: {{name}}",
        "openedForkSource": "fork source workbench를 열었습니다: {{name}}",
        "resetDownstreamFork": "downstream fork를 source 기준으로 되돌렸습니다: {{name}}",
        "resetToForkSource": "fork source 기준으로 view를 되돌렸습니다: {{name}}",
        "resetToPreset": "preset 기준으로 view를 되돌렸습니다: {{name}}",
        "restoredLatestRevision": "최신 revision 기준으로 되돌렸습니다: {{name}}",
        "restoredRevision": "revision 기준으로 되돌렸습니다: {{name}}",
        "savedViewDeleted": "저장된 view를 삭제했습니다.",
        "savedViewUpdated": "저장된 view 업데이트: {{name}}",
        "showDivergedDownstreamForks": "diverged downstream forked workbench를 표시합니다: {{name}}",
        "showDownstreamForks": "downstream forked workbench를 표시합니다: {{name}}",
        "showMyDivergedDownstreamForks": "내 diverged downstream forked workbench를 표시합니다: {{name}}",
        "showMyDownstreamForks": "내 downstream forked workbench를 표시합니다: {{name}}",
        "showTeamDivergedDownstreamForks": "team diverged downstream forked workbench를 표시합니다: {{name}}",
        "showTeamDownstreamForks": "team downstream forked workbench를 표시합니다: {{name}}"
      },
      "moreDownstreamForks": "외 {{count}}개 downstream fork가 더 있습니다.",
      "namePlaceholder": "현재 view 이름 저장",
      "openSource": "소스 열기",
      "resetToSource": "소스 기준으로 되돌리기",
      "resetToSourceShort": "reset-to-source",
      "showDivergedForks": "분기된 포크 표시",
      "showDownstreamForks": "다운스트림 포크 표시",
      "showMyDivergedForks": "내 분기된 포크 표시",
      "showTeamDivergedForks": "팀 분기된 포크 표시",
      "showTeamForks": "팀 포크 표시",
      "sourceCentricPreview": "소스 중심 조치 미리보기",
      "sourceForksOnly": "소스 포크만",
      "title": "저장된 view"
    },
    "shell": {
      "actionPanelV1": "Action Panel V1",
      "description": "Ontology, data, reports, workflows, calculations를 같은 운영 오브젝트 관점에서 탐색합니다.",
      "objectViewV1": "Object View V1",
      "objects": "오브젝트",
      "title": "Object Explorer"
    },
    "tabs": {
      "ariaLabel": "오브젝트 상세 탭",
      "detail": "상세",
      "lineage": "리니지",
      "timeline": "타임라인"
    },
    "timeline": {
      "actor": "행위자: {{id}} ({{kind}})",
      "empty": "이 오브젝트에 기록된 타임라인 이벤트가 아직 없습니다.",
      "loadMore": "더 불러오기",
      "sourceRefsUnavailable": "소스 참조를 사용할 수 없습니다."
    }
  },
  "objectType": {
    "cloud_service": {
      "label": "클라우드 서비스",
      "description": "IT 비용 관리 분석에 사용되는 합성 클라우드·SaaS 서비스 레코드"
    },
    "cloud_account_project": {
      "label": "클라우드 계정/프로젝트",
      "description": "제공업체와 사업부 소유 정보를 포함한 합성 클라우드 계정·프로젝트 레코드"
    },
    "cloud_environment": {
      "label": "클라우드 환경",
      "description": "클라우드 비용 귀속을 위한 합성 운영·스테이징·샌드박스 환경 레코드"
    },
    "usage_metric": {
      "label": "사용량 지표",
      "description": "서비스, 계정/프로젝트, 환경에 연결된 합성 클라우드 사용량 지표"
    },
    "cloud_invoice_line": {
      "label": "클라우드 인보이스 라인",
      "description": "클라우드 서비스, 계정/프로젝트, 환경, 담당자, 사용량 지표에 연결된 합성 인보이스 라인 비용"
    },
    "cost_owner": {
      "label": "비용 담당자",
      "description": "클라우드·서비스 비용 편차와 알림을 책임지는 합성 담당자 그룹"
    },
    "cloud_budget": {
      "label": "클라우드 예산",
      "description": "담당자, 계정/프로젝트, 서비스, 기간별 합성 예산 기준선"
    },
    "cloud_cost_anomaly": {
      "label": "클라우드 비용 이상",
      "description": "인보이스, 서비스, 계정/프로젝트, 환경, 담당자, 예산 증거를 연결한 탐지된 클라우드·서비스 비용 이상 항목"
    },
    "optimization_action": {
      "label": "최적화 조치",
      "description": "이상, 서비스, 담당자 레코드에 연결된 합성 클라우드 최적화 조치"
    },
    "project_record": {
      "label": "프로젝트 레코드",
      "description": "코드, 이름, 상태, 시작/종료일, 담당 팀을 포함한 프로젝트/PMO 마스터 레코드(프로젝트 비용 초과 팩 등)"
    },
    "project_budget_baseline": {
      "label": "프로젝트 예산 기준선",
      "description": "통화, 승인자, 담당 팀을 포함한 프로젝트/기간별 승인된 프로젝트 예산 기준선"
    },
    "project_actual_cost": {
      "label": "프로젝트 실제 비용",
      "description": "프로젝트, 예산 기준선, 마일스톤, 벤더, 기간, 비용 범주에 연결된 실제 발생 프로젝트 비용"
    },
    "project_cost_overrun_event": {
      "label": "프로젝트 비용 초과 이벤트",
      "description": "예산 대 실제 금액, 예측(EAC), 편차 금액/비율, 초과 플래그를 포함한 탐지된 프로젝트 비용 초과 이벤트"
    },
    "project_milestone": {
      "label": "프로젝트 마일스톤",
      "description": "계획/실제 일자, 상태, 담당 팀을 포함한 프로젝트 마일스톤 정의"
    },
    "project_vendor": {
      "label": "프로젝트 벤더",
      "description": "지역별 프로젝트/PMO 벤더 마스터 레코드(계약자, 컨설팅, 장비 공급업체, IT 서비스, 인력)"
    },
    "project_overrun_cause": {
      "label": "프로젝트 초과 원인",
      "description": "프로젝트 비용 초과 이벤트에 대한 근본 원인 분석 레코드(범위 확대, 벤더 초과, 일정 지연, 변경 지시, 과소 추정, 외부 사건)"
    },
    "project_overrun_review": {
      "label": "프로젝트 초과 검토",
      "description": "프로젝트 비용 초과 이벤트의 편차 금액 또는 비율 위반으로 발생한 PMO/프로젝트 거버넌스 검토 작업"
    },
    "policy": {
      "label": "정책",
      "description": "통제 증거 요건을 정의하는 내부 정책"
    },
    "control": {
      "label": "통제",
      "description": "증거 및 담당자 요건을 포함한 내부 통제"
    },
    "control_owner": {
      "label": "통제 담당자",
      "description": "통제 증거 수집을 책임지는 지정 담당자"
    },
    "evidence_item": {
      "label": "증거 항목",
      "description": "수집된 증거 산출물, 최신성 상태, 출처 참조"
    },
    "evidence_request": {
      "label": "증거 요청",
      "description": "누락되거나 만료된 통제 증거에 대해 담당자에게 보낸 요청"
    },
    "exception": {
      "label": "예외",
      "description": "심각도를 포함한 누락·만료·증거 실패 예외"
    },
    "remediation_task": {
      "label": "시정 작업",
      "description": "증거 또는 통제 시정을 위한 담당자 작업"
    },
    "attestation": {
      "label": "확약",
      "description": "법적 인증 없이 증거 수집 상태를 문서화하는 담당자 확약"
    },
    "purchase_volume": {
      "label": "구매량",
      "description": "Scope 3 추정 맥락에 사용되는 공급업체/자재 구매량 레코드"
    },
    "emission_factor": {
      "label": "배출계수",
      "description": "출처, 단위, 연도, 증거 품질 맥락을 포함한 배출계수 레코드"
    },
    "calculation_method": {
      "label": "산정 방법",
      "description": "공급업체별 또는 추정 방법을 문서화하는 Scope 3 산정 방법 레코드"
    },
    "supplier_submission": {
      "label": "공급업체 제출",
      "description": "기간 및 증거 품질을 포함한 공급업체 제공 Scope 3 제출 레코드"
    },
    "scope3_report_line": {
      "label": "Scope 3 보고 라인",
      "description": "공급업체 제출, 방법, 계수, 신뢰도 상태를 연결한 보고 라인 증거 레코드"
    },
    "assurance_evidence": {
      "label": "검증 증거",
      "description": "Scope 3 보고 라인 검토 및 신뢰도 상태를 뒷받침하는 증거 산출물"
    },
    "review_task": {
      "label": "검토 작업",
      "description": "신뢰도가 낮거나 불완전한 보고 라인에 대한 지속가능성 검증 검토 작업"
    },
    "layer": {
      "label": "레이어",
      "description": "네임드 그래프 레이어 인스턴스 및 차원 슬라이스"
    },
    "instance": {
      "label": "인스턴스",
      "description": "업로드된 키로 뒷받침되는 등록된 온톨로지 인스턴스"
    },
    "data_source": {
      "label": "데이터 소스",
      "description": "저장된 인스턴스 및 관계 소스 정의"
    },
    "cost_calculation": {
      "label": "비용 계산",
      "description": "저장된 비용 계산 이력 실행"
    },
    "cost_allocation": {
      "label": "비용 배분",
      "description": "공정/단계/장비/자재를 연결하는 단계별 비용 배분(반도체 팩 등)"
    },
    "process": {
      "label": "공정",
      "description": "제조 공정 정의(반도체 팩 등)"
    },
    "step": {
      "label": "공정 단계",
      "description": "자재/장비/수율 바인딩을 포함한 공정별 단계 정의"
    },
    "material": {
      "label": "자재",
      "description": "공정 단계에서 소비되는 원자재 및 소모품"
    },
    "equipment": {
      "label": "장비",
      "description": "공정 단계에서 사용되는 생산 장비/도구"
    },
    "yield_metric": {
      "label": "수율 지표",
      "description": "단계별 수율 관측 및 품질 지표"
    },
    "CardTransaction": {
      "label": "카드 거래",
      "description": "발급사 CSV 피드의 법인카드 결제 이벤트로, 승인·영수증·정책 증거를 검토함"
    },
    "Receipt": {
      "label": "영수증",
      "description": "법인카드 거래에 연결된 증빙 영수증 이미지의 OCR 결과"
    },
    "Employee": {
      "label": "직원",
      "description": "법인카드 거래 및 승인 케이스에서 참조하는 카드 소지자 또는 승인자 신원"
    },
    "Vendor": {
      "label": "벤더",
      "description": "법인카드 거래 전반에서 중복 제거된 가맹점 신원"
    },
    "BudgetCategory": {
      "label": "예산 범주",
      "description": "월별 한도 및 임원 에스컬레이션 플래그를 포함한 법인카드 예산 분류"
    },
    "ApprovalCase": {
      "label": "승인 케이스",
      "description": "검토가 필요한 법인카드 거래에 대한 승인 결정 산출물"
    },
    "customer": {
      "label": "고객",
      "description": "서비스 에스컬레이션 및 엔타이틀먼트 검토에 사용되는 고객 마스터 레코드"
    },
    "contract": {
      "label": "계약",
      "description": "서비스 수준 및 엔타이틀먼트 맥락을 정의하는 고객 계약 레코드"
    },
    "entitlement": {
      "label": "엔타이틀먼트",
      "description": "계약에 따른 서비스 수준 엔타이틀먼트, 응답 시간, 구제 한도"
    },
    "support_case": {
      "label": "지원 케이스",
      "description": "SLA, 엔타이틀먼트, 구제 검토가 필요한 고객 서비스 케이스"
    },
    "order": {
      "label": "주문",
      "description": "지원 케이스 및 배송 증거에 연결된 고객 주문 레코드"
    },
    "shipment": {
      "label": "배송",
      "description": "고객 주문 및 에스컬레이션 증거에 연결된 출고 배송 레코드"
    },
    "product_issue": {
      "label": "제품 이슈",
      "description": "고객 지원 케이스에 첨부된 제품 결함 또는 이슈 레코드"
    },
    "service_policy": {
      "label": "서비스 정책",
      "description": "에스컬레이션 및 구제 승인을 관장하는 내부 서비스 정책"
    },
    "remediation_option": {
      "label": "구제 옵션",
      "description": "실행 전 승인이 필요할 수 있는 제안된 고객 구제 조치"
    },
    "escalation_approval": {
      "label": "에스컬레이션 승인",
      "description": "고객 서비스 구제 또는 운영 조치 제안에 대한 승인 레코드"
    },
    "root_cause_task": {
      "label": "근본 원인 작업",
      "description": "지원 에스컬레이션에서 근본 원인 검토까지 루프를 닫는 후속 작업"
    },
    "distribution_channel": {
      "label": "유통 채널",
      "description": "지역별 유통 채널 마스터 레코드(소매/도매/이커머스/마켓플레이스)(유통 마진/반품 팩 등)"
    },
    "distribution_order": {
      "label": "유통 주문",
      "description": "SKU, 기간, 수량, 매출, 주문 상태를 포함한 채널별 유통 주문 항목"
    },
    "distribution_sku": {
      "label": "유통 SKU",
      "description": "제품 코드, 라인, 단위 원가, 정가를 포함한 유통 SKU 마스터 레코드"
    },
    "return_event": {
      "label": "반품 이벤트",
      "description": "사유, 반품 수량, 총/순 마진, 반품 비용, 물류 비용을 포함한 유통 주문의 탐지된 반품 이벤트"
    },
    "distribution_margin_snapshot": {
      "label": "유통 마진 스냅샷",
      "description": "총/순 마진 및 마진 변화량을 포함해 반품 이벤트에 연결된 마진 스냅샷 항목"
    },
    "reverse_logistics_cost": {
      "label": "역물류 비용",
      "description": "반품 이벤트에 연결된 역물류 비용 항목(운송사 수거, 재입고 처리, 재정비, 폐기)"
    },
    "margin_returns_review": {
      "label": "마진/반품 검토",
      "description": "반품 이벤트의 순 마진 또는 반품 비용 위반으로 발생한 유통 거버넌스 검토 작업"
    },
    "distribution_customer": {
      "label": "유통 고객",
      "description": "세그먼트, 지역, 계정별로 유통 마진 누수를 귀속하는 데 사용되는 고객 계정 레코드"
    },
    "distribution_shipment": {
      "label": "유통 배송",
      "description": "주문, 고객, 운송사, 서비스 수준, 실제 물류 비용을 연결한 배송 레코드"
    },
    "freight_charge": {
      "label": "운송 요금",
      "description": "계약, 청구, 허용 유통 비용을 비교하는 데 사용되는 운송 요금 항목"
    },
    "distribution_allowance": {
      "label": "유통 공제",
      "description": "실현 유통 마진에 영향을 주는 고객, 채널 또는 배송 공제"
    },
    "margin_leakage_reason": {
      "label": "마진 누수 사유",
      "description": "유통 마진 누수의 운송, 공제, 배송 또는 가격 원인을 설명하는 사유 코드 레코드"
    },
    "margin_leakage_event": {
      "label": "마진 누수 이벤트",
      "description": "고객, 배송, 운송, 공제, 사유, 검토 상태를 연결한 탐지된 유통 마진 누수 이벤트"
    },
    "margin_leakage_review": {
      "label": "마진 누수 검토",
      "description": "중대한 마진 누수 이벤트로 발생한 유통 거버넌스 검토 작업"
    },
    "service_request": {
      "label": "서비스 요청",
      "description": "범주, 기간, 상태, 우선순위를 포함해 총무/공유 서비스에 제출된 부서 서비스 요청(총무/서비스 비용 팩 등)"
    },
    "service_cost_event": {
      "label": "서비스 비용 이벤트",
      "description": "벤더, 계약, 시설 자산, 부서, 기준 대 실제 비용, 편차 금액을 포함한 서비스 요청의 탐지된 서비스 비용 이벤트"
    },
    "service_vendor": {
      "label": "서비스 벤더",
      "description": "총무/공유 서비스 벤더 마스터 레코드(시설 유지보수, 청소, IT 서비스, 소모품, 급식)"
    },
    "service_contract": {
      "label": "서비스 계약",
      "description": "연간 한도 및 기간을 포함한 벤더 서비스 계약 마스터 레코드(연간 유지보수/종량제/포괄/SLA)"
    },
    "facility_asset": {
      "label": "시설 자산",
      "description": "위치 및 소유 부서를 포함한 시설 자산 마스터 레코드(공조/조명/엘리베이터/프린터/차량/사무 가구)"
    },
    "department_cost_center": {
      "label": "부서 코스트 센터",
      "description": "코스트 센터 코드, 이름, 담당 팀, 인원을 포함한 부서 코스트 센터 마스터 레코드"
    },
    "service_cost_review": {
      "label": "서비스 비용 검토",
      "description": "서비스 비용 이벤트의 서비스 비용 편차 위반으로 발생한 총무 거버넌스 검토 작업"
    },
    "ga_department": {
      "label": "총무 부서",
      "description": "총무 지출 관리 보고에 사용되는 부서 및 코스트 센터 레코드"
    },
    "ga_vendor": {
      "label": "총무 벤더",
      "description": "총무 지출 관리를 위한 우선 벤더 상태를 포함한 벤더 마스터 레코드"
    },
    "ga_service_category": {
      "label": "총무 서비스 범주",
      "description": "지출 요청, 인보이스, 예산, 편차를 분류하는 데 사용되는 서비스 범주 레코드"
    },
    "spend_request": {
      "label": "지출 요청",
      "description": "부서, 벤더, 범주, 기간, 요청 금액에 연결된 총무 지출 요청"
    },
    "supplier_invoice": {
      "label": "공급업체 인보이스",
      "description": "지출 요청, 벤더, 부서, 서비스 범주와 매칭된 공급업체 인보이스"
    },
    "department_budget": {
      "label": "부서 예산",
      "description": "예산 및 약정 금액을 포함한 부서 및 서비스 범주 예산 레코드"
    },
    "spend_approval": {
      "label": "지출 승인",
      "description": "예산 초과 또는 비우선 벤더 총무 지출에 대한 승인 결과"
    },
    "spend_variance": {
      "label": "지출 편차",
      "description": "부서, 벤더, 범주, 요청, 인보이스, 예산, 승인, 정책 결과를 연결한 총무 지출 편차 이벤트"
    },
    "common_cost_allocation": {
      "label": "공통 비용 배분",
      "description": "부서, 벤더, 범주, 배분 풀, 인보이스, 기준, 승인, 편차 결과를 연결한 공유 서비스 공통 비용 배분 이벤트"
    },
    "production_line": {
      "label": "생산 라인",
      "description": "제조 생산 라인 마스터 레코드(생산 수율/손실 팩 등)"
    },
    "production_batch": {
      "label": "생산 배치",
      "description": "계획 대 생산 수량을 포함한 라인별 생산 배치 실행"
    },
    "yield_loss_event": {
      "label": "수율 손실 이벤트",
      "description": "심각도, 손실 수량, 폐기 비용을 포함한 생산 배치의 탐지된 수율/손실 이벤트"
    },
    "scrap_cost": {
      "label": "폐기 비용",
      "description": "수율 손실 이벤트 및 생산 배치에 연결된 폐기/재작업 비용 항목"
    },
    "yield_loss_review": {
      "label": "수율 손실 검토",
      "description": "수율 손실 이벤트 심각도 위반으로 발생한 생산 거버넌스 검토 작업"
    },
    "quality_inspection_lot": {
      "label": "품질 검사 로트",
      "description": "생산 실행에서 샘플링된 검사 로트 마스터 레코드(품질 실패 비용 팩 등)"
    },
    "quality_defect_event": {
      "label": "품질 결함 이벤트",
      "description": "심각도, 결함 수량, 실패 비용을 포함한 검사 로트의 탐지된 품질 결함 이벤트"
    },
    "quality_failure_cost": {
      "label": "품질 실패 비용",
      "description": "품질 결함 이벤트 및 검사 로트에 연결된 실패 비용 항목(재작업, 폐기, 보증, 고객 클레임)"
    },
    "corrective_action": {
      "label": "시정 조치",
      "description": "담당 팀 및 기한을 포함해 품질 결함 이벤트에 연결된 시정 및 예방 조치 작업"
    },
    "quality_claim": {
      "label": "품질 클레임",
      "description": "품질 결함 이벤트에 연결된 고객/내부/규제기관 품질 클레임"
    },
    "quality_review": {
      "label": "품질 검토",
      "description": "결함 심각도 또는 실패 비용 위반으로 발생한 품질 엔지니어링 거버넌스 검토 작업"
    },
    "nonconformance": {
      "label": "부적합",
      "description": "유형, 심각도, 담당 팀을 포함해 품질 결함 이벤트에서 생성된 부적합 레코드"
    },
    "containment_action": {
      "label": "격리 조치",
      "description": "품질 결함 이벤트 및 해당 부적합에 연결된 즉시 격리 조치 작업"
    },
    "action_execution": {
      "label": "액션 실행",
      "description": "거버넌스된 액션 실행, 재시도, 결과 출처"
    },
    "aggregate_artifact": {
      "label": "집계 산출물",
      "description": "출처를 포함한 생성된 브리핑 및 집계 출력"
    },
    "named_graph": {
      "label": "네임드 그래프",
      "description": "계보를 포함한 구체화된 작업·파생·집계 그래프 출력"
    },
    "saved_view_workbench": {
      "label": "저장된 워크벤치",
      "description": "프리셋, 포크, 다운스트림 거버넌스 계보를 포함한 저장된 오브젝트 익스플로러 워크벤치"
    },
    "operator_notification": {
      "label": "운영자 알림",
      "description": "확인 상태를 포함한 운영자에게 표시되는 영구 알림"
    },
    "report": {
      "label": "리포트",
      "description": "Auto Insight 리포트 및 리포트 빌더 산출물"
    },
    "workflow_definition": {
      "label": "워크플로 정의",
      "description": "트리거 및 실행 정책을 포함한 재사용 가능한 운영 워크플로 템플릿"
    },
    "branch_policy_template": {
      "label": "분기 정책 템플릿",
      "description": "재사용 가능한 의사결정 정책 템플릿 및 프로젝트 수준 워크플로 사용"
    },
    "workflow_trigger": {
      "label": "워크플로 트리거",
      "description": "워크플로 정의에 연결된 스케줄 및 웹훅 트리거 엔드포인트"
    },
    "approval_request": {
      "label": "승인 요청",
      "description": "대기 중 및 결정된 운영 승인 작업"
    },
    "workflow_instance": {
      "label": "워크플로 인스턴스",
      "description": "운영 워크플로 실행 및 승인 오케스트레이션"
    },
    "sales_customer": {
      "label": "영업 고객",
      "description": "할인 누수 분석에 사용되는 영업 운영 고객 계정 레코드"
    },
    "sales_product": {
      "label": "영업 제품",
      "description": "할인 분석을 위한 제품 패밀리 및 정가 맥락을 포함한 판매 가능 제품 레코드"
    },
    "salesperson": {
      "label": "영업 담당자",
      "description": "기회 및 주문 할인 누수를 귀속하는 데 사용되는 영업 담당자 레코드"
    },
    "sales_opportunity": {
      "label": "영업 기회",
      "description": "고객, 제품, 영업 담당자, 정가, 계약가, 할인, 승인 상태를 포함한 기회 레코드"
    },
    "sales_order": {
      "label": "영업 주문",
      "description": "계약가, 할인 금액, 주문 상태를 포함해 기회에 연결된 주문 레코드"
    },
    "discount_threshold": {
      "label": "할인 임계값",
      "description": "영업 할인 누수 라우팅을 위한 세그먼트 및 제품 패밀리별 승인 임계값 레코드"
    },
    "discount_approval": {
      "label": "할인 승인",
      "description": "설정된 임계값을 초과한 영업 할인에 대한 승인 결과"
    },
    "discount_leakage_reason": {
      "label": "할인 누수 사유",
      "description": "할인 편차 또는 승인 격차가 발생한 이유를 설명하는 사유 코드 레코드"
    },
    "discount_leakage_event": {
      "label": "할인 누수 이벤트",
      "description": "영업 담당자, 고객, 제품, 기회, 주문, 임계값, 승인, 사유를 연결한 탐지된 영업 할인 누수 이벤트"
    },
    "supplier": {
      "label": "공급업체",
      "description": "벤더/공급업체 마스터 레코드(조달 팩 등)"
    },
    "component": {
      "label": "부품",
      "description": "완제품에 소비되는 구매 부품"
    },
    "inbound_shipment": {
      "label": "입고 배송",
      "description": "발주 및 예상 입고에 연결된 공급업체 배송"
    },
    "plant": {
      "label": "공장",
      "description": "재고 버퍼를 포함한 제조 또는 물류 공장"
    },
    "finished_product": {
      "label": "완제품",
      "description": "공급된 부품으로 제조된 판매 가능 제품"
    },
    "customer_order": {
      "label": "고객 주문",
      "description": "공급 및 재고 충격에 노출된 고객 수요 레코드"
    },
    "inventory_buffer": {
      "label": "재고 버퍼",
      "description": "공장 및 부품별 보유 재고, 안전 재고, 버퍼 일수 레코드"
    },
    "revenue_exposure": {
      "label": "매출 노출",
      "description": "고객 주문, 부품, 공장에 연결된 위험 노출 매출"
    },
    "mitigation_option": {
      "label": "완화 옵션",
      "description": "충격 대응을 위한 긴급 조달, 대체 소싱, 대체품, 할당 옵션"
    },
    "shock_approval": {
      "label": "충격 승인",
      "description": "공급업체 충격 완화에 대한 조달 및 재무 승인"
    },
    "supplier_price_quote": {
      "label": "공급업체 견적가",
      "description": "기준 대비 편차를 포함한 (공급업체, 자재, 기간)별 견적 단가"
    },
    "purchase_order": {
      "label": "발주서",
      "description": "공급업체 견적 및 자재에 연결된 발행 발주서"
    },
    "price_variance_review": {
      "label": "가격 편차 검토",
      "description": "견적 편차 위반으로 발생한 조달 거버넌스 검토 작업"
    },
    "item": {
      "label": "조달 품목",
      "description": "기준 단가를 포함해 공급업체가 견적한 구매 품목 마스터 레코드(조달 가격 편차 팩)"
    },
    "hr_department": {
      "label": "인사 부서",
      "description": "인력 비용 계획에 사용되는 합성 부서 계획 단위"
    },
    "workforce_role": {
      "label": "인력 직무",
      "description": "부서 및 급여 밴드 맥락을 포함한 합성 인력 직무 정의"
    },
    "salary_band": {
      "label": "급여 밴드",
      "description": "인력 비용 계획을 위한 합성 급여 밴드 가정"
    },
    "benefits_load": {
      "label": "복리후생 부담",
      "description": "부서 또는 직무 패밀리별 복리후생 부담 가정"
    },
    "headcount_plan": {
      "label": "인원 계획",
      "description": "부서, 직무, 기간별 계획 인원 및 비용 기준선"
    },
    "hiring_plan": {
      "label": "채용 계획",
      "description": "부서 및 직무별 합성 계획 채용 및 입사월 가정"
    },
    "attrition_assumption": {
      "label": "이직 가정",
      "description": "부서 및 직무별 합성 이직 가정"
    },
    "workforce_cost_forecast": {
      "label": "인력 비용 예측",
      "description": "급여, 복리후생, 채용, 이직, 편차 필드를 포함한 부서 및 직무별 예측 인력 비용"
    },
    "workforce_variance_event": {
      "label": "인력 편차 이벤트",
      "description": "예측 항목을 부서, 직무, 급여 밴드, 복리후생 부담, 인원, 채용, 이직 가정에 연결한 탐지된 인력 비용 편차 이벤트"
    }
  },
  "dataBackfill": {
    "title": "백필 실행",
    "description": "데이터 소스의 과거 윈도우를 재동기화합니다. 실행 결과는 아래 동기화 이력과 리니지에 기록됩니다.",
    "sourceLabel": "데이터 소스",
    "open": "백필 실행…",
    "empty": "백필할 데이터 소스가 없습니다. Designer > Connect > Data Sources 에서 데이터 소스를 먼저 등록하세요.",
    "historyTitle": "동기화·백필 이력",
    "errors": {
      "loadSources": "데이터 소스 목록을 불러오지 못했습니다.",
      "execute": "백필 실행에 실패했습니다."
    }
  },
  "allProjects": {
    "shared": "공유받은 프로젝트",
    "sharedHint": "멤버로 초대된 프로젝트"
  },
  "useCases": {
    "emptyTitle": "아직 게시된 Use Case 가 없습니다",
    "empty": "운영자가 Use Case 를 게시하면 여기에 표시됩니다. 그동안 AI Build 로 나만의 워크플로를 설계하거나, Ready Made Pack 으로 완성된 업무 자동화를 바로 설치할 수 있습니다.",
    "emptyAiBuildCta": "AI Build 로 시작",
    "emptyPacksCta": "Ready Made Packs 보기",
    "title": "Use Cases",
    "subtitle": "먼저 사례를 보고, 마음에 들면 내 프로젝트로 설치합니다.",
    "tier": {
      "starter": "입문",
      "standard": "표준",
      "advanced": "심화"
    },
    "badges": {
      "subscribed": "신청됨",
      "orgScope": "조직 구독"
    },
    "actions": {
      "install": "내 프로젝트로 설치",
      "open": "사례 열기",
      "subscribe": "신청",
      "subscribing": "신청 중...",
      "unsubscribe": "신청 취소",
      "watchVideo": "데모 영상 보기"
    }
  },
  "connections": {
    "title": "커넥션",
    "subtitle": "워크플로가 사용하는 모든 외부 연결 — 데이터베이스, SaaS API, 파일 저장소, RPA 봇 — 을 한 곳에서 관리하는 통합 레지스트리입니다. Designer → Connect 의 기존 5개 메뉴를 대체합니다.",
    "refresh": "새로고침",
    "add": "커넥션 추가",
    "retry": "다시 시도",
    "selectProject": "등록된 커넥션을 보려면 프로젝트를 선택하세요.",
    "loadError": "등록된 커넥션 목록을 불러오지 못했습니다.",
    "testFailed": "테스트에 실패했습니다.",
    "renamed": "\"{{name}}\" (으)로 이름을 변경했습니다.",
    "renameFailed": "이름 변경에 실패했습니다.",
    "deleted": "\"{{name}}\" 을(를) 삭제했습니다.",
    "deleteFailed": "삭제에 실패했습니다.",
    "saved": "커넥션이 저장되었습니다.",
    "totalCount": "총 {{count}}건",
    "emptyTitle": "아직 등록된 커넥션이 없습니다",
    "emptyBody": "첫 데이터 소스를 연결해 보세요 — SQL 데이터베이스, 웨어하우스, SaaS API, RPA 오케스트레이터를 아우르는 {{count}}종의 통합을 지원합니다. 등록된 커넥션은 워크플로 source step 에서 고정 connectionId 로 참조됩니다.",
    "emptyCta": "첫 커넥션 추가",
    "otherSection": "기타 / 알 수 없는 타입 ({{count}})",
    "renameTitle": "커넥션 이름 변경",
    "renameBody": "\"{{name}}\" 의 표시 이름을 변경합니다. 타입과 자격증명은 그대로 유지됩니다 — secret 변경은 재인증을 사용하세요.",
    "displayName": "표시 이름",
    "cancel": "취소",
    "save": "저장",
    "saving": "저장 중…",
    "deleteTitle": "커넥션을 삭제할까요?",
    "deleteBody": "\"{{name}}\" 과(와) 저장된 자격증명이 영구 삭제됩니다. 이 커넥션을 참조 중인 워크플로는 재지정하기 전까지 실행 시 실패합니다.",
    "delete": "삭제",
    "deleting": "삭제 중…",
    "status": {
      "connected": "연결됨",
      "configured": "설정됨",
      "needsAuth": "인증 필요",
      "expired": "만료됨",
      "error": "오류"
    },
    "card": {
      "testTooltip": "연결 테스트",
      "usageTooltip": "워크플로 사용처 보기",
      "editTooltip": "편집 (이름/범위)",
      "deleteTooltip": "커넥션 삭제",
      "deleteUnavailable": "삭제 불가",
      "secret": "secret: {{names}}",
      "secretNotConfigured": "secret: 미설정",
      "lastTested": "마지막 테스트: {{value}}",
      "never": "없음",
      "errorPrefix": "오류: {{message}}"
    },
    "form": {
      "title": "새 {{label}} 커넥션",
      "close": "닫기",
      "displayNameHelper": "워크플로 source 선택기에 표시되는 사람이 읽는 이름",
      "scope": "범위",
      "scopeHelperFallback": "이 커넥션의 공개 범위",
      "scopeProject": "프로젝트",
      "scopeProjectHelper": "이 프로젝트의 멤버에게만 표시",
      "scopeOrg": "조직",
      "scopeOrgHelper": "조직의 모든 프로젝트에서 공유",
      "scopeUser": "사용자",
      "scopeUserHelper": "개인용 — 생성자만 사용 가능",
      "authSection": "인증",
      "manualConfigSection": "수동 설정",
      "configSection": "설정",
      "oauthButton": "{{provider}} 로 인증",
      "oauthDisplayNameRequired": "OAuth 를 시작하기 전에 표시 이름을 입력하세요.",
      "oauthFailed": "OAuth 인증에 실패했습니다.",
      "oauthStartFailed": "OAuth 흐름을 시작하지 못했습니다.",
      "oauthFallback": "{{provider}} OAuth 가 아직 운영자에 의해 설정되지 않았습니다. 아래에 액세스 토큰을 직접 붙여넣어 계속하세요.",
      "authTypeTooltip": "이 커넥션에 기록되는 인증 방식 (참고용; 실제 저장 형태는 커넥터 어댑터에 따릅니다)",
      "authType": "인증 방식:",
      "saveFailed": "커넥션 저장에 실패했습니다.",
      "savedButTestFailed": "커넥션은 저장되었지만 테스트에 실패했습니다: {{message}}",
      "saveOnly": "저장만",
      "saveAndTest": "저장 후 테스트",
      "retryTest": "테스트 재시도"
    },
    "picker": {
      "title": "커넥터 타입 선택",
      "subtitle": "지원되는 {{count}}종의 통합을 카테고리별로 보여줍니다. 카드를 선택해 자격증명과 범위를 설정하세요.",
      "searchPlaceholder": "커넥터 검색 (예: postgres, slack, OAuth)",
      "noMatch": "\"{{term}}\" 과(와) 일치하는 커넥터가 없습니다. 더 넓은 검색어를 사용해 보세요."
    }
  },
  "approvalInbox": {
    "title": "승인 대기함",
    "refresh": "새로고침",
    "emailRequired": "승인 대기함을 보려면 로그인해야 합니다.",
    "empty": "지금 처리할 승인 요청이 없습니다.",
    "col": {
      "workflow": "워크플로 실행",
      "step": "단계",
      "assignee": "담당자",
      "message": "요청 내용",
      "payload": "요청 데이터",
      "timeout": "남은 기한",
      "action": "결정"
    },
    "commentPlaceholder": "의견 (선택)",
    "approve": "승인",
    "reject": "반려",
    "expired": "기한 지남",
    "onTimeout": "기한이 지나면: {{action}}",
    "row": {
      "unitBadge": "행별 결정",
      "progress": "{{decided}}/{{total}}행 결정",
      "approvedCount": "승인 {{rows}}행",
      "rejectedCount": "반려 {{rows}}행",
      "approveSelected": "선택 승인 ({{rows}})",
      "rejectSelected": "선택 반려 ({{rows}})",
      "approveAll": "남은 전체 승인 ({{rows}})",
      "rejectAll": "남은 전체 반려 ({{rows}})",
      "hint": "행마다 승인/반려를 내립니다. 모든 행을 결정하면 워크플로가 이어서 실행되고, 승인한 행만 다음 단계로 넘어갑니다.",
      "col": {
        "row": "대상",
        "evidence": "AI 검토 근거",
        "decision": "결정"
      },
      "draftUnavailable": "AI 초안 없음 ({{reason}})",
      "draftPerRow": "이 행만 검토",
      "confidence": "신뢰도 {{percent}}%",
      "recommendation": "권고",
      "noRowEvidence": "이 행을 짚은 발견 사항 없음",
      "approved": "승인함",
      "rejected": "반려함"
    }
  }
}
